import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AddClusterToStudentsInput = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  courseIds: Array<Scalars['String']['input']>;
  studentIds: Array<Scalars['String']['input']>;
};

export type Admin = {
  __typename?: 'Admin';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<Permissions>;
};

export type AllQuestionsCount = {
  __typename?: 'AllQuestionsCount';
  count: Scalars['Float']['output'];
  difficulty?: Maybe<Scalars['String']['output']>;
};

export type Approval = {
  __typename?: 'Approval';
  _id: Scalars['ID']['output'];
  approvedBy?: Maybe<Scalars['String']['output']>;
  deleteResult?: Maybe<BulkDeleteStudentsResponse>;
  id: Scalars['String']['output'];
  payload: Scalars['JSON']['output'];
  reasonForDeletion: Scalars['String']['output'];
  requestedAt: Scalars['DateTime']['output'];
  requestedBy: Scalars['String']['output'];
  statusOfApproval: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  typeOfDeletion: Scalars['String']['output'];
};

export type Assignment = {
  __typename?: 'Assignment';
  _id: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  enable_proctoring?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  languages: Array<Scalars['String']['output']>;
  max_cheat_count?: Maybe<Scalars['Float']['output']>;
  max_tabSwitches?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  short_description?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AssignmentCompletionStatus = {
  __typename?: 'AssignmentCompletionStatus';
  Status?: Maybe<Scalars['Boolean']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  revokedCount?: Maybe<Scalars['Float']['output']>;
};

export type AssignmentFilterInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type AssignmentInput = {
  assignment_id: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
  cheat_count: Scalars['Float']['input'];
  cheat_reasons: Scalars['String']['input'];
  cluster_id: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
  tabSwitches: Scalars['Float']['input'];
};

export type AssignmentLeaderBoard = {
  __typename?: 'AssignmentLeaderBoard';
  assignment_id: Scalars['String']['output'];
  cheat_reasons?: Maybe<Scalars['String']['output']>;
  clusterNames: Scalars['String']['output'];
  position: Scalars['Float']['output'];
  questions?: Maybe<Array<QuestionLeaderboard>>;
  student?: Maybe<Student>;
  totalNumberOfQuestion: Scalars['Float']['output'];
  totalScore: Scalars['Float']['output'];
};

export type AssignmentMailResponse = {
  __typename?: 'AssignmentMailResponse';
  mailId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  recipientEmails?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  totalRecipients?: Maybe<Scalars['Float']['output']>;
};

export type AssignmentQuestion = {
  __typename?: 'AssignmentQuestion';
  _id: Scalars['String']['output'];
  assignment_id: Scalars['String']['output'];
  company_tags: Array<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['String']['output'];
  difficulty: Scalars['String']['output'];
  hints: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  marks: Scalars['String']['output'];
  predefinedCode?: Maybe<PredefinedLanguages>;
  question_sub_text?: Maybe<Scalars['String']['output']>;
  showFunctionOnly?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Scalars['String']['output']>;
  targetFunctionName?: Maybe<Scalars['String']['output']>;
  test_cases: Array<TestCase>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by: Scalars['String']['output'];
};

export type AssignmentResults = {
  __typename?: 'AssignmentResults';
  assignment_id?: Maybe<Scalars['String']['output']>;
  cheat_reasons?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<QuestionResult>>;
  student_id?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
};

export type AssignmentStatusResult = {
  __typename?: 'AssignmentStatusResult';
  completedAssignments: Array<CompletedAssignment>;
  pendingAssignments: Array<CompletedAssignment>;
};

export type AssignmentSubmit = {
  __typename?: 'AssignmentSubmit';
  assignment_id?: Maybe<Scalars['String']['output']>;
  autosave?: Maybe<Array<QuestionSubmission>>;
  cheat_count?: Maybe<Scalars['Float']['output']>;
  cheat_reasons?: Maybe<Scalars['String']['output']>;
  cluster_id?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<QuestionSubmission>>;
  student_id?: Maybe<Scalars['String']['output']>;
  tabSwitches?: Maybe<Scalars['Float']['output']>;
  timeRemaining?: Maybe<Scalars['Float']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
};

export type AssignmentSubmitInput = {
  assignment_id: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
  cheat_reasons?: InputMaybe<Scalars['String']['input']>;
  cluster_id: Scalars['String']['input'];
  question_id: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
};

export type Assignment_Folders = {
  __typename?: 'Assignment_Folders';
  _id: Scalars['String']['output'];
  assignments: Array<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Badge = {
  __typename?: 'Badge';
  creationDate?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type BulkDeleteFailedStudent = {
  __typename?: 'BulkDeleteFailedStudent';
  email: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  studentId?: Maybe<Scalars['String']['output']>;
};

export type BulkDeleteStudentsResponse = {
  __typename?: 'BulkDeleteStudentsResponse';
  deletedEmails: Array<Scalars['String']['output']>;
  failedCount: Scalars['Float']['output'];
  failedStudents: Array<BulkDeleteFailedStudent>;
  message?: Maybe<Scalars['String']['output']>;
  successCount: Scalars['Float']['output'];
};

export type Campus = {
  __typename?: 'Campus';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Categories = {
  __typename?: 'Categories';
  _id: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Category = {
  __typename?: 'Category';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  questions?: Maybe<Array<RandomQuestion>>;
};

export type CategoryDashboardDetails = {
  __typename?: 'CategoryDashboardDetails';
  awaitingCount: Scalars['Float']['output'];
  categoryId: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  completedCount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  inProgressCount: Scalars['Float']['output'];
  maxScore: Scalars['Float']['output'];
  totalScore: Scalars['Float']['output'];
};

export type CategoryDto = {
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Cluster = {
  __typename?: 'Cluster';
  assignmentIds?: Maybe<Array<Scalars['String']['output']>>;
  campusName?: Maybe<Scalars['String']['output']>;
  courseIds?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isAssessmentMail?: Maybe<Scalars['Boolean']['output']>;
  moduleIds?: Maybe<Array<Scalars['String']['output']>>;
  modules?: Maybe<Array<ModuleType>>;
  name?: Maybe<Scalars['String']['output']>;
  sendEmail?: Maybe<Scalars['Boolean']['output']>;
  staffs?: Maybe<Array<StaffType>>;
  studentCount: Scalars['Float']['output'];
};

export type CompilationOutput = {
  __typename?: 'CompilationOutput';
  compilation_time: Scalars['Float']['output'];
  stderr: Scalars['String']['output'];
  stdout: Scalars['String']['output'];
};

export type CompilationResults = {
  __typename?: 'CompilationResults';
  error: Scalars['String']['output'];
  expextedOutput: Scalars['String']['output'];
  input: Scalars['String']['output'];
  output: Scalars['String']['output'];
};

export type CompilerInput = {
  code: Scalars['String']['input'];
  language: Scalars['String']['input'];
  questionid: Scalars['String']['input'];
  testCases: Array<TestCaseInput>;
};

export type CompilerOutput = {
  __typename?: 'CompilerOutput';
  Results: Array<CompilationResults>;
  compilationOutput?: Maybe<CompilationOutput>;
  submissions: Array<SubmissionDetail>;
  testCaseFailed?: Maybe<TestCaseDetails>;
  testCasePassed?: Maybe<TestCaseDetails>;
};

export type CompletedAssignment = {
  __typename?: 'CompletedAssignment';
  assignment: Assignment;
  endTime?: Maybe<Scalars['DateTime']['output']>;
};

export type Contest = {
  __typename?: 'Contest';
  duration: Scalars['Int']['output'];
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  provider: Scalars['String']['output'];
  providerContestId: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Contributions = {
  __typename?: 'Contributions';
  points: Scalars['Float']['output'];
  questionCount: Scalars['Float']['output'];
  testcaseCount: Scalars['Float']['output'];
};

export type Course = {
  __typename?: 'Course';
  _id: Scalars['String']['output'];
  benefits?: Maybe<Array<Scalars['String']['output']>>;
  categories?: Maybe<Array<Category>>;
  companies?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  dis_price?: Maybe<Scalars['Float']['output']>;
  domain: Scalars['String']['output'];
  easy_count: Scalars['Float']['output'];
  hard_count: Scalars['Float']['output'];
  id?: Maybe<Scalars['String']['output']>;
  languages: Array<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  medium_count: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  question_ids?: Maybe<Array<Scalars['String']['output']>>;
  short_description?: Maybe<Scalars['String']['output']>;
  time_period?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  whyChoose?: Maybe<Scalars['String']['output']>;
};

export type CourseBreakdownItem = {
  __typename?: 'CourseBreakdownItem';
  completedQuestions: Scalars['Float']['output'];
  courseId?: Maybe<Scalars['String']['output']>;
  courseName?: Maybe<Scalars['String']['output']>;
  totalQuestions: Scalars['Float']['output'];
};

export type CourseDashboardDetails = {
  __typename?: 'CourseDashboardDetails';
  awaitingCount: Scalars['Float']['output'];
  categories: Array<CategoryDashboardDetails>;
  completedCount: Scalars['Float']['output'];
  courseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inProgressCount: Scalars['Float']['output'];
  maxScore: Scalars['Float']['output'];
  studentId: Scalars['String']['output'];
  totalScore: Scalars['Float']['output'];
};

export type CourseDetails = {
  __typename?: 'CourseDetails';
  completedQuestion: Scalars['String']['output'];
  courseId: Scalars['ID']['output'];
  courseName?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  percentageCompleted: Scalars['Float']['output'];
  totalQuestion: Scalars['String']['output'];
};

export type CourseProgressResponse = {
  __typename?: 'CourseProgressResponse';
  completedQuestions: Scalars['Int']['output'];
  courseId: Scalars['String']['output'];
  courseName: Scalars['String']['output'];
  level: Scalars['String']['output'];
  percentageCompleted: Scalars['Float']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type CourseResults = {
  __typename?: 'CourseResults';
  courseDetails: Array<CourseDetails>;
  rewardPoints: Scalars['String']['output'];
};

export type CreateAdminInput = {
  email: Scalars['String']['input'];
  isSuperAdmin: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  permissions: PermissionsInput;
};

export type CreateAdminResponse = {
  __typename?: 'CreateAdminResponse';
  admin: Admin;
  message: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type CreateAssignmentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  domain: Scalars['String']['input'];
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  duration: Scalars['Float']['input'];
  enable_proctoring?: InputMaybe<Scalars['Boolean']['input']>;
  languages: Array<Scalars['String']['input']>;
  max_cheat_count: Scalars['Float']['input'];
  max_tabSwitches: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  short_description?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAssignmentQuestionInput = {
  assignment_id: Scalars['String']['input'];
  company_tags: Array<Scalars['String']['input']>;
  difficulty: Scalars['String']['input'];
  hints: Array<Scalars['String']['input']>;
  marks: Scalars['String']['input'];
  predefinedCode?: InputMaybe<PredefinedLanguagesInput>;
  question_sub_text?: InputMaybe<Scalars['String']['input']>;
  showFunctionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  tags: Array<Scalars['String']['input']>;
  targetFunctionName?: InputMaybe<Scalars['String']['input']>;
  test_cases: Array<TestCaseInput>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateCampusInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCategoryInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateClusterInput = {
  campusName: Scalars['String']['input'];
  courseIds: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCourseDto = {
  benefits: Array<Scalars['String']['input']>;
  categories: Array<CategoryDto>;
  companies: Array<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  dis_price: Scalars['Float']['input'];
  domain: Scalars['String']['input'];
  easy_count?: Scalars['Float']['input'];
  hard_count?: Scalars['Float']['input'];
  languages: Array<Scalars['String']['input']>;
  level: Scalars['String']['input'];
  medium_count?: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  question_ids?: Array<Scalars['String']['input']>;
  short_description: Scalars['String']['input'];
  time_period: Scalars['Float']['input'];
  whyChoose: Scalars['String']['input'];
};

export type CreateCronJobInput = {
  assignmentId: Scalars['String']['input'];
  campusId: Scalars['String']['input'];
  campusName?: InputMaybe<Scalars['String']['input']>;
  clusterIds: Array<Scalars['String']['input']>;
  emailId: Scalars['String']['input'];
  isAdminStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isMailsend?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateFolderDto = {
  assignments?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type CreatePaymentInput = {
  amount_paid: Scalars['Float']['input'];
  cluster_id: Scalars['String']['input'];
  course_id: Scalars['String']['input'];
  order_id: Scalars['String']['input'];
  payment_id: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
};

export type CreateQuestionInput = {
  assignment_ids?: Array<Scalars['String']['input']>;
  category: QuestionCategoryInput;
  company_tags: Array<Scalars['String']['input']>;
  course_id: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  difficulty: Scalars['String']['input'];
  hints: Array<Scalars['String']['input']>;
  marks: Scalars['String']['input'];
  predefinedCode?: InputMaybe<PredefinedLanguagesInput>;
  question_sub_text?: InputMaybe<Scalars['String']['input']>;
  showFunctionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  tags: Array<Scalars['String']['input']>;
  targetFunctionName?: InputMaybe<Scalars['String']['input']>;
  test_cases: Array<TestCaseInput>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateRangeLevelInput = {
  rangeLabel: Scalars['String']['input'];
};

export type CreateReportMessageInput = {
  ranges: Array<ReportMessageRangeInput>;
};

export type CreateStaffInput = {
  campusId: Scalars['String']['input'];
  clusterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  email: Scalars['String']['input'];
  isAdminStaff: Scalars['Boolean']['input'];
  mailAutomation?: InputMaybe<Scalars['Boolean']['input']>;
  mailSettings?: InputMaybe<MailSettingsInput>;
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStaffResponse = {
  __typename?: 'CreateStaffResponse';
  message: Scalars['String']['output'];
  staff: StaffType;
  uid: Scalars['String']['output'];
};

export type CreateStudentInput = {
  campusId: Scalars['String']['input'];
  clusterIds: Array<Scalars['String']['input']>;
  courseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  email: Scalars['String']['input'];
  personalEmail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStudentResponse = {
  __typename?: 'CreateStudentResponse';
  message: Scalars['String']['output'];
  student: Student;
  uid: Scalars['String']['output'];
};

export type CronJob = {
  __typename?: 'CronJob';
  approvalToken?: Maybe<Scalars['String']['output']>;
  assignmentId: Scalars['String']['output'];
  campusId: Scalars['String']['output'];
  campusName: Scalars['String']['output'];
  clusterIds?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emailId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAdminStaff: Scalars['Boolean']['output'];
  isMailsend: Scalars['Boolean']['output'];
  job_id: Scalars['String']['output'];
  reportFilePaths?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DashboardCourseDetails = {
  __typename?: 'DashboardCourseDetails';
  courseDetails: Array<CourseDetails>;
  rewardPoints: Scalars['String']['output'];
};

export enum DateFilter {
  CustomDate = 'CUSTOM_DATE',
  Last_1Month = 'LAST_1_MONTH',
  Last_15Days = 'LAST_15_DAYS',
  TillDate = 'TILL_DATE'
}

export type DeleteMessageInRangeInput = {
  campusName: Scalars['String']['input'];
  greeting?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  rangeLabel: Scalars['String']['input'];
};

export type DeleteRangeLevelInput = {
  rangeLabel: Scalars['String']['input'];
};

export type EmailInput = {
  assignmentName?: InputMaybe<Scalars['String']['input']>;
  csvContent: Scalars['String']['input'];
  emailList: Array<Scalars['String']['input']>;
};

export type GetAllJobsInput = {
  dateFilter?: DateFilter;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetAllJobsResponse = {
  __typename?: 'GetAllJobsResponse';
  data: Array<CronJob>;
  total: Scalars['Int']['output'];
};

export type GetAutoSubmitInput = {
  campus_name: Scalars['String']['input'];
  cluster_id: Scalars['String']['input'];
  day_id: Scalars['String']['input'];
  module_id: Scalars['String']['input'];
  question_id: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
};

export type GetStudentsByCampusResponseType = {
  __typename?: 'GetStudentsByCampusResponseType';
  students: Array<Student>;
  total: Scalars['Float']['output'];
};

export type LeaderBoardResponse = {
  __typename?: 'LeaderBoardResponse';
  completedQuestions: Scalars['Float']['output'];
  courseBreakdown?: Maybe<Array<CourseBreakdownItem>>;
  department?: Maybe<Scalars['String']['output']>;
  easyQuestionsCompleted?: Maybe<Scalars['Float']['output']>;
  hardQuestionCompleted?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  latestSubmissionDate?: Maybe<Scalars['DateTime']['output']>;
  leetcode_data?: Maybe<Array<LeetCodeQuestionCount>>;
  mediumQuestionsCompleted?: Maybe<Scalars['Float']['output']>;
  position: Scalars['Float']['output'];
  student?: Maybe<Student>;
  student_id: Scalars['String']['output'];
  totalScore: Scalars['Float']['output'];
};

export type LeetCodeQuestionCount = {
  __typename?: 'LeetCodeQuestionCount';
  count: Scalars['Float']['output'];
  difficulty: Scalars['String']['output'];
  submissions: Scalars['Float']['output'];
};

export type LeetcodeDailyQuestions = {
  __typename?: 'LeetcodeDailyQuestions';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  questionNames: Array<Scalars['String']['output']>;
  questions: Array<LeetcodeQuestionItem>;
};

export type LeetcodeData = {
  __typename?: 'LeetcodeData';
  allQuestionsCount?: Maybe<Array<AllQuestionsCount>>;
  matchedUser?: Maybe<MatchedUser>;
  recentSubmissionList?: Maybe<Array<RecentSubmission>>;
};

export type LeetcodeQuestionItem = {
  __typename?: 'LeetcodeQuestionItem';
  date: Scalars['String']['output'];
  timestamp: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  titleSlug: Scalars['String']['output'];
};

export type LeetcodeQuestionsReport = {
  __typename?: 'LeetcodeQuestionsReport';
  days: Array<LeetcodeDailyQuestions>;
  fromDate: Scalars['String']['output'];
  retryReason?: Maybe<Scalars['String']['output']>;
  retrySuggested: Scalars['Boolean']['output'];
  toDate: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type LeetcodeStudent = {
  __typename?: 'LeetcodeStudent';
  acceptanceRate?: Maybe<Scalars['String']['output']>;
  contestAttended: Scalars['Int']['output'];
  contestRating: Scalars['Int']['output'];
  easySolved: Scalars['Int']['output'];
  hardSolved: Scalars['Int']['output'];
  mediumSolved: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  profileUrl: Scalars['String']['output'];
  ranking?: Maybe<Scalars['Int']['output']>;
  reputation?: Maybe<Scalars['Int']['output']>;
  starRating?: Maybe<Scalars['Int']['output']>;
  totalSolved: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type MailSettings = {
  __typename?: 'MailSettings';
  frequency: Scalars['String']['output'];
  studentFilter: Scalars['String']['output'];
};

export type MailSettingsInput = {
  frequency: Scalars['String']['input'];
  studentFilter: Scalars['String']['input'];
};

export type MatchedUser = {
  __typename?: 'MatchedUser';
  activeBadge?: Maybe<Badge>;
  badges?: Maybe<Array<Badge>>;
  contributions?: Maybe<Contributions>;
  githubUrl?: Maybe<Scalars['String']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Profile>;
  submissionCalendar?: Maybe<Scalars['String']['output']>;
  submitStats?: Maybe<SubmitStats>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  upcomingBadges?: Maybe<Array<UpcomingBadge>>;
  username?: Maybe<Scalars['String']['output']>;
};

export type ModuleAssignment = {
  __typename?: 'ModuleAssignment';
  createdAt: Scalars['DateTime']['output'];
  day_description?: Maybe<Scalars['String']['output']>;
  day_id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  questions: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ModuleAssignmentInput = {
  createdAt: Scalars['DateTime']['input'];
  day_description?: InputMaybe<Scalars['String']['input']>;
  day_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  questions: Array<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ModuleEntity = {
  __typename?: 'ModuleEntity';
  _id: Scalars['ID']['output'];
  daywise_plan?: Maybe<Array<ModuleAssignment>>;
  domain: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  name: Scalars['String']['output'];
  short_description: Scalars['String']['output'];
  start_date: Scalars['String']['output'];
};

export type ModuleForCluster = {
  __typename?: 'ModuleForCluster';
  description?: Maybe<Scalars['String']['output']>;
  enabled_dates: Array<Scalars['DateTime']['output']>;
  moduleID: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ModuleInput = {
  daywise_plan: Array<ModuleAssignmentInput>;
  domain: Scalars['String']['input'];
  end_date: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  short_description: Scalars['String']['input'];
  start_date: Scalars['DateTime']['input'];
};

export type ModuleInputForCluster = {
  enabled_dates: Array<Scalars['DateTime']['input']>;
  moduleID: Scalars['String']['input'];
};

export type ModuleSubmit = {
  __typename?: 'ModuleSubmit';
  autosave?: Maybe<SubmissionDetail>;
  campus_name: Scalars['String']['output'];
  cluster_id: Scalars['String']['output'];
  code: Scalars['String']['output'];
  compilation_time: Scalars['Float']['output'];
  day_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  is_completed: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  module_id: Scalars['String']['output'];
  question_id: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  student_id: Scalars['String']['output'];
  submissions: Array<SubmissionDetail>;
};

export type ModuleSubmitInput = {
  campus_name: Scalars['String']['input'];
  cluster_id: Scalars['String']['input'];
  code: Scalars['String']['input'];
  day_id: Scalars['String']['input'];
  isCompleted: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  module_id: Scalars['String']['input'];
  question_id: Scalars['String']['input'];
  score: Scalars['Float']['input'];
  student_id: Scalars['String']['input'];
};

export type ModuleType = {
  __typename?: 'ModuleType';
  description?: Maybe<Scalars['String']['output']>;
  enabled_dates: Array<Scalars['DateTime']['output']>;
  moduleID: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  ModuleAutoSave: Scalars['String']['output'];
  addAssignmentToCluster: Cluster;
  addAssignmentToFolder: Assignment_Folders;
  addCategory: Categories;
  addClusterToStudents: Array<Student>;
  addCoursesToCluster: Cluster;
  addModuleToCluster: Cluster;
  addQuestionsToCourse: Course;
  addStaffToCluster: Array<StaffResponse>;
  approveRequest: Approval;
  bulkUploadStudents: Array<CreateStudentResponse>;
  createAdmin: CreateAdminResponse;
  createAssignment: Assignment;
  createAssignmentQuestion: AssignmentQuestion;
  createBulkAssignmentQuestions: Array<AssignmentQuestion>;
  createCampus: Campus;
  createCluster: Cluster;
  createCourse: Course;
  createCronJob?: Maybe<CronJob>;
  createFolder: Assignment_Folders;
  createModule: ModuleEntity;
  createQuestion: Question;
  createRangeLevel: ReportMessage;
  createRazorpayOrder: Scalars['String']['output'];
  createReportMessage: ReportMessage;
  createStaff: CreateStaffResponse;
  deleteAdmin: Scalars['Boolean']['output'];
  deleteAllRequests: Scalars['String']['output'];
  deleteAssignmentQuestion: Scalars['Boolean']['output'];
  deleteBulkStudents: BulkDeleteStudentsResponse;
  deleteCampusByName: Scalars['Boolean']['output'];
  deleteCategory: Scalars['Boolean']['output'];
  deleteCronJobs: Array<Scalars['String']['output']>;
  deleteFolder: Scalars['Boolean']['output'];
  deleteMessageInRange: ReportMessage;
  deleteModule: Scalars['Boolean']['output'];
  deleteQuestion: Scalars['Boolean']['output'];
  deleteRangeLevel: ReportMessage;
  deleteStaff: Scalars['Boolean']['output'];
  deleteStudent: Scalars['String']['output'];
  deleteStudentSubmissions: Scalars['String']['output'];
  finalSubmitAssignment: AssignmentSubmit;
  getAllRangeLevels: Array<Scalars['String']['output']>;
  modulesubmitCode: CompilerOutput;
  moveAssignmentToAnotherFolder: Scalars['Boolean']['output'];
  recalculateClusterStudentCounts: Scalars['String']['output'];
  rejectRequest: Approval;
  removeAssignement: Scalars['Boolean']['output'];
  removeAssignmentFromCluster: Cluster;
  removeAssignmentFromFolder: Assignment_Folders;
  removeAssignmentFromStudent: Student;
  removeCluster: Scalars['Boolean']['output'];
  removeClusterFromStudent: Student;
  removeClusterFromStudents: Array<Student>;
  removeClusterSubmission: Scalars['String']['output'];
  removeCourse: Course;
  removeCourseFromCluster: Cluster;
  removeModuleFromCluster?: Maybe<Cluster>;
  removeStaffFromCluster: Array<RemoveStaffResponse>;
  renameCampus: Campus;
  requestDeletion: Approval;
  requestStudentPasswordReset: Scalars['String']['output'];
  resendStudentInvite: Scalars['String']['output'];
  revokeAssignment: AssignmentCompletionStatus;
  saveAssignmentCode: Scalars['String']['output'];
  saveAutoSave: Scalars['String']['output'];
  savePaymentDetails: Payment;
  sendAssignmentMail: AssignmentMailResponse;
  sendEmail: Scalars['String']['output'];
  sendInviteEmailToStaff: Scalars['String']['output'];
  sendInviteEmailToStudent: Scalars['String']['output'];
  startTest: AssignmentSubmit;
  submitAssignmentCode: CompilerOutput;
  submitCode: CompilerOutput;
  submitModuleCode: Array<SubmissionDetail>;
  toggleAssessmentMail: Cluster;
  toggleSendEmail: Cluster;
  triggerCronReports: Scalars['String']['output'];
  updateAdmin: Admin;
  updateAssignment: Assignment;
  updateAssignmentQuestion: AssignmentQuestion;
  updateClusterName: Cluster;
  updateCourse: Course;
  updateFolder: Assignment_Folders;
  updateModule: ModuleEntity;
  updateQuestion: Question;
  updateRangeLevel: ReportMessage;
  updateStaff: StaffType;
  updateStudent: Student;
  upsertMessageInRange: ReportMessage;
};


export type MutationModuleAutoSaveArgs = {
  code: Scalars['String']['input'];
  language: Scalars['String']['input'];
  moduleSubmitInput: ModuleSubmitInput;
};


export type MutationAddAssignmentToClusterArgs = {
  assignmentId: Scalars['String']['input'];
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  isEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddAssignmentToFolderArgs = {
  assignmentId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
};


export type MutationAddCategoryArgs = {
  createCategoryInput: CreateCategoryInput;
};


export type MutationAddClusterToStudentsArgs = {
  input: AddClusterToStudentsInput;
};


export type MutationAddCoursesToClusterArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  courseIds: Array<Scalars['String']['input']>;
};


export type MutationAddModuleToClusterArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  module: ModuleInputForCluster;
};


export type MutationAddQuestionsToCourseArgs = {
  courseId: Scalars['String']['input'];
  questionIds: Array<Scalars['String']['input']>;
};


export type MutationAddStaffToClusterArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  staffs: Array<UpdateStaffInput>;
};


export type MutationApproveRequestArgs = {
  admin: Scalars['String']['input'];
  id: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationBulkUploadStudentsArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  students: Array<CreateStudentInput>;
};


export type MutationCreateAdminArgs = {
  createAdminInput: CreateAdminInput;
};


export type MutationCreateAssignmentArgs = {
  createAssignmentInput: CreateAssignmentInput;
};


export type MutationCreateAssignmentQuestionArgs = {
  createQuestionInput: CreateAssignmentQuestionInput;
};


export type MutationCreateBulkAssignmentQuestionsArgs = {
  createQuestionsInput: Array<CreateAssignmentQuestionInput>;
};


export type MutationCreateCampusArgs = {
  createCampusInput: CreateCampusInput;
};


export type MutationCreateClusterArgs = {
  createClusterInput: CreateClusterInput;
};


export type MutationCreateCourseArgs = {
  createCourseInput: CreateCourseDto;
};


export type MutationCreateCronJobArgs = {
  input: CreateCronJobInput;
};


export type MutationCreateFolderArgs = {
  createFolderDto: CreateFolderDto;
};


export type MutationCreateModuleArgs = {
  data: ModuleInput;
};


export type MutationCreateQuestionArgs = {
  createQuestionInput: CreateQuestionInput;
};


export type MutationCreateRangeLevelArgs = {
  createRangeLevelInput: CreateRangeLevelInput;
};


export type MutationCreateRazorpayOrderArgs = {
  courseId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationCreateReportMessageArgs = {
  createReportMessageInput: CreateReportMessageInput;
};


export type MutationCreateStaffArgs = {
  createStaffInput: CreateStaffInput;
};


export type MutationDeleteAdminArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAssignmentQuestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBulkStudentsArgs = {
  campusName: Scalars['String']['input'];
  studentIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteCampusByNameArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteCategoryArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteCronJobsArgs = {
  jobIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteFolderArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMessageInRangeArgs = {
  deleteMessageInRangeInput: DeleteMessageInRangeInput;
};


export type MutationDeleteModuleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteQuestionArgs = {
  course_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationDeleteRangeLevelArgs = {
  deleteRangeLevelInput: DeleteRangeLevelInput;
};


export type MutationDeleteStaffArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteStudentArgs = {
  campusName: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationDeleteStudentSubmissionsArgs = {
  campusName: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationFinalSubmitAssignmentArgs = {
  AssignmentInput: AssignmentInput;
};


export type MutationModulesubmitCodeArgs = {
  ModuleSubmitInput: ModuleSubmitInput;
  compilerCodeInput: CompilerInput;
};


export type MutationMoveAssignmentToAnotherFolderArgs = {
  assignmentId: Scalars['String']['input'];
  currentFolderId: Scalars['String']['input'];
  targetFolderId: Scalars['String']['input'];
};


export type MutationRecalculateClusterStudentCountsArgs = {
  campusName: Scalars['String']['input'];
};


export type MutationRejectRequestArgs = {
  admin: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationRemoveAssignementArgs = {
  folderId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationRemoveAssignmentFromClusterArgs = {
  assignmentId: Scalars['String']['input'];
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
};


export type MutationRemoveAssignmentFromFolderArgs = {
  assignmentId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
};


export type MutationRemoveAssignmentFromStudentArgs = {
  removeAssignmentInput: RemoveAssignmentInput;
};


export type MutationRemoveClusterArgs = {
  removeClusterInput: RemoveClusterInput;
};


export type MutationRemoveClusterFromStudentArgs = {
  removeStudentClusterInput: RemoveStudentClusterInput;
};


export type MutationRemoveClusterFromStudentsArgs = {
  input: RemoveClusterFromStudentsInput;
};


export type MutationRemoveClusterSubmissionArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
};


export type MutationRemoveCourseArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveCourseFromClusterArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  courseId: Scalars['String']['input'];
};


export type MutationRemoveModuleFromClusterArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
};


export type MutationRemoveStaffFromClusterArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  staffIds: Array<Scalars['String']['input']>;
};


export type MutationRenameCampusArgs = {
  renameCampusInput: RenameCampusInput;
};


export type MutationRequestDeletionArgs = {
  payload: Scalars['JSON']['input'];
  reasonForDeletion: Scalars['String']['input'];
  requestedBy: Scalars['String']['input'];
  title: Scalars['String']['input'];
  typeOfDeletion: Scalars['String']['input'];
};


export type MutationRequestStudentPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationResendStudentInviteArgs = {
  email: Scalars['String']['input'];
};


export type MutationRevokeAssignmentArgs = {
  assignmentId: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
  studentIds: Array<Scalars['String']['input']>;
};


export type MutationSaveAssignmentCodeArgs = {
  code: Scalars['String']['input'];
  language: Scalars['String']['input'];
  saveCodeInput: AssignmentSubmitInput;
};


export type MutationSaveAutoSaveArgs = {
  code: Scalars['String']['input'];
  language: Scalars['String']['input'];
  submitInput: SubmitInput;
};


export type MutationSavePaymentDetailsArgs = {
  createPaymentInput: CreatePaymentInput;
};


export type MutationSendAssignmentMailArgs = {
  input: SendAssignmentMailInput;
};


export type MutationSendEmailArgs = {
  emailInput: EmailInput;
};


export type MutationSendInviteEmailToStaffArgs = {
  emails: Array<Scalars['String']['input']>;
};


export type MutationSendInviteEmailToStudentArgs = {
  emails: Array<Scalars['String']['input']>;
};


export type MutationStartTestArgs = {
  assignment_id: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
  testDurationInMinutes: Scalars['Float']['input'];
};


export type MutationSubmitAssignmentCodeArgs = {
  assignmentCompilerCodeInput: CompilerInput;
  assignmentSubmitInput: AssignmentSubmitInput;
};


export type MutationSubmitCodeArgs = {
  compilerCodeInput: CompilerInput;
  submitInput: SubmitInput;
};


export type MutationSubmitModuleCodeArgs = {
  moduleSubmitInput: ModuleSubmitInput;
};


export type MutationToggleAssessmentMailArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  isAssessmentMail: Scalars['Boolean']['input'];
};


export type MutationToggleSendEmailArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  sendEmail: Scalars['Boolean']['input'];
};


export type MutationTriggerCronReportsArgs = {
  jobIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateAdminArgs = {
  updateAdminInput: UpdateAdminInput;
};


export type MutationUpdateAssignmentArgs = {
  id: Scalars['String']['input'];
  updateAssignmentInput: UpdateAssignmentInput;
};


export type MutationUpdateAssignmentQuestionArgs = {
  id: Scalars['String']['input'];
  updateQuestionInput: UpdateAssignmentQuestionInput;
};


export type MutationUpdateClusterNameArgs = {
  updateClusterNameInput: UpdateClusterNameInput;
};


export type MutationUpdateCourseArgs = {
  id: Scalars['String']['input'];
  updateCourseInput: UpdateCourseDto;
};


export type MutationUpdateFolderArgs = {
  id: Scalars['String']['input'];
  updateFolderDto: UpdateFolderDto;
};


export type MutationUpdateModuleArgs = {
  data: ModuleInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateQuestionArgs = {
  id: Scalars['String']['input'];
  updateQuestionInput: UpdateQuestionInput;
};


export type MutationUpdateRangeLevelArgs = {
  updateRangeLevelInput: UpdateRangeLevelInput;
};


export type MutationUpdateStaffArgs = {
  updateStaffInput: UpdateStaffInput;
};


export type MutationUpdateStudentArgs = {
  updateStudentInput: UpdateStudentInput;
};


export type MutationUpsertMessageInRangeArgs = {
  upsertMessageInRangeInput: UpsertMessageInRangeInput;
};

export type OrderResponse = {
  __typename?: 'OrderResponse';
  amount: Scalars['String']['output'];
  course_name: Scalars['String']['output'];
  order_id: Scalars['String']['output'];
  payment_date: Scalars['DateTime']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  _id: Scalars['String']['output'];
  amount_paid: Scalars['Float']['output'];
  cluster_id: Scalars['String']['output'];
  course_id: Scalars['String']['output'];
  date_of_purchase: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  order_id: Scalars['String']['output'];
  payment_id: Scalars['String']['output'];
  student_id: Scalars['ID']['output'];
};

export type Permissions = {
  __typename?: 'Permissions';
  assignments?: Maybe<Array<Scalars['String']['output']>>;
  courses?: Maybe<Array<Scalars['String']['output']>>;
  reports?: Maybe<Scalars['Boolean']['output']>;
  student_creation?: Maybe<Scalars['Boolean']['output']>;
};

export type PermissionsInput = {
  assignments?: InputMaybe<Array<Scalars['String']['input']>>;
  courses?: InputMaybe<Array<Scalars['String']['input']>>;
  reports?: InputMaybe<Scalars['Boolean']['input']>;
  student_creation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PredefinedLanguages = {
  __typename?: 'PredefinedLanguages';
  c: Scalars['String']['output'];
  cpp: Scalars['String']['output'];
  java: Scalars['String']['output'];
  python: Scalars['String']['output'];
};

export type PredefinedLanguagesInput = {
  c: Scalars['String']['input'];
  cpp: Scalars['String']['input'];
  java: Scalars['String']['input'];
  python: Scalars['String']['input'];
};

export type Profile = {
  __typename?: 'Profile';
  aboutMe?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  ranking: Scalars['Float']['output'];
  realName?: Maybe<Scalars['String']['output']>;
  reputation: Scalars['Float']['output'];
  school?: Maybe<Scalars['String']['output']>;
  skillTags?: Maybe<Array<Scalars['String']['output']>>;
  starRating?: Maybe<Scalars['Float']['output']>;
  userAvatar?: Maybe<Scalars['String']['output']>;
  websites: Array<Scalars['String']['output']>;
};

export type PurchasedCourse = {
  __typename?: 'PurchasedCourse';
  cluster_id: Scalars['String']['output'];
  course_id: Scalars['String']['output'];
};

export type PurchasedCourseInput = {
  cluster_id: Scalars['String']['input'];
  course_id: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  allCampus: Array<Campus>;
  allCategories: Array<Categories>;
  allContests: Array<Contest>;
  assignmentsInFolder: Array<Assignment>;
  campus: Campus;
  compileCode: CompilerOutput;
  executeCronJob: Scalars['String']['output'];
  findAllQuestions: Array<Question>;
  findAssignmentsForStudentWithFilter: Array<Assignment>;
  getAdminUsingEmail: Admin;
  getAllAdmin: Array<Admin>;
  getAllAssignmentQuestion: Array<AssignmentQuestion>;
  getAllAssignments: Array<Assignment>;
  getAllCourses: Array<Course>;
  getAllCoursesByCluster: Array<Course>;
  getAllCronJobs: GetAllJobsResponse;
  getAllFolders: Array<Assignment_Folders>;
  getAllModules: Array<ModuleEntity>;
  getAllQuestion: QuestionResponse;
  getAllRequests: Array<Approval>;
  getAllStaffs: Array<StaffType>;
  getAllStudents: Array<Student>;
  getAssignment: Assignment;
  getAssignmentByCampus: Array<Assignment>;
  getAssignmentByCluster: Array<Assignment>;
  getAssignmentLeaderBoard: Array<AssignmentLeaderBoard>;
  getAssignmentLeaderBoardNew: Array<AssignmentLeaderBoard>;
  getAssignmentQuestion: AssignmentQuestion;
  getAssignmentQuestionForStudents: AssignmentQuestion;
  getAssignmentQuestionsByTags: Array<AssignmentQuestion>;
  getAssignmentSubmit?: Maybe<AssignmentSubmit>;
  getAssignmentsForStudent: AssignmentStatusResult;
  getAutoSubmit?: Maybe<ModuleSubmit>;
  getCampusByName: Campus;
  getCategoryDashboardDetails: CategoryDashboardDetails;
  getCluster: Cluster;
  getClusterStudents: Array<StudentDetail>;
  getClustersByCampus: Array<Cluster>;
  getClustersByIdsAndCampus: Array<Cluster>;
  getCourse: Course;
  getCourseDashboardDetails: CourseDashboardDetails;
  getCourseForStudents: Course;
  getCourseProgress: CourseProgressResponse;
  getCoursesByStudentEmail: Array<Course>;
  getDashboardCourseDetails: DashboardCourseDetails;
  getFolderById: Assignment_Folders;
  getLastFiveSubmissions: Submit;
  getLeaderboard: Array<LeaderBoardResponse>;
  getMessagesByRangeLevel: Array<ReportMessageEntry>;
  getModule: ModuleEntity;
  getModuleById: ModuleEntity;
  getModuleLeaderboard: Array<ModuleSubmit>;
  getModuleSubmissions: Array<ModuleSubmit>;
  getModulesByCampus: Array<ModuleForCluster>;
  getModulesByCluster: Array<ModuleForCluster>;
  getOrdersByStudentId: Array<OrderResponse>;
  getOtherAssignment: Array<Assignment>;
  getQuestion: Question;
  getQuestionCompleted: QuestionCompletionResult;
  getQuestionForStudents: QuestionOutput;
  getQuestionsByCategory: QuestionResponse;
  getQuestionsByTags: Array<Question>;
  getReportMessageByScore: ReportMessageEntry;
  getReportMessages: Array<ReportMessage>;
  getStaff: StaffType;
  getStaffByEmailId: StaffType;
  getStaffsByCampus: Array<StaffType>;
  getStudent?: Maybe<Student>;
  getStudentAndCampusDetailsByAssignmentId: Array<StudentCampusDto>;
  getStudentAssignmentResults: Array<AssignmentSubmit>;
  getStudentByEmailId: Student;
  getStudentSubmissionsForMonth: Array<SubmissionData>;
  getStudentSubmissionsForTimeRange: Array<SubmissionData>;
  getStudentsByCampus: GetStudentsByCampusResponseType;
  getStudentsByCluster: Array<Student>;
  getStudentsResults: StudentResults;
  getSubmission?: Maybe<AssignmentSubmit>;
  isAssignmentCompleted?: Maybe<AssignmentCompletionStatus>;
  leetcodeAcceptedQuestions: LeetcodeQuestionsReport;
  leetcodeBulk: Array<LeetcodeStudent>;
  leetcodeData: LeetcodeData;
  liveContests: Array<Contest>;
  removeClusterSubmission: Scalars['String']['output'];
  studentsNotAttendedAssignment: Array<StudentWithClusterInfo>;
};


export type QueryAssignmentsInFolderArgs = {
  folderId: Scalars['String']['input'];
};


export type QueryCampusArgs = {
  id: Scalars['String']['input'];
};


export type QueryCompileCodeArgs = {
  compileCodeInput: CompilerInput;
};


export type QueryExecuteCronJobArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryFindAllQuestionsArgs = {
  difficulties?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchName?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFindAssignmentsForStudentWithFilterArgs = {
  customDateRange?: InputMaybe<AssignmentFilterInput>;
  email: Scalars['String']['input'];
  filterType?: Scalars['String']['input'];
};


export type QueryGetAdminUsingEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetAllAssignmentQuestionArgs = {
  assignmentId: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryGetAllCoursesByClusterArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
};


export type QueryGetAllCronJobsArgs = {
  input?: InputMaybe<GetAllJobsInput>;
};


export type QueryGetAllQuestionArgs = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  courseId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAssignmentArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetAssignmentByCampusArgs = {
  campusName: Scalars['String']['input'];
};


export type QueryGetAssignmentByClusterArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
};


export type QueryGetAssignmentLeaderBoardArgs = {
  assignmentId: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
};


export type QueryGetAssignmentLeaderBoardNewArgs = {
  assignmentId: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
  student_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAssignmentQuestionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetAssignmentQuestionForStudentsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetAssignmentQuestionsByTagsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  tags: Array<Scalars['String']['input']>;
};


export type QueryGetAssignmentSubmitArgs = {
  assignmentId: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
};


export type QueryGetAssignmentsForStudentArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetAutoSubmitArgs = {
  GetAutoSubmitInput: GetAutoSubmitInput;
};


export type QueryGetCampusByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryGetCategoryDashboardDetailsArgs = {
  campus_name: Scalars['String']['input'];
  category_id: Scalars['String']['input'];
  course_id: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
};


export type QueryGetClusterArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
};


export type QueryGetClusterStudentsArgs = {
  clusterId: Scalars['String']['input'];
};


export type QueryGetClustersByCampusArgs = {
  campusName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClustersByIdsAndCampusArgs = {
  campusName: Scalars['String']['input'];
  clusterIds: Array<Scalars['String']['input']>;
};


export type QueryGetCourseArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCourseDashboardDetailsArgs = {
  campus_name: Scalars['String']['input'];
  course_id: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
};


export type QueryGetCourseForStudentsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCourseProgressArgs = {
  courseId: Scalars['String']['input'];
  isPaid: Scalars['Boolean']['input'];
  studentId: Scalars['String']['input'];
};


export type QueryGetCoursesByStudentEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetDashboardCourseDetailsArgs = {
  is_paid?: Scalars['Boolean']['input'];
  student_id: Scalars['String']['input'];
};


export type QueryGetFolderByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetLastFiveSubmissionsArgs = {
  submitInput: SubmitInput;
};


export type QueryGetLeaderboardArgs = {
  campusName: Scalars['String']['input'];
  clusterId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMessagesByRangeLevelArgs = {
  campusName?: InputMaybe<Scalars['String']['input']>;
  rangeLabel: Scalars['String']['input'];
};


export type QueryGetModuleArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetModuleByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetModuleLeaderboardArgs = {
  campusName: Scalars['String']['input'];
  dayIds?: InputMaybe<Array<Scalars['String']['input']>>;
  moduleId: Scalars['String']['input'];
};


export type QueryGetModuleSubmissionsArgs = {
  campusName: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
};


export type QueryGetModulesByCampusArgs = {
  campusName: Scalars['String']['input'];
};


export type QueryGetModulesByClusterArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
};


export type QueryGetOrdersByStudentIdArgs = {
  student_id: Scalars['String']['input'];
};


export type QueryGetQuestionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetQuestionCompletedArgs = {
  is_paid?: Scalars['Boolean']['input'];
  student_id: Scalars['String']['input'];
};


export type QueryGetQuestionForStudentsArgs = {
  campus_name: Scalars['String']['input'];
  category_id?: InputMaybe<Scalars['String']['input']>;
  course_id: Scalars['String']['input'];
  difficulty?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  student_id: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetQuestionsByCategoryArgs = {
  categoryId: Scalars['String']['input'];
  courseId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetQuestionsByTagsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  tags: Array<Scalars['String']['input']>;
};


export type QueryGetReportMessageByScoreArgs = {
  campusName?: InputMaybe<Scalars['String']['input']>;
  scorePercent: Scalars['Int']['input'];
};


export type QueryGetReportMessagesArgs = {
  campusName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStaffArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetStaffByEmailIdArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetStaffsByCampusArgs = {
  campusId: Scalars['String']['input'];
};


export type QueryGetStudentArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetStudentAndCampusDetailsByAssignmentIdArgs = {
  assignmentId: Scalars['String']['input'];
};


export type QueryGetStudentAssignmentResultsArgs = {
  student_id: Scalars['String']['input'];
};


export type QueryGetStudentByEmailIdArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetStudentSubmissionsForMonthArgs = {
  campusName: Scalars['String']['input'];
  month: Scalars['Int']['input'];
  studentId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


export type QueryGetStudentSubmissionsForTimeRangeArgs = {
  campusName: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
  timeRangeInMonths: Scalars['Int']['input'];
};


export type QueryGetStudentsByCampusArgs = {
  campusId: Scalars['String']['input'];
  clusterid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStudentsByClusterArgs = {
  clusterId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStudentsResultsArgs = {
  campusId: Scalars['String']['input'];
  clusterid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSubmissionArgs = {
  assignment_id: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
};


export type QueryIsAssignmentCompletedArgs = {
  assignmentId: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
};


export type QueryLeetcodeAcceptedQuestionsArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


export type QueryLeetcodeBulkArgs = {
  usernames: Array<Scalars['String']['input']>;
};


export type QueryLeetcodeDataArgs = {
  username: Scalars['String']['input'];
};


export type QueryRemoveClusterSubmissionArgs = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
};


export type QueryStudentsNotAttendedAssignmentArgs = {
  assignmentId: Scalars['String']['input'];
  campus_id: Scalars['String']['input'];
  cluster_id?: InputMaybe<Scalars['String']['input']>;
};

export type Question = {
  __typename?: 'Question';
  _id: Scalars['String']['output'];
  assignment_ids?: Maybe<Array<Scalars['String']['output']>>;
  category: QuestionCategory;
  company_tags: Array<Scalars['String']['output']>;
  course_id: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  difficulty: Scalars['String']['output'];
  hints: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  marks: Scalars['String']['output'];
  predefinedCode?: Maybe<PredefinedLanguages>;
  question_sub_text?: Maybe<Scalars['String']['output']>;
  showFunctionOnly?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Scalars['String']['output']>;
  targetFunctionName?: Maybe<Scalars['String']['output']>;
  test_cases: Array<TestCase>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
};

export type QuestionCategory = {
  __typename?: 'QuestionCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type QuestionCategoryInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type QuestionCompletionResult = {
  __typename?: 'QuestionCompletionResult';
  easy: QuestionCount;
  hard: QuestionCount;
  medium: QuestionCount;
  overall: QuestionCount;
};

export type QuestionCount = {
  __typename?: 'QuestionCount';
  completed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuestionLeaderboard = {
  __typename?: 'QuestionLeaderboard';
  AllotedTotalMarks: Scalars['Float']['output'];
  questionId: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type QuestionOutput = {
  __typename?: 'QuestionOutput';
  questions: Array<Status>;
  totalCount: Scalars['Float']['output'];
};

export type QuestionResponse = {
  __typename?: 'QuestionResponse';
  completionStatus: Scalars['Int']['output'];
  questions: Array<Question>;
  totalCount: Scalars['Int']['output'];
};

export type QuestionResult = {
  __typename?: 'QuestionResult';
  answer: Scalars['String']['output'];
  language: Scalars['String']['output'];
  question_id?: Maybe<Scalars['ID']['output']>;
  score: Scalars['Float']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type QuestionSubmission = {
  __typename?: 'QuestionSubmission';
  answer: Scalars['String']['output'];
  language: Scalars['String']['output'];
  question_id: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type RandomQuestion = {
  __typename?: 'RandomQuestion';
  difficulty: Scalars['String']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type RecentSubmission = {
  __typename?: 'RecentSubmission';
  lang?: Maybe<Scalars['String']['output']>;
  statusDisplay?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleSlug?: Maybe<Scalars['String']['output']>;
};

export type RemoveAssignmentInput = {
  assignmentId: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
};

export type RemoveClusterFromStudentsInput = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  courseIds: Array<Scalars['String']['input']>;
  studentIds: Array<Scalars['String']['input']>;
};

export type RemoveClusterInput = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
};

export type RemoveStaffResponse = {
  __typename?: 'RemoveStaffResponse';
  removed: Scalars['Boolean']['output'];
  staffId: Scalars['String']['output'];
};

export type RemoveStudentClusterInput = {
  clusterId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type RenameCampusInput = {
  newName: Scalars['String']['input'];
  oldName: Scalars['String']['input'];
};

export type ReportMessage = {
  __typename?: 'ReportMessage';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  ranges: Array<ReportMessageRange>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReportMessageEntry = {
  __typename?: 'ReportMessageEntry';
  campusName: Scalars['String']['output'];
  greeting: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ReportMessageEntryInput = {
  campusName: Scalars['String']['input'];
  greeting: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type ReportMessageRange = {
  __typename?: 'ReportMessageRange';
  entries: Array<ReportMessageEntry>;
  rangeLabel: Scalars['String']['output'];
};

export type ReportMessageRangeInput = {
  entries: Array<ReportMessageEntryInput>;
  rangeLabel: Scalars['String']['input'];
};

export type SendAssignmentMailInput = {
  assignmentId: Scalars['String']['input'];
  assignmentName: Scalars['String']['input'];
  campusId: Scalars['String']['input'];
  campusName: Scalars['String']['input'];
  clusterIds: Array<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  message: Scalars['String']['input'];
  sentBy: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  subject: Scalars['String']['input'];
};

export type StaffResponse = {
  __typename?: 'StaffResponse';
  added: Scalars['Boolean']['output'];
  staff?: Maybe<StaffType>;
};

export type StaffType = {
  __typename?: 'StaffType';
  campusId?: Maybe<Scalars['String']['output']>;
  clusterIds?: Maybe<Array<Scalars['String']['output']>>;
  contactNo?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAdminStaff?: Maybe<Scalars['Boolean']['output']>;
  isInviteSend: Scalars['Boolean']['output'];
  mailAutomation?: Maybe<Scalars['Boolean']['output']>;
  mailSettings?: Maybe<MailSettings>;
  name: Scalars['String']['output'];
};

export type Status = {
  __typename?: 'Status';
  difficulty: Scalars['String']['output'];
  mark: Scalars['Float']['output'];
  question_id: Scalars['String']['output'];
  status: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type Student = {
  __typename?: 'Student';
  assignmentIds: Array<Scalars['String']['output']>;
  campusId: Scalars['String']['output'];
  clusterIds: Array<Scalars['String']['output']>;
  completedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  courseIds: Array<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  dob: Scalars['String']['output'];
  email: Scalars['String']['output'];
  hackerRankUname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isInviteSend: Scalars['Boolean']['output'];
  leetCodeUname: Scalars['String']['output'];
  name: Scalars['String']['output'];
  personalEmail?: Maybe<Scalars['String']['output']>;
  phno: Scalars['String']['output'];
  placeOfResidence: Scalars['String']['output'];
  purchasedCourses?: Maybe<Array<Maybe<PurchasedCourse>>>;
  rollNo: Scalars['String']['output'];
};

export type StudentCampusDto = {
  __typename?: 'StudentCampusDTO';
  campus: Campus;
  student: Student;
};

export type StudentDetail = {
  __typename?: 'StudentDetail';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leetCodeUname?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rollNo?: Maybe<Scalars['String']['output']>;
};

export type StudentPersonalDetails = {
  __typename?: 'StudentPersonalDetails';
  assignmentDetails: Array<AssignmentResults>;
  courseDetails: CourseResults;
  department?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rollNo: Scalars['String']['output'];
};

export type StudentResults = {
  __typename?: 'StudentResults';
  students: Array<StudentPersonalDetails>;
  total: Scalars['Float']['output'];
};

export type StudentWithClusterInfo = {
  __typename?: 'StudentWithClusterInfo';
  cluster_names: Scalars['String']['output'];
  student_email: Scalars['String']['output'];
  student_id: Scalars['String']['output'];
  student_name: Scalars['String']['output'];
  student_rollno: Scalars['String']['output'];
};

export type Submission = {
  __typename?: 'Submission';
  submittedAt: Scalars['DateTime']['output'];
};

export type SubmissionData = {
  __typename?: 'SubmissionData';
  courseName?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  submissions: Array<Submission>;
};

export type SubmissionDetail = {
  __typename?: 'SubmissionDetail';
  code: Scalars['String']['output'];
  compilation_time?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  language?: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type Submit = {
  __typename?: 'Submit';
  autosave?: Maybe<SubmissionDetail>;
  cluster_id: Scalars['String']['output'];
  course_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  max_score?: Maybe<Scalars['Float']['output']>;
  min_compilation_time?: Maybe<Scalars['Float']['output']>;
  question_id: Scalars['String']['output'];
  student_id: Scalars['String']['output'];
  submissions: Array<SubmissionDetail>;
};

export type SubmitInput = {
  campus_name: Scalars['String']['input'];
  cluster_id: Scalars['String']['input'];
  course_id: Scalars['String']['input'];
  day_id?: InputMaybe<Scalars['String']['input']>;
  question_id: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
};

export type SubmitStats = {
  __typename?: 'SubmitStats';
  acSubmissionNum?: Maybe<Array<SubmitStatsNum>>;
  totalSubmissionNum?: Maybe<Array<SubmitStatsNum>>;
};

export type SubmitStatsNum = {
  __typename?: 'SubmitStatsNum';
  count?: Maybe<Scalars['Float']['output']>;
  difficulty?: Maybe<Scalars['String']['output']>;
  submissions?: Maybe<Scalars['Float']['output']>;
};

export type TestCase = {
  __typename?: 'TestCase';
  id?: Maybe<Scalars['ID']['output']>;
  input: Scalars['String']['output'];
  output: Scalars['String']['output'];
  visibility: Scalars['String']['output'];
  weightage: Scalars['Float']['output'];
};

export type TestCaseDetails = {
  __typename?: 'TestCaseDetails';
  count: Scalars['Float']['output'];
  testCaseIds: Array<TestCaseOutputFormat>;
};

export type TestCaseInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: Scalars['String']['input'];
  output: Scalars['String']['input'];
  visibility: Scalars['String']['input'];
  weightage: Scalars['Float']['input'];
};

export type TestCaseOutputFormat = {
  __typename?: 'TestCaseOutputFormat';
  runtime: Scalars['Float']['output'];
  stderr?: Maybe<Scalars['String']['output']>;
  stdout?: Maybe<Scalars['String']['output']>;
  testCaseId: Scalars['Float']['output'];
};

export type UpcomingBadge = {
  __typename?: 'UpcomingBadge';
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UpdateAdminInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isSuperAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<PermissionsInput>;
};

export type UpdateAssignmentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  enable_proctoring?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  max_cheat_count?: InputMaybe<Scalars['Float']['input']>;
  max_tabSwitches?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  short_description?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssignmentQuestionInput = {
  assignment_id?: InputMaybe<Scalars['String']['input']>;
  company_tags?: InputMaybe<Array<Scalars['String']['input']>>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  hints?: InputMaybe<Array<Scalars['String']['input']>>;
  marks?: InputMaybe<Scalars['String']['input']>;
  predefinedCode?: InputMaybe<PredefinedLanguagesInput>;
  question_sub_text?: InputMaybe<Scalars['String']['input']>;
  showFunctionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targetFunctionName?: InputMaybe<Scalars['String']['input']>;
  test_cases?: InputMaybe<Array<TestCaseInput>>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClusterNameInput = {
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  newName: Scalars['String']['input'];
};

export type UpdateCourseDto = {
  benefits: Array<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<CategoryInput>>>;
  companies: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dis_price: Scalars['Float']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  short_description?: InputMaybe<Scalars['String']['input']>;
  time_period?: InputMaybe<Scalars['Float']['input']>;
  whyChoose: Scalars['String']['input'];
};

export type UpdateFolderDto = {
  assignments?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuestionInput = {
  assignment_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<QuestionCategoryInput>;
  company_tags?: InputMaybe<Array<Scalars['String']['input']>>;
  course_id?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  hints?: InputMaybe<Array<Scalars['String']['input']>>;
  marks?: InputMaybe<Scalars['String']['input']>;
  predefinedCode?: InputMaybe<PredefinedLanguagesInput>;
  question_sub_text?: InputMaybe<Scalars['String']['input']>;
  showFunctionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targetFunctionName?: InputMaybe<Scalars['String']['input']>;
  test_cases?: InputMaybe<Array<TestCaseInput>>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRangeLevelInput = {
  newRangeLabel: Scalars['String']['input'];
  oldRangeLabel: Scalars['String']['input'];
};

export type UpdateStaffInput = {
  clusterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  contactNo?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isAdminStaff?: InputMaybe<Scalars['Boolean']['input']>;
  mailAutomation?: InputMaybe<Scalars['Boolean']['input']>;
  mailSettings?: InputMaybe<MailSettingsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStudentInput = {
  assignmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  courseIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  department?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hackerRankUname?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  leetCodeUname?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  phno?: InputMaybe<Scalars['String']['input']>;
  placeOfResidence?: InputMaybe<Scalars['String']['input']>;
  purchasedCourses?: InputMaybe<Array<InputMaybe<PurchasedCourseInput>>>;
  rollNo?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertMessageInRangeInput = {
  campusName: Scalars['String']['input'];
  greeting: Scalars['String']['input'];
  message: Scalars['String']['input'];
  rangeLabel: Scalars['String']['input'];
};

export type CreateModuleMutationVariables = Exact<{
  data: ModuleInput;
}>;


export type CreateModuleMutation = { __typename?: 'Mutation', createModule: { __typename?: 'ModuleEntity', _id: string, name: string, domain: string, short_description: string, start_date: string, end_date: string, daywise_plan?: Array<{ __typename?: 'ModuleAssignment', name: string, day_description?: string | null, questions: Array<string>, createdAt: any, updatedAt?: any | null }> | null } };

export type RemoveClusterMutationVariables = Exact<{
  removeClusterInput: RemoveClusterInput;
}>;


export type RemoveClusterMutation = { __typename?: 'Mutation', removeCluster: boolean };

export type DeleteCampusByNameMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteCampusByNameMutation = { __typename?: 'Mutation', deleteCampusByName: boolean };

export type RequestDeletionMutationVariables = Exact<{
  typeOfDeletion: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
  reasonForDeletion: Scalars['String']['input'];
  requestedBy: Scalars['String']['input'];
  title: Scalars['String']['input'];
}>;


export type RequestDeletionMutation = { __typename?: 'Mutation', requestDeletion: { __typename?: 'Approval', id: string, typeOfDeletion: string, payload: any, statusOfApproval: string, requestedBy: string, requestedAt: any } };

export type AddModuleToClusterMutationVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  module: ModuleInputForCluster;
}>;


export type AddModuleToClusterMutation = { __typename?: 'Mutation', addModuleToCluster: { __typename?: 'Cluster', id: string, name?: string | null, courseIds?: Array<string> | null, assignmentIds?: Array<string> | null, studentCount: number, campusName?: string | null, createdAt?: any | null, moduleIds?: Array<string> | null, sendEmail?: boolean | null, staffs?: Array<{ __typename?: 'StaffType', id: string, name: string, email: string, campusId?: string | null, designation?: string | null, contactNo?: string | null, clusterIds?: Array<string> | null, isInviteSend: boolean, isAdminStaff?: boolean | null }> | null } };

export type CreateCampusMutationVariables = Exact<{
  createCampusInput: CreateCampusInput;
}>;


export type CreateCampusMutation = { __typename?: 'Mutation', createCampus: { __typename?: 'Campus', id: string, name: string } };

export type CreateClusterMutationVariables = Exact<{
  createClusterInput: CreateClusterInput;
}>;


export type CreateClusterMutation = { __typename?: 'Mutation', createCluster: { __typename?: 'Cluster', id: string, name?: string | null, courseIds?: Array<string> | null } };

export type CreateStaffMutationVariables = Exact<{
  createStaffInput: CreateStaffInput;
}>;


export type CreateStaffMutation = { __typename?: 'Mutation', createStaff: { __typename?: 'CreateStaffResponse', uid: string, message: string, staff: { __typename?: 'StaffType', id: string, name: string, email: string, campusId?: string | null } } };

export type DeleteStaffMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteStaffMutation = { __typename?: 'Mutation', deleteStaff: boolean };

export type SendInviteEmailToStaffMutationVariables = Exact<{
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SendInviteEmailToStaffMutation = { __typename?: 'Mutation', sendInviteEmailToStaff: string };

export type SendInviteEmailToStudentMutationVariables = Exact<{
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SendInviteEmailToStudentMutation = { __typename?: 'Mutation', sendInviteEmailToStudent: string };

export type DeleteStudentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  campusName: Scalars['String']['input'];
}>;


export type DeleteStudentMutation = { __typename?: 'Mutation', deleteStudent: string };

export type UpdateStudentMutationVariables = Exact<{
  updateStudentInput: UpdateStudentInput;
}>;


export type UpdateStudentMutation = { __typename?: 'Mutation', updateStudent: { __typename?: 'Student', id: string, name: string, email: string, personalEmail?: string | null, phno: string, dob: string, rollNo: string, department?: string | null, placeOfResidence: string, leetCodeUname: string, hackerRankUname: string, assignmentIds: Array<string>, courseIds: Array<string> } };

export type BulkUploadStudentsMutationVariables = Exact<{
  students: Array<CreateStudentInput> | CreateStudentInput;
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
}>;


export type BulkUploadStudentsMutation = { __typename?: 'Mutation', bulkUploadStudents: Array<{ __typename?: 'CreateStudentResponse', uid: string, message: string, student: { __typename?: 'Student', id: string, name: string, email: string, personalEmail?: string | null } }> };

export type CreateAdminMutationVariables = Exact<{
  CreateAdminInput: CreateAdminInput;
}>;


export type CreateAdminMutation = { __typename?: 'Mutation', createAdmin: { __typename?: 'CreateAdminResponse', uid: string, message: string, admin: { __typename?: 'Admin', id: string, name: string, email: string } } };

export type DeleteAdminMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAdminMutation = { __typename?: 'Mutation', deleteAdmin: boolean };

export type UpdateStaffMutationVariables = Exact<{
  updateStaffInput: UpdateStaffInput;
}>;


export type UpdateStaffMutation = { __typename?: 'Mutation', updateStaff: { __typename?: 'StaffType', id: string, name: string, email: string, campusId?: string | null, designation?: string | null, contactNo?: string | null } };

export type CreateCourseMutationVariables = Exact<{
  createCourseInput: CreateCourseDto;
}>;


export type CreateCourseMutation = { __typename?: 'Mutation', createCourse: { __typename?: 'Course', id?: string | null, name: string, short_description?: string | null, description: string, price: number, time_period?: number | null, languages: Array<string>, domain: string, updatedBy?: string | null, updatedAt?: any | null, createdBy?: string | null, createdAt?: any | null, categories?: Array<{ __typename?: 'Category', id: string, name: string, description: string }> | null } };

export type UpdateCourseMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateCourseInput: UpdateCourseDto;
}>;


export type UpdateCourseMutation = { __typename?: 'Mutation', updateCourse: { __typename?: 'Course', id?: string | null, name: string, short_description?: string | null, description: string, price: number, time_period?: number | null, languages: Array<string>, domain: string, updatedBy?: string | null, updatedAt?: any | null, createdBy?: string | null, createdAt?: any | null, categories?: Array<{ __typename?: 'Category', name: string, description: string }> | null } };

export type RemoveCourseMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveCourseMutation = { __typename?: 'Mutation', removeCourse: { __typename?: 'Course', id?: string | null, name: string } };

export type CreateQuestionMutationVariables = Exact<{
  createQuestionInput: CreateQuestionInput;
}>;


export type CreateQuestionMutation = { __typename?: 'Mutation', createQuestion: { __typename?: 'Question', id: string, course_id: string, assignment_ids?: Array<string> | null, title: string, text: string, question_sub_text?: string | null, showFunctionOnly?: boolean | null, targetFunctionName?: string | null, marks: string, difficulty: string, hints: Array<string>, tags: Array<string>, company_tags: Array<string>, created_by?: string | null, created_at: any, updated_by?: string | null, updated_at: any, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, category: { __typename?: 'QuestionCategory', id: string, name: string }, predefinedCode?: { __typename?: 'PredefinedLanguages', c: string, java: string, python: string, cpp: string } | null } };

export type UpdateQuestionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateQuestionInput: UpdateQuestionInput;
}>;


export type UpdateQuestionMutation = { __typename?: 'Mutation', updateQuestion: { __typename?: 'Question', id: string, course_id: string, assignment_ids?: Array<string> | null, title: string, text: string, question_sub_text?: string | null, marks: string, difficulty: string, hints: Array<string>, tags: Array<string>, company_tags: Array<string>, updated_by?: string | null, updated_at: any, created_by?: string | null, created_at: any, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, category: { __typename?: 'QuestionCategory', name: string, id: string } } };

export type DeleteQuestionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  course_id: Scalars['String']['input'];
}>;


export type DeleteQuestionMutation = { __typename?: 'Mutation', deleteQuestion: boolean };

export type AddCoursesToClusterMutationVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  courseIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddCoursesToClusterMutation = { __typename?: 'Mutation', addCoursesToCluster: { __typename?: 'Cluster', id: string, name?: string | null, courseIds?: Array<string> | null } };

export type RemoveCourseFromClusterMutationVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  courseId: Scalars['String']['input'];
}>;


export type RemoveCourseFromClusterMutation = { __typename?: 'Mutation', removeCourseFromCluster: { __typename?: 'Cluster', id: string, name?: string | null, courseIds?: Array<string> | null } };

export type UpdateClusterNameMutationVariables = Exact<{
  updateClusterNameInput: UpdateClusterNameInput;
}>;


export type UpdateClusterNameMutation = { __typename?: 'Mutation', updateClusterName: { __typename?: 'Cluster', id: string, name?: string | null, courseIds?: Array<string> | null } };

export type AddClusterToStudentsMutationVariables = Exact<{
  input: AddClusterToStudentsInput;
}>;


export type AddClusterToStudentsMutation = { __typename?: 'Mutation', addClusterToStudents: Array<{ __typename?: 'Student', id: string, name: string, email: string, phno: string, dob: string, placeOfResidence: string, assignmentIds: Array<string>, courseIds: Array<string>, isInviteSend: boolean }> };

export type RemoveClusterFromStudentsMutationVariables = Exact<{
  input: RemoveClusterFromStudentsInput;
}>;


export type RemoveClusterFromStudentsMutation = { __typename?: 'Mutation', removeClusterFromStudents: Array<{ __typename?: 'Student', id: string, name: string, email: string, phno: string, dob: string, placeOfResidence: string, assignmentIds: Array<string>, courseIds: Array<string>, clusterIds: Array<string>, isInviteSend: boolean }> };

export type SubmitCodeMutationVariables = Exact<{
  compilerCodeInput: CompilerInput;
  submitInput: SubmitInput;
}>;


export type SubmitCodeMutation = { __typename?: 'Mutation', submitCode: { __typename?: 'CompilerOutput', compilationOutput?: { __typename?: 'CompilationOutput', stdout: string, stderr: string } | null, submissions: Array<{ __typename?: 'SubmissionDetail', code: string, score: number, submittedAt: any, language?: string | null }>, testCasePassed?: { __typename?: 'TestCaseDetails', count: number, testCaseIds: Array<{ __typename?: 'TestCaseOutputFormat', testCaseId: number, stdout?: string | null }> } | null, testCaseFailed?: { __typename?: 'TestCaseDetails', count: number, testCaseIds: Array<{ __typename?: 'TestCaseOutputFormat', testCaseId: number, stdout?: string | null }> } | null, Results: Array<{ __typename?: 'CompilationResults', input: string, output: string, expextedOutput: string, error: string }> } };

export type AddStaffToClusterMutationVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  staffs: Array<UpdateStaffInput> | UpdateStaffInput;
}>;


export type AddStaffToClusterMutation = { __typename?: 'Mutation', addStaffToCluster: Array<{ __typename?: 'StaffResponse', added: boolean, staff?: { __typename?: 'StaffType', id: string, email: string, name: string, designation?: string | null } | null }> };

export type RemoveStaffFromClusterMutationVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  staffIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RemoveStaffFromClusterMutation = { __typename?: 'Mutation', removeStaffFromCluster: Array<{ __typename?: 'RemoveStaffResponse', staffId: string, removed: boolean }> };

export type ToggleSendEmailMutationVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  sendEmail: Scalars['Boolean']['input'];
}>;


export type ToggleSendEmailMutation = { __typename?: 'Mutation', toggleSendEmail: { __typename?: 'Cluster', sendEmail?: boolean | null } };

export type ToggleAssessmentMailMutationVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  isAssessmentMail: Scalars['Boolean']['input'];
}>;


export type ToggleAssessmentMailMutation = { __typename?: 'Mutation', toggleAssessmentMail: { __typename?: 'Cluster', id: string, name?: string | null, isAssessmentMail?: boolean | null, sendEmail?: boolean | null } };

export type SendEmailMutationVariables = Exact<{
  emailInput: EmailInput;
}>;


export type SendEmailMutation = { __typename?: 'Mutation', sendEmail: string };

export type CreateAssignmentMutationVariables = Exact<{
  createAssignmentInput: CreateAssignmentInput;
}>;


export type CreateAssignmentMutation = { __typename?: 'Mutation', createAssignment: { __typename?: 'Assignment', _id: string, id?: string | null, name: string, short_description?: string | null, description: string, start_time?: any | null, due_date?: any | null, duration?: number | null, languages: Array<string>, domain?: string | null, updatedBy?: string | null, updatedAt?: any | null, createdBy?: string | null, createdAt?: any | null } };

export type UpdateAssignmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateAssignmentInput: UpdateAssignmentInput;
}>;


export type UpdateAssignmentMutation = { __typename?: 'Mutation', updateAssignment: { __typename?: 'Assignment', _id: string, id?: string | null, name: string, short_description?: string | null, description: string, start_time?: any | null, due_date?: any | null, duration?: number | null, languages: Array<string>, domain?: string | null, updatedBy?: string | null, updatedAt?: any | null, createdBy?: string | null, createdAt?: any | null } };

export type CreateBulkAssignmentQuestionsMutationVariables = Exact<{
  createQuestionsInput: Array<CreateAssignmentQuestionInput> | CreateAssignmentQuestionInput;
}>;


export type CreateBulkAssignmentQuestionsMutation = { __typename?: 'Mutation', createBulkAssignmentQuestions: Array<{ __typename?: 'AssignmentQuestion', id: string, assignment_id: string, title: string, text: string, question_sub_text?: string | null, marks: string, showFunctionOnly?: boolean | null, targetFunctionName?: string | null, difficulty: string, hints: Array<string>, tags: Array<string>, company_tags: Array<string>, updated_by: string, updated_at: any, created_by: string, created_at: any, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, predefinedCode?: { __typename?: 'PredefinedLanguages', c: string, java: string, python: string, cpp: string } | null }> };

export type CreateAssignmentQuestionMutationVariables = Exact<{
  createQuestionInput: CreateAssignmentQuestionInput;
}>;


export type CreateAssignmentQuestionMutation = { __typename?: 'Mutation', createAssignmentQuestion: { __typename?: 'AssignmentQuestion', id: string, assignment_id: string, title: string, text: string, question_sub_text?: string | null, marks: string, showFunctionOnly?: boolean | null, targetFunctionName?: string | null, difficulty: string, hints: Array<string>, tags: Array<string>, company_tags: Array<string>, updated_by: string, updated_at: any, created_by: string, created_at: any, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, predefinedCode?: { __typename?: 'PredefinedLanguages', c: string, java: string, python: string, cpp: string } | null } };

export type UpdateAssignmentQuestionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateQuestionInput: UpdateAssignmentQuestionInput;
}>;


export type UpdateAssignmentQuestionMutation = { __typename?: 'Mutation', updateAssignmentQuestion: { __typename?: 'AssignmentQuestion', id: string, assignment_id: string, title: string, text: string, question_sub_text?: string | null, marks: string, showFunctionOnly?: boolean | null, targetFunctionName?: string | null, difficulty: string, hints: Array<string>, tags: Array<string>, company_tags: Array<string>, updated_by: string, updated_at: any, created_by: string, created_at: any, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, predefinedCode?: { __typename?: 'PredefinedLanguages', c: string, java: string, python: string, cpp: string } | null } };

export type DeleteAssignmentQuestionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAssignmentQuestionMutation = { __typename?: 'Mutation', deleteAssignmentQuestion: boolean };

export type RemoveAssignmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
}>;


export type RemoveAssignmentMutation = { __typename?: 'Mutation', removeAssignement: boolean };

export type RemoveAssignmentFromStudentMutationVariables = Exact<{
  removeAssignmentInput: RemoveAssignmentInput;
}>;


export type RemoveAssignmentFromStudentMutation = { __typename?: 'Mutation', removeAssignmentFromStudent: { __typename?: 'Student', id: string, name: string, email: string, assignmentIds: Array<string> } };

export type SubmitAssignmentCodeMutationVariables = Exact<{
  assignmentCompilerCodeInput: CompilerInput;
  assignmentSubmitInput: AssignmentSubmitInput;
}>;


export type SubmitAssignmentCodeMutation = { __typename?: 'Mutation', submitAssignmentCode: { __typename?: 'CompilerOutput', compilationOutput?: { __typename?: 'CompilationOutput', stdout: string, stderr: string } | null, testCasePassed?: { __typename?: 'TestCaseDetails', count: number, testCaseIds: Array<{ __typename?: 'TestCaseOutputFormat', testCaseId: number, stdout?: string | null }> } | null, testCaseFailed?: { __typename?: 'TestCaseDetails', count: number, testCaseIds: Array<{ __typename?: 'TestCaseOutputFormat', testCaseId: number, stdout?: string | null }> } | null, Results: Array<{ __typename?: 'CompilationResults', input: string, output: string, expextedOutput: string, error: string }> } };

export type FinalSubmitAssignmentMutationVariables = Exact<{
  AssignmentInput: AssignmentInput;
}>;


export type FinalSubmitAssignmentMutation = { __typename?: 'Mutation', finalSubmitAssignment: { __typename?: 'AssignmentSubmit', id?: string | null, assignment_id?: string | null, student_id?: string | null, totalScore?: number | null, tabSwitches?: number | null, cheat_count?: number | null, completed?: boolean | null, questions?: Array<{ __typename?: 'QuestionSubmission', question_id: string, answer: string, score: number, language: string }> | null } };

export type DeleteBulkStudentsMutationVariables = Exact<{
  studentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  campusName: Scalars['String']['input'];
}>;


export type DeleteBulkStudentsMutation = { __typename?: 'Mutation', deleteBulkStudents: { __typename?: 'BulkDeleteStudentsResponse', successCount: number, failedCount: number, deletedEmails: Array<string>, message?: string | null, failedStudents: Array<{ __typename?: 'BulkDeleteFailedStudent', email: string, studentId?: string | null, reason: string }> } };

export type AddQuestionsToCourseMutationVariables = Exact<{
  courseId: Scalars['String']['input'];
  questionIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddQuestionsToCourseMutation = { __typename?: 'Mutation', addQuestionsToCourse: { __typename?: 'Course', id?: string | null, name: string, short_description?: string | null, description: string, price: number, time_period?: number | null, languages: Array<string>, level?: string | null, domain: string, question_ids?: Array<string> | null, easy_count: number, hard_count: number, medium_count: number, categories?: Array<{ __typename?: 'Category', id: string, name: string, description: string }> | null } };

export type RemoveAssignmentFromClusterMutationVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;


export type RemoveAssignmentFromClusterMutation = { __typename?: 'Mutation', removeAssignmentFromCluster: { __typename?: 'Cluster', courseIds?: Array<string> | null, studentCount: number } };

export type UpdateAdminMutationVariables = Exact<{
  updateAdminInput: UpdateAdminInput;
}>;


export type UpdateAdminMutation = { __typename?: 'Mutation', updateAdmin: { __typename?: 'Admin', id: string, name: string, email: string, isSuperAdmin?: boolean | null, permissions?: { __typename?: 'Permissions', courses?: Array<string> | null, assignments?: Array<string> | null, reports?: boolean | null, student_creation?: boolean | null } | null } };

export type CreateFolderMutationVariables = Exact<{
  createFolderDto: CreateFolderDto;
}>;


export type CreateFolderMutation = { __typename?: 'Mutation', createFolder: { __typename: 'Assignment_Folders', _id: string, id?: string | null, name: string, assignments: Array<string> } };

export type CreateReportMessageMutationVariables = Exact<{
  input: CreateReportMessageInput;
}>;


export type CreateReportMessageMutation = { __typename?: 'Mutation', createReportMessage: { __typename?: 'ReportMessage', id: string, createdAt: any, updatedAt: any, ranges: Array<{ __typename?: 'ReportMessageRange', rangeLabel: string, entries: Array<{ __typename?: 'ReportMessageEntry', campusName: string, message: string, greeting: string }> }> } };

export type UpsertMessageInRangeMutationVariables = Exact<{
  input: UpsertMessageInRangeInput;
}>;


export type UpsertMessageInRangeMutation = { __typename?: 'Mutation', upsertMessageInRange: { __typename?: 'ReportMessage', id: string, updatedAt: any, ranges: Array<{ __typename?: 'ReportMessageRange', rangeLabel: string, entries: Array<{ __typename?: 'ReportMessageEntry', campusName: string, message: string, greeting: string }> }> } };

export type CreateRangeLevelMutationVariables = Exact<{
  input: CreateRangeLevelInput;
}>;


export type CreateRangeLevelMutation = { __typename?: 'Mutation', createRangeLevel: { __typename?: 'ReportMessage', id: string, ranges: Array<{ __typename?: 'ReportMessageRange', rangeLabel: string, entries: Array<{ __typename?: 'ReportMessageEntry', campusName: string, message: string, greeting: string }> }> } };

export type UpdateRangeLevelMutationVariables = Exact<{
  input: UpdateRangeLevelInput;
}>;


export type UpdateRangeLevelMutation = { __typename?: 'Mutation', updateRangeLevel: { __typename?: 'ReportMessage', id: string, ranges: Array<{ __typename?: 'ReportMessageRange', rangeLabel: string, entries: Array<{ __typename?: 'ReportMessageEntry', campusName: string, message: string, greeting: string }> }> } };

export type DeleteRangeLevelMutationVariables = Exact<{
  input: DeleteRangeLevelInput;
}>;


export type DeleteRangeLevelMutation = { __typename?: 'Mutation', deleteRangeLevel: { __typename?: 'ReportMessage', id: string, ranges: Array<{ __typename?: 'ReportMessageRange', rangeLabel: string, entries: Array<{ __typename?: 'ReportMessageEntry', campusName: string, message: string, greeting: string }> }> } };

export type DeleteMessageInRangeMutationVariables = Exact<{
  input: DeleteMessageInRangeInput;
}>;


export type DeleteMessageInRangeMutation = { __typename?: 'Mutation', deleteMessageInRange: { __typename?: 'ReportMessage', id: string, ranges: Array<{ __typename?: 'ReportMessageRange', rangeLabel: string, entries: Array<{ __typename?: 'ReportMessageEntry', campusName: string, message: string, greeting: string }> }> } };

export type GetAllRangeLevelsMutationVariables = Exact<{ [key: string]: never; }>;


export type GetAllRangeLevelsMutation = { __typename?: 'Mutation', getAllRangeLevels: Array<string> };

export type UpdateFolderMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateFolderDto: UpdateFolderDto;
}>;


export type UpdateFolderMutation = { __typename?: 'Mutation', updateFolder: { __typename: 'Assignment_Folders', _id: string, id?: string | null, name: string, assignments: Array<string> } };

export type DeleteFolderMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteFolderMutation = { __typename?: 'Mutation', deleteFolder: boolean };

export type RemoveAssignementMutationVariables = Exact<{
  id: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
}>;


export type RemoveAssignementMutation = { __typename?: 'Mutation', removeAssignement: boolean };

export type SaveAutoSaveMutationVariables = Exact<{
  submitInput: SubmitInput;
  code: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type SaveAutoSaveMutation = { __typename?: 'Mutation', saveAutoSave: string };

export type SaveAssignmentCodeMutationVariables = Exact<{
  saveCodeInput: AssignmentSubmitInput;
  code: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type SaveAssignmentCodeMutation = { __typename?: 'Mutation', saveAssignmentCode: string };

export type AddAssignmentToClusterMutationVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  isEmail: Scalars['Boolean']['input'];
}>;


export type AddAssignmentToClusterMutation = { __typename?: 'Mutation', addAssignmentToCluster: { __typename: 'Cluster', id: string, name?: string | null, campusName?: string | null, courseIds?: Array<string> | null, assignmentIds?: Array<string> | null, createdAt?: any | null, studentCount: number, sendEmail?: boolean | null, staffs?: Array<{ __typename?: 'StaffType', id: string, name: string, email: string, campusId?: string | null, designation?: string | null, contactNo?: string | null, clusterIds?: Array<string> | null, isInviteSend: boolean, isAdminStaff?: boolean | null }> | null } };

export type CreateRazorpayOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  courseId: Scalars['String']['input'];
}>;


export type CreateRazorpayOrderMutation = { __typename?: 'Mutation', createRazorpayOrder: string };

export type SavePaymentDetailsMutationVariables = Exact<{
  createPaymentInput: CreatePaymentInput;
}>;


export type SavePaymentDetailsMutation = { __typename?: 'Mutation', savePaymentDetails: { __typename: 'Payment', id: string, student_id: string, course_id: string, order_id: string, payment_id: string, amount_paid: number, date_of_purchase: any } };

export type ModuleSubmitCodeMutationVariables = Exact<{
  compilerCodeInput: CompilerInput;
  moduleSubmitInput: ModuleSubmitInput;
}>;


export type ModuleSubmitCodeMutation = { __typename?: 'Mutation', modulesubmitCode: { __typename?: 'CompilerOutput', compilationOutput?: { __typename?: 'CompilationOutput', stdout: string, stderr: string } | null, submissions: Array<{ __typename?: 'SubmissionDetail', code: string, score: number, submittedAt: any, language?: string | null }>, testCasePassed?: { __typename?: 'TestCaseDetails', count: number, testCaseIds: Array<{ __typename?: 'TestCaseOutputFormat', testCaseId: number, stdout?: string | null }> } | null, testCaseFailed?: { __typename?: 'TestCaseDetails', count: number, testCaseIds: Array<{ __typename?: 'TestCaseOutputFormat', testCaseId: number, stdout?: string | null }> } | null, Results: Array<{ __typename?: 'CompilationResults', input: string, output: string, error: string }> } };

export type ModuleAutoSaveMutationVariables = Exact<{
  moduleSubmitInput: ModuleSubmitInput;
  code: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type ModuleAutoSaveMutation = { __typename?: 'Mutation', ModuleAutoSave: string };

export type DeleteCronJobsMutationVariables = Exact<{
  jobIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteCronJobsMutation = { __typename?: 'Mutation', deleteCronJobs: Array<string> };

export type TriggerCronReportsMutationVariables = Exact<{
  jobIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type TriggerCronReportsMutation = { __typename?: 'Mutation', triggerCronReports: string };

export type UpdateModuleMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: ModuleInput;
}>;


export type UpdateModuleMutation = { __typename?: 'Mutation', updateModule: { __typename?: 'ModuleEntity', _id: string, name: string, short_description: string, start_date: string, end_date: string, domain: string, daywise_plan?: Array<{ __typename?: 'ModuleAssignment', day_id?: string | null, name: string, questions: Array<string>, createdAt: any, updatedAt?: any | null }> | null } };

export type RevokeAssignmentMutationVariables = Exact<{
  assignmentId: Scalars['String']['input'];
  studentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
}>;


export type RevokeAssignmentMutation = { __typename?: 'Mutation', revokeAssignment: { __typename?: 'AssignmentCompletionStatus', Status?: boolean | null, revokedCount?: number | null } };

export type RecalculateClusterCountsMutationVariables = Exact<{
  campusName: Scalars['String']['input'];
}>;


export type RecalculateClusterCountsMutation = { __typename?: 'Mutation', recalculateClusterStudentCounts: string };

export type GetAllModulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllModulesQuery = { __typename?: 'Query', getAllModules: Array<{ __typename?: 'ModuleEntity', _id: string, name: string, domain: string, short_description: string, start_date: string, end_date: string, daywise_plan?: Array<{ __typename?: 'ModuleAssignment', name: string, questions: Array<string>, createdAt: any, updatedAt?: any | null }> | null }> };

export type GetClusterDetailsQueryVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
}>;


export type GetClusterDetailsQuery = { __typename?: 'Query', getCluster: { __typename?: 'Cluster', id: string, name?: string | null, campusName?: string | null, moduleIds?: Array<string> | null } };

export type GetModuleQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetModuleQuery = { __typename?: 'Query', getModule: { __typename?: 'ModuleEntity', _id: string, name: string, domain: string, short_description: string } };

export type GetCampusQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCampusQuery = { __typename?: 'Query', campus: { __typename?: 'Campus', id: string, name: string } };

export type GetAllCampusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCampusesQuery = { __typename?: 'Query', allCampus: Array<{ __typename?: 'Campus', id: string, name: string }> };

export type GetAllAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAdminQuery = { __typename?: 'Query', getAllAdmin: Array<{ __typename?: 'Admin', id: string, name: string, email: string, isSuperAdmin?: boolean | null, permissions?: { __typename?: 'Permissions', courses?: Array<string> | null, assignments?: Array<string> | null, reports?: boolean | null, student_creation?: boolean | null } | null }> };

export type GetAllStaffsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStaffsQuery = { __typename?: 'Query', getAllStaffs: Array<{ __typename?: 'StaffType', id: string, name: string, email: string, campusId?: string | null }> };

export type GetClustersByCampusQueryVariables = Exact<{
  campusName: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetClustersByCampusQuery = { __typename?: 'Query', getClustersByCampus: Array<{ __typename?: 'Cluster', id: string, name?: string | null, studentCount: number }> };

export type GetStudentsByClusterQueryVariables = Exact<{
  clusterId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStudentsByClusterQuery = { __typename?: 'Query', getStudentsByCluster: Array<{ __typename?: 'Student', id: string, name: string, email: string, department?: string | null, phno: string, dob: string, rollNo: string, placeOfResidence: string, leetCodeUname: string, hackerRankUname: string, campusId: string, assignmentIds: Array<string>, clusterIds: Array<string>, courseIds: Array<string>, isInviteSend: boolean }> };

export type GetStaffsByCampusQueryVariables = Exact<{
  campusId: Scalars['String']['input'];
}>;


export type GetStaffsByCampusQuery = { __typename?: 'Query', getStaffsByCampus: Array<{ __typename?: 'StaffType', id: string, name: string, email: string, campusId?: string | null, designation?: string | null, contactNo?: string | null, isInviteSend: boolean, clusterIds?: Array<string> | null, isAdminStaff?: boolean | null, mailAutomation?: boolean | null, mailSettings?: { __typename?: 'MailSettings', frequency: string, studentFilter: string } | null }> };

export type GetStaffByEmailIdQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetStaffByEmailIdQuery = { __typename?: 'Query', getStaffByEmailId: { __typename?: 'StaffType', id: string, name: string, email: string, designation?: string | null, contactNo?: string | null, campusId?: string | null, isInviteSend: boolean, isAdminStaff?: boolean | null, clusterIds?: Array<string> | null, mailAutomation?: boolean | null, mailSettings?: { __typename?: 'MailSettings', frequency: string, studentFilter: string } | null } };

export type GetStudentByEmailIdQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetStudentByEmailIdQuery = { __typename?: 'Query', getStudentByEmailId: { __typename?: 'Student', id: string, name: string, email: string, personalEmail?: string | null, phno: string, dob: string, rollNo: string, department?: string | null, campusId: string, leetCodeUname: string, hackerRankUname: string, placeOfResidence: string, assignmentIds: Array<string>, courseIds: Array<string>, clusterIds: Array<string>, completedQuestions?: Array<string> | null, purchasedCourses?: Array<{ __typename?: 'PurchasedCourse', course_id: string, cluster_id: string } | null> | null } };

export type GetStaffQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetStaffQuery = { __typename?: 'Query', getStaff: { __typename?: 'StaffType', id: string, name: string, email: string, campusId?: string | null } };

export type GetAllStudentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStudentsQuery = { __typename?: 'Query', getAllStudents: Array<{ __typename?: 'Student', id: string, name: string, email: string, phno: string, dob: string, placeOfResidence: string, assignmentIds: Array<string>, courseIds: Array<string> }> };

export type GetStudentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetStudentQuery = { __typename?: 'Query', getStudent?: { __typename?: 'Student', id: string, name: string, email: string, phno: string, dob: string, rollNo: string, campusId: string, leetCodeUname: string, hackerRankUname: string, placeOfResidence: string, assignmentIds: Array<string>, courseIds: Array<string>, clusterIds: Array<string>, completedQuestions?: Array<string> | null, purchasedCourses?: Array<{ __typename?: 'PurchasedCourse', course_id: string, cluster_id: string } | null> | null } | null };

export type GetStudentsByCampusQueryVariables = Exact<{
  campusId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  clusterid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStudentsByCampusQuery = { __typename?: 'Query', getStudentsByCampus: { __typename?: 'GetStudentsByCampusResponseType', total: number, students: Array<{ __typename?: 'Student', id: string, name: string, email: string, rollNo: string, department?: string | null, phno: string, leetCodeUname: string, hackerRankUname: string, dob: string, placeOfResidence: string, campusId: string, isInviteSend: boolean, assignmentIds: Array<string>, clusterIds: Array<string>, purchasedCourses?: Array<{ __typename?: 'PurchasedCourse', course_id: string, cluster_id: string } | null> | null }> } };

export type GetLeetcodeDataQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type GetLeetcodeDataQuery = { __typename?: 'Query', leetcodeData: { __typename?: 'LeetcodeData', allQuestionsCount?: Array<{ __typename?: 'AllQuestionsCount', difficulty?: string | null, count: number }> | null, matchedUser?: { __typename?: 'MatchedUser', username?: string | null, githubUrl?: string | null, twitterUrl?: string | null, linkedinUrl?: string | null, submissionCalendar?: string | null, contributions?: { __typename?: 'Contributions', points: number, questionCount: number, testcaseCount: number } | null, profile?: { __typename?: 'Profile', realName?: string | null, userAvatar?: string | null, birthday?: string | null, ranking: number, reputation: number, websites: Array<string>, countryName?: string | null, company?: string | null, school?: string | null, skillTags?: Array<string> | null, aboutMe?: string | null, starRating?: number | null } | null, badges?: Array<{ __typename?: 'Badge', id?: string | null, displayName?: string | null, icon?: string | null, creationDate?: string | null }> | null, upcomingBadges?: Array<{ __typename?: 'UpcomingBadge', name?: string | null, icon?: string | null }> | null, activeBadge?: { __typename?: 'Badge', id?: string | null, displayName?: string | null, icon?: string | null, creationDate?: string | null } | null, submitStats?: { __typename?: 'SubmitStats', totalSubmissionNum?: Array<{ __typename?: 'SubmitStatsNum', difficulty?: string | null, count?: number | null, submissions?: number | null }> | null, acSubmissionNum?: Array<{ __typename?: 'SubmitStatsNum', difficulty?: string | null, count?: number | null, submissions?: number | null }> | null } | null } | null, recentSubmissionList?: Array<{ __typename?: 'RecentSubmission', title?: string | null, titleSlug?: string | null, timestamp?: string | null, statusDisplay?: string | null, lang?: string | null }> | null } };

export type GetAllCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCoursesQuery = { __typename?: 'Query', getAllCourses: Array<{ __typename?: 'Course', id?: string | null, name: string, short_description?: string | null, description: string, price: number, level?: string | null, time_period?: number | null, languages: Array<string>, domain: string, benefits?: Array<string> | null, question_ids?: Array<string> | null, updatedBy?: string | null, updatedAt?: any | null, createdBy?: string | null, createdAt?: any | null, categories?: Array<{ __typename?: 'Category', id: string, name: string, description: string }> | null }> };

export type GetCourseQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCourseQuery = { __typename?: 'Query', getCourse: { __typename?: 'Course', _id: string, id?: string | null, name: string, question_ids?: Array<string> | null, short_description?: string | null, description: string, easy_count: number, medium_count: number, hard_count: number, price: number, companies?: Array<string> | null, benefits?: Array<string> | null, whyChoose?: string | null, dis_price?: number | null, time_period?: number | null, languages: Array<string>, domain: string, level?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string, description: string }> | null } };

export type FindAllQuestionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  difficulties?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  searchName?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type FindAllQuestionsQuery = { __typename?: 'Query', findAllQuestions: Array<{ __typename?: 'Question', id: string, title: string, text: string, question_sub_text?: string | null, marks: string, difficulty: string, hints: Array<string>, tags: Array<string>, showFunctionOnly?: boolean | null, targetFunctionName?: string | null, company_tags: Array<string>, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, predefinedCode?: { __typename?: 'PredefinedLanguages', c: string, java: string, python: string, cpp: string } | null }> };

export type GetAllQuestionQueryVariables = Exact<{
  courseId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  categoryId: Scalars['String']['input'];
}>;


export type GetAllQuestionQuery = { __typename?: 'Query', getAllQuestion: { __typename?: 'QuestionResponse', totalCount: number, questions: Array<{ __typename?: 'Question', id: string, course_id: string, assignment_ids?: Array<string> | null, title: string, text: string, question_sub_text?: string | null, marks: string, difficulty: string, hints: Array<string>, tags: Array<string>, company_tags: Array<string>, createdBy?: string | null, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, category: { __typename?: 'QuestionCategory', name: string, id: string } }> } };

export type GetQuestionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetQuestionQuery = { __typename?: 'Query', getQuestion: { __typename?: 'Question', id: string, course_id: string, assignment_ids?: Array<string> | null, title: string, text: string, question_sub_text?: string | null, marks: string, difficulty: string, hints: Array<string>, tags: Array<string>, showFunctionOnly?: boolean | null, targetFunctionName?: string | null, company_tags: Array<string>, updated_by?: string | null, updated_at: any, created_by?: string | null, created_at: any, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, category: { __typename?: 'QuestionCategory', name: string, id: string }, predefinedCode?: { __typename?: 'PredefinedLanguages', c: string, java: string, python: string, cpp: string } | null } };

export type GetQuestionsByTagsQueryVariables = Exact<{
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetQuestionsByTagsQuery = { __typename?: 'Query', getQuestionsByTags: Array<{ __typename?: 'Question', id: string, course_id: string, assignment_ids?: Array<string> | null, title: string, text: string, question_sub_text?: string | null, marks: string, difficulty: string, hints: Array<string>, tags: Array<string>, company_tags: Array<string>, updated_by?: string | null, updated_at: any, created_by?: string | null, created_at: any, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, category: { __typename?: 'QuestionCategory', name: string, id: string } }> };

export type GetCoursesByStudentEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetCoursesByStudentEmailQuery = { __typename?: 'Query', getCoursesByStudentEmail: Array<{ __typename?: 'Course', _id: string, id?: string | null, name: string, short_description?: string | null, description: string, price: number, time_period?: number | null, languages: Array<string>, domain: string, categories?: Array<{ __typename?: 'Category', id: string, name: string, description: string }> | null }> };

export type GetAllCoursesByClusterQueryVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
}>;


export type GetAllCoursesByClusterQuery = { __typename?: 'Query', getAllCoursesByCluster: Array<{ __typename?: 'Course', _id: string, id?: string | null, name: string, short_description?: string | null, description: string, price: number, companies?: Array<string> | null, benefits?: Array<string> | null, whyChoose?: string | null, dis_price?: number | null, question_ids?: Array<string> | null, level?: string | null, time_period?: number | null, languages: Array<string>, domain: string, easy_count: number, hard_count: number, medium_count: number, categories?: Array<{ __typename?: 'Category', id: string, name: string, description: string }> | null }> };

export type GetClusterQueryVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
}>;


export type GetClusterQuery = { __typename?: 'Query', getCluster: { __typename?: 'Cluster', id: string, name?: string | null, courseIds?: Array<string> | null, studentCount: number, createdAt?: any | null, sendEmail?: boolean | null, isAssessmentMail?: boolean | null, staffs?: Array<{ __typename?: 'StaffType', id: string, name: string, email: string }> | null } };

export type CompileCodeQueryVariables = Exact<{
  compileCodeInput: CompilerInput;
}>;


export type CompileCodeQuery = { __typename?: 'Query', compileCode: { __typename?: 'CompilerOutput', compilationOutput?: { __typename?: 'CompilationOutput', stdout: string, stderr: string } | null, testCasePassed?: { __typename?: 'TestCaseDetails', count: number, testCaseIds: Array<{ __typename?: 'TestCaseOutputFormat', testCaseId: number, stdout?: string | null }> } | null, testCaseFailed?: { __typename?: 'TestCaseDetails', count: number, testCaseIds: Array<{ __typename?: 'TestCaseOutputFormat', testCaseId: number, stdout?: string | null }> } | null, Results: Array<{ __typename?: 'CompilationResults', input: string, output: string, expextedOutput: string, error: string }> } };

export type GetCampusByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetCampusByNameQuery = { __typename?: 'Query', getCampusByName: { __typename?: 'Campus', id: string, name: string } };

export type GetClustersByIdsAndCampusQueryVariables = Exact<{
  clusterIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  campusName: Scalars['String']['input'];
}>;


export type GetClustersByIdsAndCampusQuery = { __typename?: 'Query', getClustersByIdsAndCampus: Array<{ __typename?: 'Cluster', id: string, name?: string | null, courseIds?: Array<string> | null, createdAt?: any | null, studentCount: number }> };

export type GetLeaderboardQueryVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLeaderboardQuery = { __typename?: 'Query', getLeaderboard: Array<{ __typename?: 'LeaderBoardResponse', student_id: string, totalScore: number, department?: string | null, completedQuestions: number, latestSubmissionDate?: any | null, position: number, easyQuestionsCompleted?: number | null, hardQuestionCompleted?: number | null, mediumQuestionsCompleted?: number | null, student?: { __typename?: 'Student', id: string, name: string, email: string, rollNo: string, phno: string, dob: string, completedQuestions?: Array<string> | null, leetCodeUname: string } | null, courseBreakdown?: Array<{ __typename?: 'CourseBreakdownItem', courseId?: string | null, courseName?: string | null, completedQuestions: number, totalQuestions: number }> | null, leetcode_data?: Array<{ __typename?: 'LeetCodeQuestionCount', difficulty: string, count: number, submissions: number }> | null }> };

export type GetQuestionCompletedQueryVariables = Exact<{
  student_id: Scalars['String']['input'];
  is_paid: Scalars['Boolean']['input'];
}>;


export type GetQuestionCompletedQuery = { __typename?: 'Query', getQuestionCompleted: { __typename?: 'QuestionCompletionResult', easy: { __typename?: 'QuestionCount', completed: number, total: number }, medium: { __typename?: 'QuestionCount', completed: number, total: number }, hard: { __typename?: 'QuestionCount', completed: number, total: number }, overall: { __typename?: 'QuestionCount', completed: number, total: number } } };

export type GetDashboardCourseDetailsQueryVariables = Exact<{
  student_id: Scalars['String']['input'];
  is_paid: Scalars['Boolean']['input'];
}>;


export type GetDashboardCourseDetailsQuery = { __typename?: 'Query', getDashboardCourseDetails: { __typename: 'DashboardCourseDetails', courseDetails: Array<{ __typename?: 'CourseDetails', courseId: string, courseName?: string | null, level?: string | null, completedQuestion: string, totalQuestion: string, percentageCompleted: number }> } };

export type GetLastFiveSubmissionsQueryVariables = Exact<{
  submitInput: SubmitInput;
}>;


export type GetLastFiveSubmissionsQuery = { __typename?: 'Query', getLastFiveSubmissions: { __typename?: 'Submit', id: string, student_id: string, course_id: string, cluster_id: string, question_id: string, max_score?: number | null, is_completed?: boolean | null, autosave?: { __typename?: 'SubmissionDetail', id: string, code: string, score: number, submittedAt: any, language?: string | null } | null, submissions: Array<{ __typename?: 'SubmissionDetail', id: string, code: string, score: number, submittedAt: any, language?: string | null }> } };

export type GetAllAssignmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAssignmentsQuery = { __typename?: 'Query', getAllAssignments: Array<{ __typename?: 'Assignment', _id: string, id?: string | null, name: string, short_description?: string | null, description: string, start_time?: any | null, due_date?: any | null, duration?: number | null, languages: Array<string>, domain?: string | null, updatedBy?: string | null, updatedAt?: any | null, createdBy?: string | null, createdAt?: any | null }> };

export type GetAssignmentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAssignmentQuery = { __typename?: 'Query', getAssignment: { __typename?: 'Assignment', _id: string, id?: string | null, name: string, short_description?: string | null, description: string, start_time?: any | null, due_date?: any | null, duration?: number | null, languages: Array<string>, max_cheat_count?: number | null, max_tabSwitches?: number | null, enable_proctoring?: boolean | null, domain?: string | null, updatedBy?: string | null, updatedAt?: any | null, createdBy?: string | null, createdAt?: any | null } };

export type GetAllAssignmentQuestionQueryVariables = Exact<{
  assignmentId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllAssignmentQuestionQuery = { __typename?: 'Query', getAllAssignmentQuestion: Array<{ __typename?: 'AssignmentQuestion', id: string, assignment_id: string, title: string, text: string, question_sub_text?: string | null, marks: string, showFunctionOnly?: boolean | null, targetFunctionName?: string | null, difficulty: string, hints: Array<string>, tags: Array<string>, company_tags: Array<string>, updated_by: string, updated_at: any, created_by: string, created_at: any, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, predefinedCode?: { __typename?: 'PredefinedLanguages', c: string, java: string, python: string, cpp: string } | null }> };

export type GetAssignmentQuestionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAssignmentQuestionQuery = { __typename?: 'Query', getAssignmentQuestion: { __typename?: 'AssignmentQuestion', id: string, assignment_id: string, title: string, text: string, question_sub_text?: string | null, marks: string, showFunctionOnly?: boolean | null, targetFunctionName?: string | null, difficulty: string, hints: Array<string>, tags: Array<string>, company_tags: Array<string>, updated_by: string, updated_at: any, created_by: string, created_at: any, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, predefinedCode?: { __typename?: 'PredefinedLanguages', c: string, java: string, python: string, cpp: string } | null } };

export type GetAssignmentQuestionsByTagsQueryVariables = Exact<{
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetAssignmentQuestionsByTagsQuery = { __typename?: 'Query', getAssignmentQuestionsByTags: Array<{ __typename?: 'AssignmentQuestion', id: string, assignment_id: string, title: string, text: string, question_sub_text?: string | null, marks: string, showFunctionOnly?: boolean | null, targetFunctionName?: string | null, difficulty: string, hints: Array<string>, tags: Array<string>, company_tags: Array<string>, updated_by: string, updated_at: any, created_by: string, created_at: any, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, predefinedCode?: { __typename?: 'PredefinedLanguages', c: string, java: string, python: string, cpp: string } | null }> };

export type GetStudentAndCampusDetailsByAssignmentIdQueryVariables = Exact<{
  assignmentId: Scalars['String']['input'];
}>;


export type GetStudentAndCampusDetailsByAssignmentIdQuery = { __typename?: 'Query', getStudentAndCampusDetailsByAssignmentId: Array<{ __typename?: 'StudentCampusDTO', student: { __typename?: 'Student', id: string, name: string, email: string, campusId: string, rollNo: string, assignmentIds: Array<string> }, campus: { __typename?: 'Campus', id: string, name: string } }> };

export type GetAssignmentsForStudentQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetAssignmentsForStudentQuery = { __typename?: 'Query', getAssignmentsForStudent: { __typename?: 'AssignmentStatusResult', completedAssignments: Array<{ __typename?: 'CompletedAssignment', endTime?: any | null, assignment: { __typename?: 'Assignment', id?: string | null, name: string, short_description?: string | null, start_time?: any | null, due_date?: any | null, duration?: number | null, createdAt?: any | null } }>, pendingAssignments: Array<{ __typename?: 'CompletedAssignment', endTime?: any | null, assignment: { __typename?: 'Assignment', id?: string | null, name: string, short_description?: string | null, start_time?: any | null, due_date?: any | null, duration?: number | null, createdAt?: any | null } }> } };

export type GetAssignmentSubmitQueryVariables = Exact<{
  assignmentId: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
}>;


export type GetAssignmentSubmitQuery = { __typename?: 'Query', getAssignmentSubmit?: { __typename?: 'AssignmentSubmit', id?: string | null, assignment_id?: string | null, cluster_id?: string | null, student_id?: string | null, totalScore?: number | null, tabSwitches?: number | null, cheat_count?: number | null, cheat_reasons?: string | null, endTime?: any | null, completed?: boolean | null, timeRemaining?: number | null, questions?: Array<{ __typename?: 'QuestionSubmission', question_id: string, answer: string, score: number, language: string }> | null, autosave?: Array<{ __typename?: 'QuestionSubmission', question_id: string, answer: string, score: number, language: string }> | null } | null };

export type GetModulesByClusterQueryVariables = Exact<{
  clusterId: Scalars['String']['input'];
  campusName: Scalars['String']['input'];
}>;


export type GetModulesByClusterQuery = { __typename?: 'Query', getModulesByCluster: Array<{ __typename?: 'ModuleForCluster', moduleID: string, enabled_dates: Array<any> }> };

export type GetStudentSubmissionsForMonthQueryVariables = Exact<{
  studentId: Scalars['String']['input'];
  campusName: Scalars['String']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
}>;


export type GetStudentSubmissionsForMonthQuery = { __typename?: 'Query', getStudentSubmissionsForMonth: Array<{ __typename?: 'SubmissionData', date: any, courseName?: string | null, submissions: Array<{ __typename?: 'Submission', submittedAt: any }> }> };

export type GetStudentSubmissionsForTimeRangeQueryVariables = Exact<{
  studentId: Scalars['String']['input'];
  campusName: Scalars['String']['input'];
  timeRangeInMonths: Scalars['Int']['input'];
}>;


export type GetStudentSubmissionsForTimeRangeQuery = { __typename?: 'Query', getStudentSubmissionsForTimeRange: Array<{ __typename?: 'SubmissionData', courseName?: string | null, date: any, submissions: Array<{ __typename?: 'Submission', submittedAt: any }> }> };

export type GetAssignmentLeaderBoardQueryVariables = Exact<{
  assignmentId: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
}>;


export type GetAssignmentLeaderBoardQuery = { __typename?: 'Query', getAssignmentLeaderBoard: Array<{ __typename: 'AssignmentLeaderBoard', assignment_id: string, totalScore: number, clusterNames: string, totalNumberOfQuestion: number, cheat_reasons?: string | null, position: number, student?: { __typename?: 'Student', id: string, name: string, email: string, campusId: string, rollNo: string, department?: string | null } | null, questions?: Array<{ __typename?: 'QuestionLeaderboard', questionId: string, score: number, AllotedTotalMarks: number }> | null }> };

export type FindAssignmentsForStudentWithFilterQueryVariables = Exact<{
  email: Scalars['String']['input'];
  filterType: Scalars['String']['input'];
  customDateRange?: InputMaybe<AssignmentFilterInput>;
}>;


export type FindAssignmentsForStudentWithFilterQuery = { __typename?: 'Query', findAssignmentsForStudentWithFilter: Array<{ __typename: 'Assignment', _id: string, id?: string | null, name: string, short_description?: string | null, description: string, start_time?: any | null, due_date?: any | null, languages: Array<string>, domain?: string | null, duration?: number | null, max_cheat_count?: number | null, max_tabSwitches?: number | null, enable_proctoring?: boolean | null, updatedBy?: string | null, updatedAt?: any | null, createdBy?: string | null, createdAt?: any | null }> };

export type AllCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCategoriesQuery = { __typename?: 'Query', allCategories: Array<{ __typename?: 'Categories', id?: string | null, name: string, description: string }> };

export type GetSubmissionQueryVariables = Exact<{
  campus_name: Scalars['String']['input'];
  assignment_id: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
}>;


export type GetSubmissionQuery = { __typename?: 'Query', getSubmission?: { __typename?: 'AssignmentSubmit', id?: string | null, assignment_id?: string | null, student_id?: string | null, completed?: boolean | null, cheat_reasons?: string | null, tabSwitches?: number | null, cheat_count?: number | null, totalScore?: number | null, endTime?: any | null, autosave?: Array<{ __typename?: 'QuestionSubmission', question_id: string, answer: string, score: number, language: string }> | null, questions?: Array<{ __typename?: 'QuestionSubmission', question_id: string, answer: string, score: number, language: string }> | null } | null };

export type GetQuestionsByCategoryQueryVariables = Exact<{
  categoryId: Scalars['String']['input'];
  courseId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetQuestionsByCategoryQuery = { __typename?: 'Query', getQuestionsByCategory: { __typename?: 'QuestionResponse', totalCount: number, questions: Array<{ __typename?: 'Question', id: string, course_id: string, assignment_ids?: Array<string> | null, title: string, text: string, question_sub_text?: string | null, marks: string, showFunctionOnly?: boolean | null, targetFunctionName?: string | null, difficulty: string, hints: Array<string>, tags: Array<string>, company_tags: Array<string>, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, category: { __typename?: 'QuestionCategory', id: string, name: string }, predefinedCode?: { __typename?: 'PredefinedLanguages', c: string, java: string, python: string, cpp: string } | null }> } };

export type GetAssignmentByClusterQueryVariables = Exact<{
  campusName: Scalars['String']['input'];
  clusterId: Scalars['String']['input'];
}>;


export type GetAssignmentByClusterQuery = { __typename?: 'Query', getAssignmentByCluster: Array<{ __typename?: 'Assignment', id?: string | null, name: string, short_description?: string | null, description: string, due_date?: any | null, languages: Array<string>, domain?: string | null, duration?: number | null }> };

export type GetAdminUsingEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetAdminUsingEmailQuery = { __typename?: 'Query', getAdminUsingEmail: { __typename?: 'Admin', id: string, name: string, email: string, isSuperAdmin?: boolean | null, permissions?: { __typename?: 'Permissions', courses?: Array<string> | null, assignments?: Array<string> | null, reports?: boolean | null, student_creation?: boolean | null } | null } };

export type GetStudentsResultsQueryVariables = Exact<{
  campusId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  clusterid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStudentsResultsQuery = { __typename?: 'Query', getStudentsResults: { __typename: 'StudentResults', total: number, students: Array<{ __typename?: 'StudentPersonalDetails', id: string, name: string, email: string, rollNo: string, department?: string | null, courseDetails: { __typename?: 'CourseResults', rewardPoints: string, courseDetails: Array<{ __typename?: 'CourseDetails', courseId: string, percentageCompleted: number, completedQuestion: string, totalQuestion: string }> }, assignmentDetails: Array<{ __typename?: 'AssignmentResults', assignment_id?: string | null, student_id?: string | null, totalScore?: number | null }> }> } };

export type GetAssignmentByCampusQueryVariables = Exact<{
  campusName: Scalars['String']['input'];
}>;


export type GetAssignmentByCampusQuery = { __typename?: 'Query', getAssignmentByCampus: Array<{ __typename: 'Assignment', _id: string, id?: string | null, name: string, short_description?: string | null, description: string, due_date?: any | null, languages: Array<string>, domain?: string | null, duration?: number | null, max_cheat_count?: number | null, max_tabSwitches?: number | null, enable_proctoring?: boolean | null, updatedBy?: string | null, updatedAt?: any | null, createdBy?: string | null, createdAt?: any | null }> };

export type StudentsNotAttendedAssignmentQueryVariables = Exact<{
  campus_id: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  cluster_id?: InputMaybe<Scalars['String']['input']>;
}>;


export type StudentsNotAttendedAssignmentQuery = { __typename?: 'Query', studentsNotAttendedAssignment: Array<{ __typename: 'StudentWithClusterInfo', student_name: string, student_id: string, cluster_names: string, student_rollno: string, student_email: string }> };

export type GetOrdersByStudentIdQueryVariables = Exact<{
  student_id: Scalars['String']['input'];
}>;


export type GetOrdersByStudentIdQuery = { __typename?: 'Query', getOrdersByStudentId: Array<{ __typename: 'OrderResponse', order_id: string, course_name: string, amount: string, payment_date: any }> };

export type GetCourseProgressQueryVariables = Exact<{
  studentId: Scalars['String']['input'];
  courseId: Scalars['String']['input'];
  isPaid: Scalars['Boolean']['input'];
}>;


export type GetCourseProgressQuery = { __typename?: 'Query', getCourseProgress: { __typename: 'CourseProgressResponse', courseId: string, courseName: string, level: string, completedQuestions: number, totalQuestions: number, percentageCompleted: number } };

export type GetCourseForStudentsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCourseForStudentsQuery = { __typename?: 'Query', getCourseForStudents: { __typename?: 'Course', easy_count: number, medium_count: number, hard_count: number, name: string, short_description?: string | null, price: number, companies?: Array<string> | null, benefits?: Array<string> | null, whyChoose?: string | null, dis_price?: number | null, time_period?: number | null, languages: Array<string>, domain: string, level?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string, description: string, questions?: Array<{ __typename?: 'RandomQuestion', id: string, title: string, difficulty: string }> | null }> | null } };

export type GetCourseDashboardDetailsQueryVariables = Exact<{
  course_id: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
}>;


export type GetCourseDashboardDetailsQuery = { __typename?: 'Query', getCourseDashboardDetails: { __typename?: 'CourseDashboardDetails', totalScore: number, inProgressCount: number, awaitingCount: number, completedCount: number } };

export type GetCategoryDashboardDetailsQueryVariables = Exact<{
  course_id: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
  category_id: Scalars['String']['input'];
}>;


export type GetCategoryDashboardDetailsQuery = { __typename?: 'Query', getCategoryDashboardDetails: { __typename?: 'CategoryDashboardDetails', totalScore: number, inProgressCount: number, awaitingCount: number, completedCount: number, categoryName: string, maxScore: number } };

export type GetQuestionForStudentsQueryVariables = Exact<{
  course_id: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
  campus_name: Scalars['String']['input'];
  category_id: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetQuestionForStudentsQuery = { __typename?: 'Query', getQuestionForStudents: { __typename?: 'QuestionOutput', totalCount: number, questions: Array<{ __typename?: 'Status', mark: number, status: number, question_id: string, title: string, difficulty: string }> } };

export type GetAssignmentQuestionForStudentsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAssignmentQuestionForStudentsQuery = { __typename?: 'Query', getAssignmentQuestionForStudents: { __typename?: 'AssignmentQuestion', id: string, assignment_id: string, title: string, text: string, question_sub_text?: string | null, marks: string, showFunctionOnly?: boolean | null, targetFunctionName?: string | null, difficulty: string, hints: Array<string>, tags: Array<string>, company_tags: Array<string>, updated_by: string, updated_at: any, created_by: string, created_at: any, test_cases: Array<{ __typename?: 'TestCase', id?: string | null, visibility: string, input: string, output: string, weightage: number }>, predefinedCode?: { __typename?: 'PredefinedLanguages', c: string, java: string, python: string, cpp: string } | null } };

export type GetAllFoldersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllFoldersQuery = { __typename?: 'Query', getAllFolders: Array<{ __typename: 'Assignment_Folders', _id: string, id?: string | null, name: string, assignments: Array<string> }> };

export type AssignmentsInFolderQueryVariables = Exact<{
  folderId: Scalars['String']['input'];
}>;


export type AssignmentsInFolderQuery = { __typename?: 'Query', assignmentsInFolder: Array<{ __typename: 'Assignment', _id: string, id?: string | null, name: string, short_description?: string | null, description: string, due_date?: any | null, languages: Array<string>, domain?: string | null, duration?: number | null, max_cheat_count?: number | null, max_tabSwitches?: number | null, enable_proctoring?: boolean | null, updatedBy?: string | null, updatedAt?: any | null, createdBy?: string | null, createdAt?: any | null }> };

export type StartTestMutationVariables = Exact<{
  campus_name: Scalars['String']['input'];
  assignment_id: Scalars['String']['input'];
  student_id: Scalars['String']['input'];
  testDurationInMinutes: Scalars['Float']['input'];
}>;


export type StartTestMutation = { __typename?: 'Mutation', startTest: { __typename?: 'AssignmentSubmit', id?: string | null, assignment_id?: string | null, cluster_id?: string | null, student_id?: string | null, totalScore?: number | null, tabSwitches?: number | null, cheat_count?: number | null, completed?: boolean | null, endTime?: any | null, questions?: Array<{ __typename?: 'QuestionSubmission', question_id: string, answer: string, score: number, language: string }> | null, autosave?: Array<{ __typename?: 'QuestionSubmission', question_id: string, answer: string, score: number, language: string }> | null } };

export type GetAutoSubmitQueryVariables = Exact<{
  getModuleSubmit: GetAutoSubmitInput;
}>;


export type GetAutoSubmitQuery = { __typename?: 'Query', getAutoSubmit?: { __typename?: 'ModuleSubmit', id: string, student_id: string, module_id: string, day_id: string, question_id: string, cluster_id: string, campus_name: string, autosave?: { __typename?: 'SubmissionDetail', id: string, code: string, language?: string | null, submittedAt: any } | null } | null };

export type GetModuleSubmissionsQueryVariables = Exact<{
  studentId: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
  campusName: Scalars['String']['input'];
}>;


export type GetModuleSubmissionsQuery = { __typename?: 'Query', getModuleSubmissions: Array<{ __typename?: 'ModuleSubmit', id: string, student_id: string, score: number, is_completed: boolean, question_id: string, submissions: Array<{ __typename?: 'SubmissionDetail', id: string, code: string, score: number, submittedAt: any }> }> };

export type GetModulesByCampusQueryVariables = Exact<{
  campusName: Scalars['String']['input'];
}>;


export type GetModulesByCampusQuery = { __typename?: 'Query', getModulesByCampus: Array<{ __typename?: 'ModuleForCluster', moduleID: string, name?: string | null, description?: string | null, enabled_dates: Array<any> }> };

export type GetModuleByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetModuleByIdQuery = { __typename?: 'Query', getModuleById: { __typename?: 'ModuleEntity', _id: string, name: string, short_description: string, domain: string, start_date: string, end_date: string, daywise_plan?: Array<{ __typename?: 'ModuleAssignment', day_id?: string | null, name: string, day_description?: string | null, questions: Array<string>, createdAt: any, updatedAt?: any | null }> | null } };

export type GetAllCronJobsQueryVariables = Exact<{
  input: GetAllJobsInput;
}>;


export type GetAllCronJobsQuery = { __typename?: 'Query', getAllCronJobs: { __typename?: 'GetAllJobsResponse', total: number, data: Array<{ __typename?: 'CronJob', id: string, job_id: string, emailId: string, campusName: string, status?: string | null, createdAt?: any | null }> } };

export type GetAllReportMessagesQueryVariables = Exact<{
  campusName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllReportMessagesQuery = { __typename?: 'Query', getReportMessages: Array<{ __typename?: 'ReportMessage', id: string, createdAt: any, updatedAt: any, ranges: Array<{ __typename?: 'ReportMessageRange', rangeLabel: string, entries: Array<{ __typename?: 'ReportMessageEntry', campusName: string, message: string, greeting: string }> }> }> };

export type GetMessageByScoreQueryVariables = Exact<{
  scorePercent: Scalars['Int']['input'];
  campusName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMessageByScoreQuery = { __typename?: 'Query', getReportMessageByScore: { __typename?: 'ReportMessageEntry', campusName: string, message: string, greeting: string } };

export type GetMessagesByRangeQueryVariables = Exact<{
  rangeLabel: Scalars['String']['input'];
  campusName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMessagesByRangeQuery = { __typename?: 'Query', getMessagesByRangeLevel: Array<{ __typename?: 'ReportMessageEntry', campusName: string, message: string, greeting: string }> };

export type GetClusterStudentsQueryVariables = Exact<{
  clusterId: Scalars['String']['input'];
}>;


export type GetClusterStudentsQuery = { __typename?: 'Query', getClusterStudents: Array<{ __typename?: 'StudentDetail', id: string, name?: string | null, email: string, rollNo?: string | null, leetCodeUname?: string | null }> };

export type GetLeetcodeBulkQueryVariables = Exact<{
  usernames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetLeetcodeBulkQuery = { __typename?: 'Query', leetcodeBulk: Array<{ __typename?: 'LeetcodeStudent', username: string, name: string, ranking?: number | null, totalSolved: number, easySolved: number, mediumSolved: number, hardSolved: number, profileUrl: string }> };

export type GetOtherAssignmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOtherAssignmentQuery = { __typename?: 'Query', getOtherAssignment: Array<{ __typename?: 'Assignment', id?: string | null, name: string }> };


export const CreateModuleDocument = gql`
    mutation CreateModule($data: ModuleInput!) {
  createModule(data: $data) {
    _id
    name
    domain
    short_description
    start_date
    end_date
    daywise_plan {
      name
      day_description
      questions
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateModuleMutationFn = Apollo.MutationFunction<CreateModuleMutation, CreateModuleMutationVariables>;

/**
 * __useCreateModuleMutation__
 *
 * To run a mutation, you first call `useCreateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModuleMutation, { data, loading, error }] = useCreateModuleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateModuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateModuleMutation, CreateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModuleMutation, CreateModuleMutationVariables>(CreateModuleDocument, options);
      }
export type CreateModuleMutationHookResult = ReturnType<typeof useCreateModuleMutation>;
export type CreateModuleMutationResult = Apollo.MutationResult<CreateModuleMutation>;
export type CreateModuleMutationOptions = Apollo.BaseMutationOptions<CreateModuleMutation, CreateModuleMutationVariables>;
export const RemoveClusterDocument = gql`
    mutation RemoveCluster($removeClusterInput: RemoveClusterInput!) {
  removeCluster(removeClusterInput: $removeClusterInput)
}
    `;
export type RemoveClusterMutationFn = Apollo.MutationFunction<RemoveClusterMutation, RemoveClusterMutationVariables>;

/**
 * __useRemoveClusterMutation__
 *
 * To run a mutation, you first call `useRemoveClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClusterMutation, { data, loading, error }] = useRemoveClusterMutation({
 *   variables: {
 *      removeClusterInput: // value for 'removeClusterInput'
 *   },
 * });
 */
export function useRemoveClusterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveClusterMutation, RemoveClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveClusterMutation, RemoveClusterMutationVariables>(RemoveClusterDocument, options);
      }
export type RemoveClusterMutationHookResult = ReturnType<typeof useRemoveClusterMutation>;
export type RemoveClusterMutationResult = Apollo.MutationResult<RemoveClusterMutation>;
export type RemoveClusterMutationOptions = Apollo.BaseMutationOptions<RemoveClusterMutation, RemoveClusterMutationVariables>;
export const DeleteCampusByNameDocument = gql`
    mutation DeleteCampusByName($name: String!) {
  deleteCampusByName(name: $name)
}
    `;
export type DeleteCampusByNameMutationFn = Apollo.MutationFunction<DeleteCampusByNameMutation, DeleteCampusByNameMutationVariables>;

/**
 * __useDeleteCampusByNameMutation__
 *
 * To run a mutation, you first call `useDeleteCampusByNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampusByNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampusByNameMutation, { data, loading, error }] = useDeleteCampusByNameMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteCampusByNameMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampusByNameMutation, DeleteCampusByNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampusByNameMutation, DeleteCampusByNameMutationVariables>(DeleteCampusByNameDocument, options);
      }
export type DeleteCampusByNameMutationHookResult = ReturnType<typeof useDeleteCampusByNameMutation>;
export type DeleteCampusByNameMutationResult = Apollo.MutationResult<DeleteCampusByNameMutation>;
export type DeleteCampusByNameMutationOptions = Apollo.BaseMutationOptions<DeleteCampusByNameMutation, DeleteCampusByNameMutationVariables>;
export const RequestDeletionDocument = gql`
    mutation requestDeletion($typeOfDeletion: String!, $payload: JSON!, $reasonForDeletion: String!, $requestedBy: String!, $title: String!) {
  requestDeletion(
    typeOfDeletion: $typeOfDeletion
    payload: $payload
    reasonForDeletion: $reasonForDeletion
    requestedBy: $requestedBy
    title: $title
  ) {
    id
    typeOfDeletion
    payload
    statusOfApproval
    requestedBy
    requestedAt
  }
}
    `;
export type RequestDeletionMutationFn = Apollo.MutationFunction<RequestDeletionMutation, RequestDeletionMutationVariables>;

/**
 * __useRequestDeletionMutation__
 *
 * To run a mutation, you first call `useRequestDeletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDeletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDeletionMutation, { data, loading, error }] = useRequestDeletionMutation({
 *   variables: {
 *      typeOfDeletion: // value for 'typeOfDeletion'
 *      payload: // value for 'payload'
 *      reasonForDeletion: // value for 'reasonForDeletion'
 *      requestedBy: // value for 'requestedBy'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useRequestDeletionMutation(baseOptions?: Apollo.MutationHookOptions<RequestDeletionMutation, RequestDeletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestDeletionMutation, RequestDeletionMutationVariables>(RequestDeletionDocument, options);
      }
export type RequestDeletionMutationHookResult = ReturnType<typeof useRequestDeletionMutation>;
export type RequestDeletionMutationResult = Apollo.MutationResult<RequestDeletionMutation>;
export type RequestDeletionMutationOptions = Apollo.BaseMutationOptions<RequestDeletionMutation, RequestDeletionMutationVariables>;
export const AddModuleToClusterDocument = gql`
    mutation AddModuleToCluster($campusName: String!, $clusterId: String!, $module: ModuleInputForCluster!) {
  addModuleToCluster(
    campusName: $campusName
    clusterId: $clusterId
    module: $module
  ) {
    id
    name
    courseIds
    assignmentIds
    studentCount
    campusName
    createdAt
    moduleIds
    sendEmail
    staffs {
      id
      name
      email
      campusId
      designation
      contactNo
      clusterIds
      isInviteSend
      isAdminStaff
    }
  }
}
    `;
export type AddModuleToClusterMutationFn = Apollo.MutationFunction<AddModuleToClusterMutation, AddModuleToClusterMutationVariables>;

/**
 * __useAddModuleToClusterMutation__
 *
 * To run a mutation, you first call `useAddModuleToClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddModuleToClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addModuleToClusterMutation, { data, loading, error }] = useAddModuleToClusterMutation({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *      module: // value for 'module'
 *   },
 * });
 */
export function useAddModuleToClusterMutation(baseOptions?: Apollo.MutationHookOptions<AddModuleToClusterMutation, AddModuleToClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddModuleToClusterMutation, AddModuleToClusterMutationVariables>(AddModuleToClusterDocument, options);
      }
export type AddModuleToClusterMutationHookResult = ReturnType<typeof useAddModuleToClusterMutation>;
export type AddModuleToClusterMutationResult = Apollo.MutationResult<AddModuleToClusterMutation>;
export type AddModuleToClusterMutationOptions = Apollo.BaseMutationOptions<AddModuleToClusterMutation, AddModuleToClusterMutationVariables>;
export const CreateCampusDocument = gql`
    mutation CreateCampus($createCampusInput: CreateCampusInput!) {
  createCampus(createCampusInput: $createCampusInput) {
    id
    name
  }
}
    `;
export type CreateCampusMutationFn = Apollo.MutationFunction<CreateCampusMutation, CreateCampusMutationVariables>;

/**
 * __useCreateCampusMutation__
 *
 * To run a mutation, you first call `useCreateCampusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampusMutation, { data, loading, error }] = useCreateCampusMutation({
 *   variables: {
 *      createCampusInput: // value for 'createCampusInput'
 *   },
 * });
 */
export function useCreateCampusMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampusMutation, CreateCampusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampusMutation, CreateCampusMutationVariables>(CreateCampusDocument, options);
      }
export type CreateCampusMutationHookResult = ReturnType<typeof useCreateCampusMutation>;
export type CreateCampusMutationResult = Apollo.MutationResult<CreateCampusMutation>;
export type CreateCampusMutationOptions = Apollo.BaseMutationOptions<CreateCampusMutation, CreateCampusMutationVariables>;
export const CreateClusterDocument = gql`
    mutation CreateCluster($createClusterInput: CreateClusterInput!) {
  createCluster(createClusterInput: $createClusterInput) {
    id
    name
    courseIds
  }
}
    `;
export type CreateClusterMutationFn = Apollo.MutationFunction<CreateClusterMutation, CreateClusterMutationVariables>;

/**
 * __useCreateClusterMutation__
 *
 * To run a mutation, you first call `useCreateClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClusterMutation, { data, loading, error }] = useCreateClusterMutation({
 *   variables: {
 *      createClusterInput: // value for 'createClusterInput'
 *   },
 * });
 */
export function useCreateClusterMutation(baseOptions?: Apollo.MutationHookOptions<CreateClusterMutation, CreateClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClusterMutation, CreateClusterMutationVariables>(CreateClusterDocument, options);
      }
export type CreateClusterMutationHookResult = ReturnType<typeof useCreateClusterMutation>;
export type CreateClusterMutationResult = Apollo.MutationResult<CreateClusterMutation>;
export type CreateClusterMutationOptions = Apollo.BaseMutationOptions<CreateClusterMutation, CreateClusterMutationVariables>;
export const CreateStaffDocument = gql`
    mutation CreateStaff($createStaffInput: CreateStaffInput!) {
  createStaff(createStaffInput: $createStaffInput) {
    staff {
      id
      name
      email
      campusId
    }
    uid
    message
  }
}
    `;
export type CreateStaffMutationFn = Apollo.MutationFunction<CreateStaffMutation, CreateStaffMutationVariables>;

/**
 * __useCreateStaffMutation__
 *
 * To run a mutation, you first call `useCreateStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStaffMutation, { data, loading, error }] = useCreateStaffMutation({
 *   variables: {
 *      createStaffInput: // value for 'createStaffInput'
 *   },
 * });
 */
export function useCreateStaffMutation(baseOptions?: Apollo.MutationHookOptions<CreateStaffMutation, CreateStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStaffMutation, CreateStaffMutationVariables>(CreateStaffDocument, options);
      }
export type CreateStaffMutationHookResult = ReturnType<typeof useCreateStaffMutation>;
export type CreateStaffMutationResult = Apollo.MutationResult<CreateStaffMutation>;
export type CreateStaffMutationOptions = Apollo.BaseMutationOptions<CreateStaffMutation, CreateStaffMutationVariables>;
export const DeleteStaffDocument = gql`
    mutation DeleteStaff($id: String!) {
  deleteStaff(id: $id)
}
    `;
export type DeleteStaffMutationFn = Apollo.MutationFunction<DeleteStaffMutation, DeleteStaffMutationVariables>;

/**
 * __useDeleteStaffMutation__
 *
 * To run a mutation, you first call `useDeleteStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStaffMutation, { data, loading, error }] = useDeleteStaffMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStaffMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStaffMutation, DeleteStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStaffMutation, DeleteStaffMutationVariables>(DeleteStaffDocument, options);
      }
export type DeleteStaffMutationHookResult = ReturnType<typeof useDeleteStaffMutation>;
export type DeleteStaffMutationResult = Apollo.MutationResult<DeleteStaffMutation>;
export type DeleteStaffMutationOptions = Apollo.BaseMutationOptions<DeleteStaffMutation, DeleteStaffMutationVariables>;
export const SendInviteEmailToStaffDocument = gql`
    mutation SendInviteEmailToStaff($emails: [String!]!) {
  sendInviteEmailToStaff(emails: $emails)
}
    `;
export type SendInviteEmailToStaffMutationFn = Apollo.MutationFunction<SendInviteEmailToStaffMutation, SendInviteEmailToStaffMutationVariables>;

/**
 * __useSendInviteEmailToStaffMutation__
 *
 * To run a mutation, you first call `useSendInviteEmailToStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInviteEmailToStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInviteEmailToStaffMutation, { data, loading, error }] = useSendInviteEmailToStaffMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useSendInviteEmailToStaffMutation(baseOptions?: Apollo.MutationHookOptions<SendInviteEmailToStaffMutation, SendInviteEmailToStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInviteEmailToStaffMutation, SendInviteEmailToStaffMutationVariables>(SendInviteEmailToStaffDocument, options);
      }
export type SendInviteEmailToStaffMutationHookResult = ReturnType<typeof useSendInviteEmailToStaffMutation>;
export type SendInviteEmailToStaffMutationResult = Apollo.MutationResult<SendInviteEmailToStaffMutation>;
export type SendInviteEmailToStaffMutationOptions = Apollo.BaseMutationOptions<SendInviteEmailToStaffMutation, SendInviteEmailToStaffMutationVariables>;
export const SendInviteEmailToStudentDocument = gql`
    mutation sendInviteEmailToStudent($emails: [String!]!) {
  sendInviteEmailToStudent(emails: $emails)
}
    `;
export type SendInviteEmailToStudentMutationFn = Apollo.MutationFunction<SendInviteEmailToStudentMutation, SendInviteEmailToStudentMutationVariables>;

/**
 * __useSendInviteEmailToStudentMutation__
 *
 * To run a mutation, you first call `useSendInviteEmailToStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInviteEmailToStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInviteEmailToStudentMutation, { data, loading, error }] = useSendInviteEmailToStudentMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useSendInviteEmailToStudentMutation(baseOptions?: Apollo.MutationHookOptions<SendInviteEmailToStudentMutation, SendInviteEmailToStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInviteEmailToStudentMutation, SendInviteEmailToStudentMutationVariables>(SendInviteEmailToStudentDocument, options);
      }
export type SendInviteEmailToStudentMutationHookResult = ReturnType<typeof useSendInviteEmailToStudentMutation>;
export type SendInviteEmailToStudentMutationResult = Apollo.MutationResult<SendInviteEmailToStudentMutation>;
export type SendInviteEmailToStudentMutationOptions = Apollo.BaseMutationOptions<SendInviteEmailToStudentMutation, SendInviteEmailToStudentMutationVariables>;
export const DeleteStudentDocument = gql`
    mutation DeleteStudent($id: String!, $campusName: String!) {
  deleteStudent(id: $id, campusName: $campusName)
}
    `;
export type DeleteStudentMutationFn = Apollo.MutationFunction<DeleteStudentMutation, DeleteStudentMutationVariables>;

/**
 * __useDeleteStudentMutation__
 *
 * To run a mutation, you first call `useDeleteStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudentMutation, { data, loading, error }] = useDeleteStudentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campusName: // value for 'campusName'
 *   },
 * });
 */
export function useDeleteStudentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStudentMutation, DeleteStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStudentMutation, DeleteStudentMutationVariables>(DeleteStudentDocument, options);
      }
export type DeleteStudentMutationHookResult = ReturnType<typeof useDeleteStudentMutation>;
export type DeleteStudentMutationResult = Apollo.MutationResult<DeleteStudentMutation>;
export type DeleteStudentMutationOptions = Apollo.BaseMutationOptions<DeleteStudentMutation, DeleteStudentMutationVariables>;
export const UpdateStudentDocument = gql`
    mutation UpdateStudent($updateStudentInput: UpdateStudentInput!) {
  updateStudent(updateStudentInput: $updateStudentInput) {
    id
    name
    email
    personalEmail
    phno
    dob
    rollNo
    department
    placeOfResidence
    leetCodeUname
    hackerRankUname
    assignmentIds
    courseIds
  }
}
    `;
export type UpdateStudentMutationFn = Apollo.MutationFunction<UpdateStudentMutation, UpdateStudentMutationVariables>;

/**
 * __useUpdateStudentMutation__
 *
 * To run a mutation, you first call `useUpdateStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentMutation, { data, loading, error }] = useUpdateStudentMutation({
 *   variables: {
 *      updateStudentInput: // value for 'updateStudentInput'
 *   },
 * });
 */
export function useUpdateStudentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentMutation, UpdateStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentMutation, UpdateStudentMutationVariables>(UpdateStudentDocument, options);
      }
export type UpdateStudentMutationHookResult = ReturnType<typeof useUpdateStudentMutation>;
export type UpdateStudentMutationResult = Apollo.MutationResult<UpdateStudentMutation>;
export type UpdateStudentMutationOptions = Apollo.BaseMutationOptions<UpdateStudentMutation, UpdateStudentMutationVariables>;
export const BulkUploadStudentsDocument = gql`
    mutation BulkUploadStudents($students: [CreateStudentInput!]!, $campusName: String!, $clusterId: String!) {
  bulkUploadStudents(
    students: $students
    campusName: $campusName
    clusterId: $clusterId
  ) {
    student {
      id
      name
      email
      personalEmail
    }
    uid
    message
  }
}
    `;
export type BulkUploadStudentsMutationFn = Apollo.MutationFunction<BulkUploadStudentsMutation, BulkUploadStudentsMutationVariables>;

/**
 * __useBulkUploadStudentsMutation__
 *
 * To run a mutation, you first call `useBulkUploadStudentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadStudentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadStudentsMutation, { data, loading, error }] = useBulkUploadStudentsMutation({
 *   variables: {
 *      students: // value for 'students'
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useBulkUploadStudentsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadStudentsMutation, BulkUploadStudentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadStudentsMutation, BulkUploadStudentsMutationVariables>(BulkUploadStudentsDocument, options);
      }
export type BulkUploadStudentsMutationHookResult = ReturnType<typeof useBulkUploadStudentsMutation>;
export type BulkUploadStudentsMutationResult = Apollo.MutationResult<BulkUploadStudentsMutation>;
export type BulkUploadStudentsMutationOptions = Apollo.BaseMutationOptions<BulkUploadStudentsMutation, BulkUploadStudentsMutationVariables>;
export const CreateAdminDocument = gql`
    mutation CreateAdmin($CreateAdminInput: CreateAdminInput!) {
  createAdmin(createAdminInput: $CreateAdminInput) {
    admin {
      id
      name
      email
    }
    uid
    message
  }
}
    `;
export type CreateAdminMutationFn = Apollo.MutationFunction<CreateAdminMutation, CreateAdminMutationVariables>;

/**
 * __useCreateAdminMutation__
 *
 * To run a mutation, you first call `useCreateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminMutation, { data, loading, error }] = useCreateAdminMutation({
 *   variables: {
 *      CreateAdminInput: // value for 'CreateAdminInput'
 *   },
 * });
 */
export function useCreateAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminMutation, CreateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminMutation, CreateAdminMutationVariables>(CreateAdminDocument, options);
      }
export type CreateAdminMutationHookResult = ReturnType<typeof useCreateAdminMutation>;
export type CreateAdminMutationResult = Apollo.MutationResult<CreateAdminMutation>;
export type CreateAdminMutationOptions = Apollo.BaseMutationOptions<CreateAdminMutation, CreateAdminMutationVariables>;
export const DeleteAdminDocument = gql`
    mutation DeleteAdmin($id: String!) {
  deleteAdmin(id: $id)
}
    `;
export type DeleteAdminMutationFn = Apollo.MutationFunction<DeleteAdminMutation, DeleteAdminMutationVariables>;

/**
 * __useDeleteAdminMutation__
 *
 * To run a mutation, you first call `useDeleteAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminMutation, { data, loading, error }] = useDeleteAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdminMutation, DeleteAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdminMutation, DeleteAdminMutationVariables>(DeleteAdminDocument, options);
      }
export type DeleteAdminMutationHookResult = ReturnType<typeof useDeleteAdminMutation>;
export type DeleteAdminMutationResult = Apollo.MutationResult<DeleteAdminMutation>;
export type DeleteAdminMutationOptions = Apollo.BaseMutationOptions<DeleteAdminMutation, DeleteAdminMutationVariables>;
export const UpdateStaffDocument = gql`
    mutation UpdateStaff($updateStaffInput: UpdateStaffInput!) {
  updateStaff(updateStaffInput: $updateStaffInput) {
    id
    name
    email
    campusId
    designation
    contactNo
  }
}
    `;
export type UpdateStaffMutationFn = Apollo.MutationFunction<UpdateStaffMutation, UpdateStaffMutationVariables>;

/**
 * __useUpdateStaffMutation__
 *
 * To run a mutation, you first call `useUpdateStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStaffMutation, { data, loading, error }] = useUpdateStaffMutation({
 *   variables: {
 *      updateStaffInput: // value for 'updateStaffInput'
 *   },
 * });
 */
export function useUpdateStaffMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStaffMutation, UpdateStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStaffMutation, UpdateStaffMutationVariables>(UpdateStaffDocument, options);
      }
export type UpdateStaffMutationHookResult = ReturnType<typeof useUpdateStaffMutation>;
export type UpdateStaffMutationResult = Apollo.MutationResult<UpdateStaffMutation>;
export type UpdateStaffMutationOptions = Apollo.BaseMutationOptions<UpdateStaffMutation, UpdateStaffMutationVariables>;
export const CreateCourseDocument = gql`
    mutation CreateCourse($createCourseInput: CreateCourseDto!) {
  createCourse(createCourseInput: $createCourseInput) {
    id
    name
    short_description
    description
    categories {
      id
      name
      description
    }
    price
    time_period
    languages
    domain
    updatedBy
    updatedAt
    createdBy
    createdAt
  }
}
    `;
export type CreateCourseMutationFn = Apollo.MutationFunction<CreateCourseMutation, CreateCourseMutationVariables>;

/**
 * __useCreateCourseMutation__
 *
 * To run a mutation, you first call `useCreateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourseMutation, { data, loading, error }] = useCreateCourseMutation({
 *   variables: {
 *      createCourseInput: // value for 'createCourseInput'
 *   },
 * });
 */
export function useCreateCourseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCourseMutation, CreateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCourseMutation, CreateCourseMutationVariables>(CreateCourseDocument, options);
      }
export type CreateCourseMutationHookResult = ReturnType<typeof useCreateCourseMutation>;
export type CreateCourseMutationResult = Apollo.MutationResult<CreateCourseMutation>;
export type CreateCourseMutationOptions = Apollo.BaseMutationOptions<CreateCourseMutation, CreateCourseMutationVariables>;
export const UpdateCourseDocument = gql`
    mutation UpdateCourse($id: String!, $updateCourseInput: UpdateCourseDto!) {
  updateCourse(id: $id, updateCourseInput: $updateCourseInput) {
    id
    name
    short_description
    description
    categories {
      name
      description
    }
    price
    time_period
    languages
    domain
    updatedBy
    updatedAt
    createdBy
    createdAt
  }
}
    `;
export type UpdateCourseMutationFn = Apollo.MutationFunction<UpdateCourseMutation, UpdateCourseMutationVariables>;

/**
 * __useUpdateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseMutation, { data, loading, error }] = useUpdateCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateCourseInput: // value for 'updateCourseInput'
 *   },
 * });
 */
export function useUpdateCourseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourseMutation, UpdateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourseMutation, UpdateCourseMutationVariables>(UpdateCourseDocument, options);
      }
export type UpdateCourseMutationHookResult = ReturnType<typeof useUpdateCourseMutation>;
export type UpdateCourseMutationResult = Apollo.MutationResult<UpdateCourseMutation>;
export type UpdateCourseMutationOptions = Apollo.BaseMutationOptions<UpdateCourseMutation, UpdateCourseMutationVariables>;
export const RemoveCourseDocument = gql`
    mutation RemoveCourse($id: String!) {
  removeCourse(id: $id) {
    id
    name
  }
}
    `;
export type RemoveCourseMutationFn = Apollo.MutationFunction<RemoveCourseMutation, RemoveCourseMutationVariables>;

/**
 * __useRemoveCourseMutation__
 *
 * To run a mutation, you first call `useRemoveCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCourseMutation, { data, loading, error }] = useRemoveCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCourseMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCourseMutation, RemoveCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCourseMutation, RemoveCourseMutationVariables>(RemoveCourseDocument, options);
      }
export type RemoveCourseMutationHookResult = ReturnType<typeof useRemoveCourseMutation>;
export type RemoveCourseMutationResult = Apollo.MutationResult<RemoveCourseMutation>;
export type RemoveCourseMutationOptions = Apollo.BaseMutationOptions<RemoveCourseMutation, RemoveCourseMutationVariables>;
export const CreateQuestionDocument = gql`
    mutation CreateQuestion($createQuestionInput: CreateQuestionInput!) {
  createQuestion(createQuestionInput: $createQuestionInput) {
    id
    course_id
    assignment_ids
    title
    text
    question_sub_text
    test_cases {
      id
      visibility
      input
      output
      weightage
    }
    category {
      id
      name
    }
    predefinedCode {
      c
      java
      python
      cpp
    }
    showFunctionOnly
    targetFunctionName
    marks
    difficulty
    hints
    tags
    company_tags
    created_by
    created_at
    updated_by
    updated_at
  }
}
    `;
export type CreateQuestionMutationFn = Apollo.MutationFunction<CreateQuestionMutation, CreateQuestionMutationVariables>;

/**
 * __useCreateQuestionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionMutation, { data, loading, error }] = useCreateQuestionMutation({
 *   variables: {
 *      createQuestionInput: // value for 'createQuestionInput'
 *   },
 * });
 */
export function useCreateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionMutation, CreateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionMutation, CreateQuestionMutationVariables>(CreateQuestionDocument, options);
      }
export type CreateQuestionMutationHookResult = ReturnType<typeof useCreateQuestionMutation>;
export type CreateQuestionMutationResult = Apollo.MutationResult<CreateQuestionMutation>;
export type CreateQuestionMutationOptions = Apollo.BaseMutationOptions<CreateQuestionMutation, CreateQuestionMutationVariables>;
export const UpdateQuestionDocument = gql`
    mutation updateQuestion($id: String!, $updateQuestionInput: UpdateQuestionInput!) {
  updateQuestion(id: $id, updateQuestionInput: $updateQuestionInput) {
    id
    course_id
    assignment_ids
    title
    text
    question_sub_text
    test_cases {
      id
      visibility
      input
      output
      weightage
    }
    category {
      name
      id
    }
    marks
    difficulty
    hints
    tags
    company_tags
    updated_by
    updated_at
    created_by
    created_at
  }
}
    `;
export type UpdateQuestionMutationFn = Apollo.MutationFunction<UpdateQuestionMutation, UpdateQuestionMutationVariables>;

/**
 * __useUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionMutation, { data, loading, error }] = useUpdateQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateQuestionInput: // value for 'updateQuestionInput'
 *   },
 * });
 */
export function useUpdateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionMutation, UpdateQuestionMutationVariables>(UpdateQuestionDocument, options);
      }
export type UpdateQuestionMutationHookResult = ReturnType<typeof useUpdateQuestionMutation>;
export type UpdateQuestionMutationResult = Apollo.MutationResult<UpdateQuestionMutation>;
export type UpdateQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>;
export const DeleteQuestionDocument = gql`
    mutation deleteQuestion($id: String!, $course_id: String!) {
  deleteQuestion(id: $id, course_id: $course_id)
}
    `;
export type DeleteQuestionMutationFn = Apollo.MutationFunction<DeleteQuestionMutation, DeleteQuestionMutationVariables>;

/**
 * __useDeleteQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionMutation, { data, loading, error }] = useDeleteQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      course_id: // value for 'course_id'
 *   },
 * });
 */
export function useDeleteQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuestionMutation, DeleteQuestionMutationVariables>(DeleteQuestionDocument, options);
      }
export type DeleteQuestionMutationHookResult = ReturnType<typeof useDeleteQuestionMutation>;
export type DeleteQuestionMutationResult = Apollo.MutationResult<DeleteQuestionMutation>;
export type DeleteQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>;
export const AddCoursesToClusterDocument = gql`
    mutation addCoursesToCluster($campusName: String!, $clusterId: String!, $courseIds: [String!]!) {
  addCoursesToCluster(
    campusName: $campusName
    clusterId: $clusterId
    courseIds: $courseIds
  ) {
    id
    name
    courseIds
  }
}
    `;
export type AddCoursesToClusterMutationFn = Apollo.MutationFunction<AddCoursesToClusterMutation, AddCoursesToClusterMutationVariables>;

/**
 * __useAddCoursesToClusterMutation__
 *
 * To run a mutation, you first call `useAddCoursesToClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCoursesToClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCoursesToClusterMutation, { data, loading, error }] = useAddCoursesToClusterMutation({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *      courseIds: // value for 'courseIds'
 *   },
 * });
 */
export function useAddCoursesToClusterMutation(baseOptions?: Apollo.MutationHookOptions<AddCoursesToClusterMutation, AddCoursesToClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCoursesToClusterMutation, AddCoursesToClusterMutationVariables>(AddCoursesToClusterDocument, options);
      }
export type AddCoursesToClusterMutationHookResult = ReturnType<typeof useAddCoursesToClusterMutation>;
export type AddCoursesToClusterMutationResult = Apollo.MutationResult<AddCoursesToClusterMutation>;
export type AddCoursesToClusterMutationOptions = Apollo.BaseMutationOptions<AddCoursesToClusterMutation, AddCoursesToClusterMutationVariables>;
export const RemoveCourseFromClusterDocument = gql`
    mutation removeCourseFromCluster($campusName: String!, $clusterId: String!, $courseId: String!) {
  removeCourseFromCluster(
    campusName: $campusName
    clusterId: $clusterId
    courseId: $courseId
  ) {
    id
    name
    courseIds
  }
}
    `;
export type RemoveCourseFromClusterMutationFn = Apollo.MutationFunction<RemoveCourseFromClusterMutation, RemoveCourseFromClusterMutationVariables>;

/**
 * __useRemoveCourseFromClusterMutation__
 *
 * To run a mutation, you first call `useRemoveCourseFromClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCourseFromClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCourseFromClusterMutation, { data, loading, error }] = useRemoveCourseFromClusterMutation({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useRemoveCourseFromClusterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCourseFromClusterMutation, RemoveCourseFromClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCourseFromClusterMutation, RemoveCourseFromClusterMutationVariables>(RemoveCourseFromClusterDocument, options);
      }
export type RemoveCourseFromClusterMutationHookResult = ReturnType<typeof useRemoveCourseFromClusterMutation>;
export type RemoveCourseFromClusterMutationResult = Apollo.MutationResult<RemoveCourseFromClusterMutation>;
export type RemoveCourseFromClusterMutationOptions = Apollo.BaseMutationOptions<RemoveCourseFromClusterMutation, RemoveCourseFromClusterMutationVariables>;
export const UpdateClusterNameDocument = gql`
    mutation updateClusterName($updateClusterNameInput: UpdateClusterNameInput!) {
  updateClusterName(updateClusterNameInput: $updateClusterNameInput) {
    id
    name
    courseIds
  }
}
    `;
export type UpdateClusterNameMutationFn = Apollo.MutationFunction<UpdateClusterNameMutation, UpdateClusterNameMutationVariables>;

/**
 * __useUpdateClusterNameMutation__
 *
 * To run a mutation, you first call `useUpdateClusterNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClusterNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClusterNameMutation, { data, loading, error }] = useUpdateClusterNameMutation({
 *   variables: {
 *      updateClusterNameInput: // value for 'updateClusterNameInput'
 *   },
 * });
 */
export function useUpdateClusterNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClusterNameMutation, UpdateClusterNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClusterNameMutation, UpdateClusterNameMutationVariables>(UpdateClusterNameDocument, options);
      }
export type UpdateClusterNameMutationHookResult = ReturnType<typeof useUpdateClusterNameMutation>;
export type UpdateClusterNameMutationResult = Apollo.MutationResult<UpdateClusterNameMutation>;
export type UpdateClusterNameMutationOptions = Apollo.BaseMutationOptions<UpdateClusterNameMutation, UpdateClusterNameMutationVariables>;
export const AddClusterToStudentsDocument = gql`
    mutation addClusterToStudents($input: AddClusterToStudentsInput!) {
  addClusterToStudents(input: $input) {
    id
    name
    email
    phno
    dob
    placeOfResidence
    assignmentIds
    courseIds
    isInviteSend
  }
}
    `;
export type AddClusterToStudentsMutationFn = Apollo.MutationFunction<AddClusterToStudentsMutation, AddClusterToStudentsMutationVariables>;

/**
 * __useAddClusterToStudentsMutation__
 *
 * To run a mutation, you first call `useAddClusterToStudentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClusterToStudentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClusterToStudentsMutation, { data, loading, error }] = useAddClusterToStudentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddClusterToStudentsMutation(baseOptions?: Apollo.MutationHookOptions<AddClusterToStudentsMutation, AddClusterToStudentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClusterToStudentsMutation, AddClusterToStudentsMutationVariables>(AddClusterToStudentsDocument, options);
      }
export type AddClusterToStudentsMutationHookResult = ReturnType<typeof useAddClusterToStudentsMutation>;
export type AddClusterToStudentsMutationResult = Apollo.MutationResult<AddClusterToStudentsMutation>;
export type AddClusterToStudentsMutationOptions = Apollo.BaseMutationOptions<AddClusterToStudentsMutation, AddClusterToStudentsMutationVariables>;
export const RemoveClusterFromStudentsDocument = gql`
    mutation removeClusterFromStudents($input: RemoveClusterFromStudentsInput!) {
  removeClusterFromStudents(input: $input) {
    id
    name
    email
    phno
    dob
    placeOfResidence
    assignmentIds
    courseIds
    clusterIds
    isInviteSend
  }
}
    `;
export type RemoveClusterFromStudentsMutationFn = Apollo.MutationFunction<RemoveClusterFromStudentsMutation, RemoveClusterFromStudentsMutationVariables>;

/**
 * __useRemoveClusterFromStudentsMutation__
 *
 * To run a mutation, you first call `useRemoveClusterFromStudentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClusterFromStudentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClusterFromStudentsMutation, { data, loading, error }] = useRemoveClusterFromStudentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveClusterFromStudentsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveClusterFromStudentsMutation, RemoveClusterFromStudentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveClusterFromStudentsMutation, RemoveClusterFromStudentsMutationVariables>(RemoveClusterFromStudentsDocument, options);
      }
export type RemoveClusterFromStudentsMutationHookResult = ReturnType<typeof useRemoveClusterFromStudentsMutation>;
export type RemoveClusterFromStudentsMutationResult = Apollo.MutationResult<RemoveClusterFromStudentsMutation>;
export type RemoveClusterFromStudentsMutationOptions = Apollo.BaseMutationOptions<RemoveClusterFromStudentsMutation, RemoveClusterFromStudentsMutationVariables>;
export const SubmitCodeDocument = gql`
    mutation submitCode($compilerCodeInput: CompilerInput!, $submitInput: SubmitInput!) {
  submitCode(compilerCodeInput: $compilerCodeInput, submitInput: $submitInput) {
    compilationOutput {
      stdout
      stderr
    }
    submissions {
      code
      score
      submittedAt
      language
    }
    testCasePassed {
      count
      testCaseIds {
        testCaseId
        stdout
      }
    }
    testCaseFailed {
      count
      testCaseIds {
        testCaseId
        stdout
      }
    }
    Results {
      input
      output
      expextedOutput
      error
    }
  }
}
    `;
export type SubmitCodeMutationFn = Apollo.MutationFunction<SubmitCodeMutation, SubmitCodeMutationVariables>;

/**
 * __useSubmitCodeMutation__
 *
 * To run a mutation, you first call `useSubmitCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCodeMutation, { data, loading, error }] = useSubmitCodeMutation({
 *   variables: {
 *      compilerCodeInput: // value for 'compilerCodeInput'
 *      submitInput: // value for 'submitInput'
 *   },
 * });
 */
export function useSubmitCodeMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCodeMutation, SubmitCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCodeMutation, SubmitCodeMutationVariables>(SubmitCodeDocument, options);
      }
export type SubmitCodeMutationHookResult = ReturnType<typeof useSubmitCodeMutation>;
export type SubmitCodeMutationResult = Apollo.MutationResult<SubmitCodeMutation>;
export type SubmitCodeMutationOptions = Apollo.BaseMutationOptions<SubmitCodeMutation, SubmitCodeMutationVariables>;
export const AddStaffToClusterDocument = gql`
    mutation AddStaffToCluster($campusName: String!, $clusterId: String!, $staffs: [UpdateStaffInput!]!) {
  addStaffToCluster(
    campusName: $campusName
    clusterId: $clusterId
    staffs: $staffs
  ) {
    staff {
      id
      email
      name
      designation
    }
    added
  }
}
    `;
export type AddStaffToClusterMutationFn = Apollo.MutationFunction<AddStaffToClusterMutation, AddStaffToClusterMutationVariables>;

/**
 * __useAddStaffToClusterMutation__
 *
 * To run a mutation, you first call `useAddStaffToClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStaffToClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStaffToClusterMutation, { data, loading, error }] = useAddStaffToClusterMutation({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *      staffs: // value for 'staffs'
 *   },
 * });
 */
export function useAddStaffToClusterMutation(baseOptions?: Apollo.MutationHookOptions<AddStaffToClusterMutation, AddStaffToClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStaffToClusterMutation, AddStaffToClusterMutationVariables>(AddStaffToClusterDocument, options);
      }
export type AddStaffToClusterMutationHookResult = ReturnType<typeof useAddStaffToClusterMutation>;
export type AddStaffToClusterMutationResult = Apollo.MutationResult<AddStaffToClusterMutation>;
export type AddStaffToClusterMutationOptions = Apollo.BaseMutationOptions<AddStaffToClusterMutation, AddStaffToClusterMutationVariables>;
export const RemoveStaffFromClusterDocument = gql`
    mutation RemoveStaffFromCluster($campusName: String!, $clusterId: String!, $staffIds: [String!]!) {
  removeStaffFromCluster(
    campusName: $campusName
    clusterId: $clusterId
    staffIds: $staffIds
  ) {
    staffId
    removed
  }
}
    `;
export type RemoveStaffFromClusterMutationFn = Apollo.MutationFunction<RemoveStaffFromClusterMutation, RemoveStaffFromClusterMutationVariables>;

/**
 * __useRemoveStaffFromClusterMutation__
 *
 * To run a mutation, you first call `useRemoveStaffFromClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStaffFromClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStaffFromClusterMutation, { data, loading, error }] = useRemoveStaffFromClusterMutation({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *      staffIds: // value for 'staffIds'
 *   },
 * });
 */
export function useRemoveStaffFromClusterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStaffFromClusterMutation, RemoveStaffFromClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStaffFromClusterMutation, RemoveStaffFromClusterMutationVariables>(RemoveStaffFromClusterDocument, options);
      }
export type RemoveStaffFromClusterMutationHookResult = ReturnType<typeof useRemoveStaffFromClusterMutation>;
export type RemoveStaffFromClusterMutationResult = Apollo.MutationResult<RemoveStaffFromClusterMutation>;
export type RemoveStaffFromClusterMutationOptions = Apollo.BaseMutationOptions<RemoveStaffFromClusterMutation, RemoveStaffFromClusterMutationVariables>;
export const ToggleSendEmailDocument = gql`
    mutation ToggleSendEmail($campusName: String!, $clusterId: String!, $sendEmail: Boolean!) {
  toggleSendEmail(
    campusName: $campusName
    clusterId: $clusterId
    sendEmail: $sendEmail
  ) {
    sendEmail
  }
}
    `;
export type ToggleSendEmailMutationFn = Apollo.MutationFunction<ToggleSendEmailMutation, ToggleSendEmailMutationVariables>;

/**
 * __useToggleSendEmailMutation__
 *
 * To run a mutation, you first call `useToggleSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleSendEmailMutation, { data, loading, error }] = useToggleSendEmailMutation({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *      sendEmail: // value for 'sendEmail'
 *   },
 * });
 */
export function useToggleSendEmailMutation(baseOptions?: Apollo.MutationHookOptions<ToggleSendEmailMutation, ToggleSendEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleSendEmailMutation, ToggleSendEmailMutationVariables>(ToggleSendEmailDocument, options);
      }
export type ToggleSendEmailMutationHookResult = ReturnType<typeof useToggleSendEmailMutation>;
export type ToggleSendEmailMutationResult = Apollo.MutationResult<ToggleSendEmailMutation>;
export type ToggleSendEmailMutationOptions = Apollo.BaseMutationOptions<ToggleSendEmailMutation, ToggleSendEmailMutationVariables>;
export const ToggleAssessmentMailDocument = gql`
    mutation ToggleAssessmentMail($campusName: String!, $clusterId: String!, $isAssessmentMail: Boolean!) {
  toggleAssessmentMail(
    campusName: $campusName
    clusterId: $clusterId
    isAssessmentMail: $isAssessmentMail
  ) {
    id
    name
    isAssessmentMail
    sendEmail
  }
}
    `;
export type ToggleAssessmentMailMutationFn = Apollo.MutationFunction<ToggleAssessmentMailMutation, ToggleAssessmentMailMutationVariables>;

/**
 * __useToggleAssessmentMailMutation__
 *
 * To run a mutation, you first call `useToggleAssessmentMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAssessmentMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAssessmentMailMutation, { data, loading, error }] = useToggleAssessmentMailMutation({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *      isAssessmentMail: // value for 'isAssessmentMail'
 *   },
 * });
 */
export function useToggleAssessmentMailMutation(baseOptions?: Apollo.MutationHookOptions<ToggleAssessmentMailMutation, ToggleAssessmentMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleAssessmentMailMutation, ToggleAssessmentMailMutationVariables>(ToggleAssessmentMailDocument, options);
      }
export type ToggleAssessmentMailMutationHookResult = ReturnType<typeof useToggleAssessmentMailMutation>;
export type ToggleAssessmentMailMutationResult = Apollo.MutationResult<ToggleAssessmentMailMutation>;
export type ToggleAssessmentMailMutationOptions = Apollo.BaseMutationOptions<ToggleAssessmentMailMutation, ToggleAssessmentMailMutationVariables>;
export const SendEmailDocument = gql`
    mutation SendEmail($emailInput: EmailInput!) {
  sendEmail(emailInput: $emailInput)
}
    `;
export type SendEmailMutationFn = Apollo.MutationFunction<SendEmailMutation, SendEmailMutationVariables>;

/**
 * __useSendEmailMutation__
 *
 * To run a mutation, you first call `useSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailMutation, { data, loading, error }] = useSendEmailMutation({
 *   variables: {
 *      emailInput: // value for 'emailInput'
 *   },
 * });
 */
export function useSendEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailMutation, SendEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailMutation, SendEmailMutationVariables>(SendEmailDocument, options);
      }
export type SendEmailMutationHookResult = ReturnType<typeof useSendEmailMutation>;
export type SendEmailMutationResult = Apollo.MutationResult<SendEmailMutation>;
export type SendEmailMutationOptions = Apollo.BaseMutationOptions<SendEmailMutation, SendEmailMutationVariables>;
export const CreateAssignmentDocument = gql`
    mutation CreateAssignment($createAssignmentInput: CreateAssignmentInput!) {
  createAssignment(createAssignmentInput: $createAssignmentInput) {
    _id
    id
    name
    short_description
    description
    start_time
    due_date
    duration
    languages
    domain
    updatedBy
    updatedAt
    createdBy
    createdAt
  }
}
    `;
export type CreateAssignmentMutationFn = Apollo.MutationFunction<CreateAssignmentMutation, CreateAssignmentMutationVariables>;

/**
 * __useCreateAssignmentMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentMutation, { data, loading, error }] = useCreateAssignmentMutation({
 *   variables: {
 *      createAssignmentInput: // value for 'createAssignmentInput'
 *   },
 * });
 */
export function useCreateAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssignmentMutation, CreateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssignmentMutation, CreateAssignmentMutationVariables>(CreateAssignmentDocument, options);
      }
export type CreateAssignmentMutationHookResult = ReturnType<typeof useCreateAssignmentMutation>;
export type CreateAssignmentMutationResult = Apollo.MutationResult<CreateAssignmentMutation>;
export type CreateAssignmentMutationOptions = Apollo.BaseMutationOptions<CreateAssignmentMutation, CreateAssignmentMutationVariables>;
export const UpdateAssignmentDocument = gql`
    mutation UpdateAssignment($id: String!, $updateAssignmentInput: UpdateAssignmentInput!) {
  updateAssignment(id: $id, updateAssignmentInput: $updateAssignmentInput) {
    _id
    id
    name
    short_description
    description
    start_time
    due_date
    duration
    languages
    domain
    updatedBy
    updatedAt
    createdBy
    createdAt
  }
}
    `;
export type UpdateAssignmentMutationFn = Apollo.MutationFunction<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>;

/**
 * __useUpdateAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentMutation, { data, loading, error }] = useUpdateAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateAssignmentInput: // value for 'updateAssignmentInput'
 *   },
 * });
 */
export function useUpdateAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>(UpdateAssignmentDocument, options);
      }
export type UpdateAssignmentMutationHookResult = ReturnType<typeof useUpdateAssignmentMutation>;
export type UpdateAssignmentMutationResult = Apollo.MutationResult<UpdateAssignmentMutation>;
export type UpdateAssignmentMutationOptions = Apollo.BaseMutationOptions<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>;
export const CreateBulkAssignmentQuestionsDocument = gql`
    mutation CreateBulkAssignmentQuestions($createQuestionsInput: [CreateAssignmentQuestionInput!]!) {
  createBulkAssignmentQuestions(createQuestionsInput: $createQuestionsInput) {
    id
    assignment_id
    title
    text
    question_sub_text
    test_cases {
      id
      visibility
      input
      output
      weightage
    }
    marks
    predefinedCode {
      c
      java
      python
      cpp
    }
    showFunctionOnly
    targetFunctionName
    difficulty
    hints
    tags
    company_tags
    updated_by
    updated_at
    created_by
    created_at
  }
}
    `;
export type CreateBulkAssignmentQuestionsMutationFn = Apollo.MutationFunction<CreateBulkAssignmentQuestionsMutation, CreateBulkAssignmentQuestionsMutationVariables>;

/**
 * __useCreateBulkAssignmentQuestionsMutation__
 *
 * To run a mutation, you first call `useCreateBulkAssignmentQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkAssignmentQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkAssignmentQuestionsMutation, { data, loading, error }] = useCreateBulkAssignmentQuestionsMutation({
 *   variables: {
 *      createQuestionsInput: // value for 'createQuestionsInput'
 *   },
 * });
 */
export function useCreateBulkAssignmentQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateBulkAssignmentQuestionsMutation, CreateBulkAssignmentQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBulkAssignmentQuestionsMutation, CreateBulkAssignmentQuestionsMutationVariables>(CreateBulkAssignmentQuestionsDocument, options);
      }
export type CreateBulkAssignmentQuestionsMutationHookResult = ReturnType<typeof useCreateBulkAssignmentQuestionsMutation>;
export type CreateBulkAssignmentQuestionsMutationResult = Apollo.MutationResult<CreateBulkAssignmentQuestionsMutation>;
export type CreateBulkAssignmentQuestionsMutationOptions = Apollo.BaseMutationOptions<CreateBulkAssignmentQuestionsMutation, CreateBulkAssignmentQuestionsMutationVariables>;
export const CreateAssignmentQuestionDocument = gql`
    mutation createAssignmentQuestion($createQuestionInput: CreateAssignmentQuestionInput!) {
  createAssignmentQuestion(createQuestionInput: $createQuestionInput) {
    id
    assignment_id
    title
    text
    question_sub_text
    test_cases {
      id
      visibility
      input
      output
      weightage
    }
    marks
    predefinedCode {
      c
      java
      python
      cpp
    }
    showFunctionOnly
    targetFunctionName
    difficulty
    hints
    tags
    company_tags
    updated_by
    updated_at
    created_by
    created_at
  }
}
    `;
export type CreateAssignmentQuestionMutationFn = Apollo.MutationFunction<CreateAssignmentQuestionMutation, CreateAssignmentQuestionMutationVariables>;

/**
 * __useCreateAssignmentQuestionMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentQuestionMutation, { data, loading, error }] = useCreateAssignmentQuestionMutation({
 *   variables: {
 *      createQuestionInput: // value for 'createQuestionInput'
 *   },
 * });
 */
export function useCreateAssignmentQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssignmentQuestionMutation, CreateAssignmentQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssignmentQuestionMutation, CreateAssignmentQuestionMutationVariables>(CreateAssignmentQuestionDocument, options);
      }
export type CreateAssignmentQuestionMutationHookResult = ReturnType<typeof useCreateAssignmentQuestionMutation>;
export type CreateAssignmentQuestionMutationResult = Apollo.MutationResult<CreateAssignmentQuestionMutation>;
export type CreateAssignmentQuestionMutationOptions = Apollo.BaseMutationOptions<CreateAssignmentQuestionMutation, CreateAssignmentQuestionMutationVariables>;
export const UpdateAssignmentQuestionDocument = gql`
    mutation updateAssignmentQuestion($id: String!, $updateQuestionInput: UpdateAssignmentQuestionInput!) {
  updateAssignmentQuestion(id: $id, updateQuestionInput: $updateQuestionInput) {
    id
    assignment_id
    title
    text
    question_sub_text
    test_cases {
      id
      visibility
      input
      output
      weightage
    }
    marks
    predefinedCode {
      c
      java
      python
      cpp
    }
    showFunctionOnly
    targetFunctionName
    difficulty
    hints
    tags
    company_tags
    updated_by
    updated_at
    created_by
    created_at
  }
}
    `;
export type UpdateAssignmentQuestionMutationFn = Apollo.MutationFunction<UpdateAssignmentQuestionMutation, UpdateAssignmentQuestionMutationVariables>;

/**
 * __useUpdateAssignmentQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentQuestionMutation, { data, loading, error }] = useUpdateAssignmentQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateQuestionInput: // value for 'updateQuestionInput'
 *   },
 * });
 */
export function useUpdateAssignmentQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentQuestionMutation, UpdateAssignmentQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentQuestionMutation, UpdateAssignmentQuestionMutationVariables>(UpdateAssignmentQuestionDocument, options);
      }
export type UpdateAssignmentQuestionMutationHookResult = ReturnType<typeof useUpdateAssignmentQuestionMutation>;
export type UpdateAssignmentQuestionMutationResult = Apollo.MutationResult<UpdateAssignmentQuestionMutation>;
export type UpdateAssignmentQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateAssignmentQuestionMutation, UpdateAssignmentQuestionMutationVariables>;
export const DeleteAssignmentQuestionDocument = gql`
    mutation deleteAssignmentQuestion($id: String!) {
  deleteAssignmentQuestion(id: $id)
}
    `;
export type DeleteAssignmentQuestionMutationFn = Apollo.MutationFunction<DeleteAssignmentQuestionMutation, DeleteAssignmentQuestionMutationVariables>;

/**
 * __useDeleteAssignmentQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentQuestionMutation, { data, loading, error }] = useDeleteAssignmentQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssignmentQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignmentQuestionMutation, DeleteAssignmentQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignmentQuestionMutation, DeleteAssignmentQuestionMutationVariables>(DeleteAssignmentQuestionDocument, options);
      }
export type DeleteAssignmentQuestionMutationHookResult = ReturnType<typeof useDeleteAssignmentQuestionMutation>;
export type DeleteAssignmentQuestionMutationResult = Apollo.MutationResult<DeleteAssignmentQuestionMutation>;
export type DeleteAssignmentQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteAssignmentQuestionMutation, DeleteAssignmentQuestionMutationVariables>;
export const RemoveAssignmentDocument = gql`
    mutation removeAssignment($id: String!, $folderId: String!) {
  removeAssignement(id: $id, folderId: $folderId)
}
    `;
export type RemoveAssignmentMutationFn = Apollo.MutationFunction<RemoveAssignmentMutation, RemoveAssignmentMutationVariables>;

/**
 * __useRemoveAssignmentMutation__
 *
 * To run a mutation, you first call `useRemoveAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssignmentMutation, { data, loading, error }] = useRemoveAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useRemoveAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAssignmentMutation, RemoveAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAssignmentMutation, RemoveAssignmentMutationVariables>(RemoveAssignmentDocument, options);
      }
export type RemoveAssignmentMutationHookResult = ReturnType<typeof useRemoveAssignmentMutation>;
export type RemoveAssignmentMutationResult = Apollo.MutationResult<RemoveAssignmentMutation>;
export type RemoveAssignmentMutationOptions = Apollo.BaseMutationOptions<RemoveAssignmentMutation, RemoveAssignmentMutationVariables>;
export const RemoveAssignmentFromStudentDocument = gql`
    mutation RemoveAssignmentFromStudent($removeAssignmentInput: RemoveAssignmentInput!) {
  removeAssignmentFromStudent(removeAssignmentInput: $removeAssignmentInput) {
    id
    name
    email
    assignmentIds
  }
}
    `;
export type RemoveAssignmentFromStudentMutationFn = Apollo.MutationFunction<RemoveAssignmentFromStudentMutation, RemoveAssignmentFromStudentMutationVariables>;

/**
 * __useRemoveAssignmentFromStudentMutation__
 *
 * To run a mutation, you first call `useRemoveAssignmentFromStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssignmentFromStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssignmentFromStudentMutation, { data, loading, error }] = useRemoveAssignmentFromStudentMutation({
 *   variables: {
 *      removeAssignmentInput: // value for 'removeAssignmentInput'
 *   },
 * });
 */
export function useRemoveAssignmentFromStudentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAssignmentFromStudentMutation, RemoveAssignmentFromStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAssignmentFromStudentMutation, RemoveAssignmentFromStudentMutationVariables>(RemoveAssignmentFromStudentDocument, options);
      }
export type RemoveAssignmentFromStudentMutationHookResult = ReturnType<typeof useRemoveAssignmentFromStudentMutation>;
export type RemoveAssignmentFromStudentMutationResult = Apollo.MutationResult<RemoveAssignmentFromStudentMutation>;
export type RemoveAssignmentFromStudentMutationOptions = Apollo.BaseMutationOptions<RemoveAssignmentFromStudentMutation, RemoveAssignmentFromStudentMutationVariables>;
export const SubmitAssignmentCodeDocument = gql`
    mutation SubmitAssignmentCode($assignmentCompilerCodeInput: CompilerInput!, $assignmentSubmitInput: AssignmentSubmitInput!) {
  submitAssignmentCode(
    assignmentCompilerCodeInput: $assignmentCompilerCodeInput
    assignmentSubmitInput: $assignmentSubmitInput
  ) {
    compilationOutput {
      stdout
      stderr
    }
    testCasePassed {
      count
      testCaseIds {
        testCaseId
        stdout
      }
    }
    testCaseFailed {
      count
      testCaseIds {
        testCaseId
        stdout
      }
    }
    Results {
      input
      output
      expextedOutput
      error
    }
  }
}
    `;
export type SubmitAssignmentCodeMutationFn = Apollo.MutationFunction<SubmitAssignmentCodeMutation, SubmitAssignmentCodeMutationVariables>;

/**
 * __useSubmitAssignmentCodeMutation__
 *
 * To run a mutation, you first call `useSubmitAssignmentCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAssignmentCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAssignmentCodeMutation, { data, loading, error }] = useSubmitAssignmentCodeMutation({
 *   variables: {
 *      assignmentCompilerCodeInput: // value for 'assignmentCompilerCodeInput'
 *      assignmentSubmitInput: // value for 'assignmentSubmitInput'
 *   },
 * });
 */
export function useSubmitAssignmentCodeMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAssignmentCodeMutation, SubmitAssignmentCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAssignmentCodeMutation, SubmitAssignmentCodeMutationVariables>(SubmitAssignmentCodeDocument, options);
      }
export type SubmitAssignmentCodeMutationHookResult = ReturnType<typeof useSubmitAssignmentCodeMutation>;
export type SubmitAssignmentCodeMutationResult = Apollo.MutationResult<SubmitAssignmentCodeMutation>;
export type SubmitAssignmentCodeMutationOptions = Apollo.BaseMutationOptions<SubmitAssignmentCodeMutation, SubmitAssignmentCodeMutationVariables>;
export const FinalSubmitAssignmentDocument = gql`
    mutation FinalSubmitAssignment($AssignmentInput: AssignmentInput!) {
  finalSubmitAssignment(AssignmentInput: $AssignmentInput) {
    id
    assignment_id
    student_id
    questions {
      question_id
      answer
      score
      language
    }
    totalScore
    tabSwitches
    cheat_count
    completed
  }
}
    `;
export type FinalSubmitAssignmentMutationFn = Apollo.MutationFunction<FinalSubmitAssignmentMutation, FinalSubmitAssignmentMutationVariables>;

/**
 * __useFinalSubmitAssignmentMutation__
 *
 * To run a mutation, you first call `useFinalSubmitAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalSubmitAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalSubmitAssignmentMutation, { data, loading, error }] = useFinalSubmitAssignmentMutation({
 *   variables: {
 *      AssignmentInput: // value for 'AssignmentInput'
 *   },
 * });
 */
export function useFinalSubmitAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<FinalSubmitAssignmentMutation, FinalSubmitAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalSubmitAssignmentMutation, FinalSubmitAssignmentMutationVariables>(FinalSubmitAssignmentDocument, options);
      }
export type FinalSubmitAssignmentMutationHookResult = ReturnType<typeof useFinalSubmitAssignmentMutation>;
export type FinalSubmitAssignmentMutationResult = Apollo.MutationResult<FinalSubmitAssignmentMutation>;
export type FinalSubmitAssignmentMutationOptions = Apollo.BaseMutationOptions<FinalSubmitAssignmentMutation, FinalSubmitAssignmentMutationVariables>;
export const DeleteBulkStudentsDocument = gql`
    mutation DeleteBulkStudents($studentIds: [String!]!, $campusName: String!) {
  deleteBulkStudents(studentIds: $studentIds, campusName: $campusName) {
    successCount
    failedCount
    deletedEmails
    failedStudents {
      email
      studentId
      reason
    }
    message
  }
}
    `;
export type DeleteBulkStudentsMutationFn = Apollo.MutationFunction<DeleteBulkStudentsMutation, DeleteBulkStudentsMutationVariables>;

/**
 * __useDeleteBulkStudentsMutation__
 *
 * To run a mutation, you first call `useDeleteBulkStudentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBulkStudentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBulkStudentsMutation, { data, loading, error }] = useDeleteBulkStudentsMutation({
 *   variables: {
 *      studentIds: // value for 'studentIds'
 *      campusName: // value for 'campusName'
 *   },
 * });
 */
export function useDeleteBulkStudentsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBulkStudentsMutation, DeleteBulkStudentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBulkStudentsMutation, DeleteBulkStudentsMutationVariables>(DeleteBulkStudentsDocument, options);
      }
export type DeleteBulkStudentsMutationHookResult = ReturnType<typeof useDeleteBulkStudentsMutation>;
export type DeleteBulkStudentsMutationResult = Apollo.MutationResult<DeleteBulkStudentsMutation>;
export type DeleteBulkStudentsMutationOptions = Apollo.BaseMutationOptions<DeleteBulkStudentsMutation, DeleteBulkStudentsMutationVariables>;
export const AddQuestionsToCourseDocument = gql`
    mutation addQuestionsToCourse($courseId: String!, $questionIds: [String!]!) {
  addQuestionsToCourse(courseId: $courseId, questionIds: $questionIds) {
    id
    name
    short_description
    description
    categories {
      id
      name
      description
    }
    price
    time_period
    languages
    level
    domain
    question_ids
    easy_count
    hard_count
    medium_count
  }
}
    `;
export type AddQuestionsToCourseMutationFn = Apollo.MutationFunction<AddQuestionsToCourseMutation, AddQuestionsToCourseMutationVariables>;

/**
 * __useAddQuestionsToCourseMutation__
 *
 * To run a mutation, you first call `useAddQuestionsToCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuestionsToCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuestionsToCourseMutation, { data, loading, error }] = useAddQuestionsToCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      questionIds: // value for 'questionIds'
 *   },
 * });
 */
export function useAddQuestionsToCourseMutation(baseOptions?: Apollo.MutationHookOptions<AddQuestionsToCourseMutation, AddQuestionsToCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQuestionsToCourseMutation, AddQuestionsToCourseMutationVariables>(AddQuestionsToCourseDocument, options);
      }
export type AddQuestionsToCourseMutationHookResult = ReturnType<typeof useAddQuestionsToCourseMutation>;
export type AddQuestionsToCourseMutationResult = Apollo.MutationResult<AddQuestionsToCourseMutation>;
export type AddQuestionsToCourseMutationOptions = Apollo.BaseMutationOptions<AddQuestionsToCourseMutation, AddQuestionsToCourseMutationVariables>;
export const RemoveAssignmentFromClusterDocument = gql`
    mutation removeAssignmentFromCluster($campusName: String!, $clusterId: String!, $assignmentId: String!) {
  removeAssignmentFromCluster(
    campusName: $campusName
    clusterId: $clusterId
    assignmentId: $assignmentId
  ) {
    courseIds
    studentCount
  }
}
    `;
export type RemoveAssignmentFromClusterMutationFn = Apollo.MutationFunction<RemoveAssignmentFromClusterMutation, RemoveAssignmentFromClusterMutationVariables>;

/**
 * __useRemoveAssignmentFromClusterMutation__
 *
 * To run a mutation, you first call `useRemoveAssignmentFromClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssignmentFromClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssignmentFromClusterMutation, { data, loading, error }] = useRemoveAssignmentFromClusterMutation({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useRemoveAssignmentFromClusterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAssignmentFromClusterMutation, RemoveAssignmentFromClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAssignmentFromClusterMutation, RemoveAssignmentFromClusterMutationVariables>(RemoveAssignmentFromClusterDocument, options);
      }
export type RemoveAssignmentFromClusterMutationHookResult = ReturnType<typeof useRemoveAssignmentFromClusterMutation>;
export type RemoveAssignmentFromClusterMutationResult = Apollo.MutationResult<RemoveAssignmentFromClusterMutation>;
export type RemoveAssignmentFromClusterMutationOptions = Apollo.BaseMutationOptions<RemoveAssignmentFromClusterMutation, RemoveAssignmentFromClusterMutationVariables>;
export const UpdateAdminDocument = gql`
    mutation UpdateAdmin($updateAdminInput: UpdateAdminInput!) {
  updateAdmin(updateAdminInput: $updateAdminInput) {
    id
    name
    email
    isSuperAdmin
    permissions {
      courses
      assignments
      reports
      student_creation
    }
  }
}
    `;
export type UpdateAdminMutationFn = Apollo.MutationFunction<UpdateAdminMutation, UpdateAdminMutationVariables>;

/**
 * __useUpdateAdminMutation__
 *
 * To run a mutation, you first call `useUpdateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminMutation, { data, loading, error }] = useUpdateAdminMutation({
 *   variables: {
 *      updateAdminInput: // value for 'updateAdminInput'
 *   },
 * });
 */
export function useUpdateAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminMutation, UpdateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminMutation, UpdateAdminMutationVariables>(UpdateAdminDocument, options);
      }
export type UpdateAdminMutationHookResult = ReturnType<typeof useUpdateAdminMutation>;
export type UpdateAdminMutationResult = Apollo.MutationResult<UpdateAdminMutation>;
export type UpdateAdminMutationOptions = Apollo.BaseMutationOptions<UpdateAdminMutation, UpdateAdminMutationVariables>;
export const CreateFolderDocument = gql`
    mutation createFolder($createFolderDto: CreateFolderDto!) {
  createFolder(createFolderDto: $createFolderDto) {
    __typename
    _id
    id
    name
    assignments
  }
}
    `;
export type CreateFolderMutationFn = Apollo.MutationFunction<CreateFolderMutation, CreateFolderMutationVariables>;

/**
 * __useCreateFolderMutation__
 *
 * To run a mutation, you first call `useCreateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFolderMutation, { data, loading, error }] = useCreateFolderMutation({
 *   variables: {
 *      createFolderDto: // value for 'createFolderDto'
 *   },
 * });
 */
export function useCreateFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateFolderMutation, CreateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFolderMutation, CreateFolderMutationVariables>(CreateFolderDocument, options);
      }
export type CreateFolderMutationHookResult = ReturnType<typeof useCreateFolderMutation>;
export type CreateFolderMutationResult = Apollo.MutationResult<CreateFolderMutation>;
export type CreateFolderMutationOptions = Apollo.BaseMutationOptions<CreateFolderMutation, CreateFolderMutationVariables>;
export const CreateReportMessageDocument = gql`
    mutation CreateReportMessage($input: CreateReportMessageInput!) {
  createReportMessage(createReportMessageInput: $input) {
    id
    ranges {
      rangeLabel
      entries {
        campusName
        message
        greeting
      }
    }
    createdAt
    updatedAt
  }
}
    `;
export type CreateReportMessageMutationFn = Apollo.MutationFunction<CreateReportMessageMutation, CreateReportMessageMutationVariables>;

/**
 * __useCreateReportMessageMutation__
 *
 * To run a mutation, you first call `useCreateReportMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMessageMutation, { data, loading, error }] = useCreateReportMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportMessageMutation, CreateReportMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportMessageMutation, CreateReportMessageMutationVariables>(CreateReportMessageDocument, options);
      }
export type CreateReportMessageMutationHookResult = ReturnType<typeof useCreateReportMessageMutation>;
export type CreateReportMessageMutationResult = Apollo.MutationResult<CreateReportMessageMutation>;
export type CreateReportMessageMutationOptions = Apollo.BaseMutationOptions<CreateReportMessageMutation, CreateReportMessageMutationVariables>;
export const UpsertMessageInRangeDocument = gql`
    mutation UpsertMessageInRange($input: UpsertMessageInRangeInput!) {
  upsertMessageInRange(upsertMessageInRangeInput: $input) {
    id
    ranges {
      rangeLabel
      entries {
        campusName
        message
        greeting
      }
    }
    updatedAt
  }
}
    `;
export type UpsertMessageInRangeMutationFn = Apollo.MutationFunction<UpsertMessageInRangeMutation, UpsertMessageInRangeMutationVariables>;

/**
 * __useUpsertMessageInRangeMutation__
 *
 * To run a mutation, you first call `useUpsertMessageInRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMessageInRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMessageInRangeMutation, { data, loading, error }] = useUpsertMessageInRangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertMessageInRangeMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMessageInRangeMutation, UpsertMessageInRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMessageInRangeMutation, UpsertMessageInRangeMutationVariables>(UpsertMessageInRangeDocument, options);
      }
export type UpsertMessageInRangeMutationHookResult = ReturnType<typeof useUpsertMessageInRangeMutation>;
export type UpsertMessageInRangeMutationResult = Apollo.MutationResult<UpsertMessageInRangeMutation>;
export type UpsertMessageInRangeMutationOptions = Apollo.BaseMutationOptions<UpsertMessageInRangeMutation, UpsertMessageInRangeMutationVariables>;
export const CreateRangeLevelDocument = gql`
    mutation CreateRangeLevel($input: CreateRangeLevelInput!) {
  createRangeLevel(createRangeLevelInput: $input) {
    id
    ranges {
      rangeLabel
      entries {
        campusName
        message
        greeting
      }
    }
  }
}
    `;
export type CreateRangeLevelMutationFn = Apollo.MutationFunction<CreateRangeLevelMutation, CreateRangeLevelMutationVariables>;

/**
 * __useCreateRangeLevelMutation__
 *
 * To run a mutation, you first call `useCreateRangeLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRangeLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRangeLevelMutation, { data, loading, error }] = useCreateRangeLevelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRangeLevelMutation(baseOptions?: Apollo.MutationHookOptions<CreateRangeLevelMutation, CreateRangeLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRangeLevelMutation, CreateRangeLevelMutationVariables>(CreateRangeLevelDocument, options);
      }
export type CreateRangeLevelMutationHookResult = ReturnType<typeof useCreateRangeLevelMutation>;
export type CreateRangeLevelMutationResult = Apollo.MutationResult<CreateRangeLevelMutation>;
export type CreateRangeLevelMutationOptions = Apollo.BaseMutationOptions<CreateRangeLevelMutation, CreateRangeLevelMutationVariables>;
export const UpdateRangeLevelDocument = gql`
    mutation UpdateRangeLevel($input: UpdateRangeLevelInput!) {
  updateRangeLevel(updateRangeLevelInput: $input) {
    id
    ranges {
      rangeLabel
      entries {
        campusName
        message
        greeting
      }
    }
  }
}
    `;
export type UpdateRangeLevelMutationFn = Apollo.MutationFunction<UpdateRangeLevelMutation, UpdateRangeLevelMutationVariables>;

/**
 * __useUpdateRangeLevelMutation__
 *
 * To run a mutation, you first call `useUpdateRangeLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRangeLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRangeLevelMutation, { data, loading, error }] = useUpdateRangeLevelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRangeLevelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRangeLevelMutation, UpdateRangeLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRangeLevelMutation, UpdateRangeLevelMutationVariables>(UpdateRangeLevelDocument, options);
      }
export type UpdateRangeLevelMutationHookResult = ReturnType<typeof useUpdateRangeLevelMutation>;
export type UpdateRangeLevelMutationResult = Apollo.MutationResult<UpdateRangeLevelMutation>;
export type UpdateRangeLevelMutationOptions = Apollo.BaseMutationOptions<UpdateRangeLevelMutation, UpdateRangeLevelMutationVariables>;
export const DeleteRangeLevelDocument = gql`
    mutation DeleteRangeLevel($input: DeleteRangeLevelInput!) {
  deleteRangeLevel(deleteRangeLevelInput: $input) {
    id
    ranges {
      rangeLabel
      entries {
        campusName
        message
        greeting
      }
    }
  }
}
    `;
export type DeleteRangeLevelMutationFn = Apollo.MutationFunction<DeleteRangeLevelMutation, DeleteRangeLevelMutationVariables>;

/**
 * __useDeleteRangeLevelMutation__
 *
 * To run a mutation, you first call `useDeleteRangeLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRangeLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRangeLevelMutation, { data, loading, error }] = useDeleteRangeLevelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRangeLevelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRangeLevelMutation, DeleteRangeLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRangeLevelMutation, DeleteRangeLevelMutationVariables>(DeleteRangeLevelDocument, options);
      }
export type DeleteRangeLevelMutationHookResult = ReturnType<typeof useDeleteRangeLevelMutation>;
export type DeleteRangeLevelMutationResult = Apollo.MutationResult<DeleteRangeLevelMutation>;
export type DeleteRangeLevelMutationOptions = Apollo.BaseMutationOptions<DeleteRangeLevelMutation, DeleteRangeLevelMutationVariables>;
export const DeleteMessageInRangeDocument = gql`
    mutation DeleteMessageInRange($input: DeleteMessageInRangeInput!) {
  deleteMessageInRange(deleteMessageInRangeInput: $input) {
    id
    ranges {
      rangeLabel
      entries {
        campusName
        message
        greeting
      }
    }
  }
}
    `;
export type DeleteMessageInRangeMutationFn = Apollo.MutationFunction<DeleteMessageInRangeMutation, DeleteMessageInRangeMutationVariables>;

/**
 * __useDeleteMessageInRangeMutation__
 *
 * To run a mutation, you first call `useDeleteMessageInRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageInRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageInRangeMutation, { data, loading, error }] = useDeleteMessageInRangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMessageInRangeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageInRangeMutation, DeleteMessageInRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageInRangeMutation, DeleteMessageInRangeMutationVariables>(DeleteMessageInRangeDocument, options);
      }
export type DeleteMessageInRangeMutationHookResult = ReturnType<typeof useDeleteMessageInRangeMutation>;
export type DeleteMessageInRangeMutationResult = Apollo.MutationResult<DeleteMessageInRangeMutation>;
export type DeleteMessageInRangeMutationOptions = Apollo.BaseMutationOptions<DeleteMessageInRangeMutation, DeleteMessageInRangeMutationVariables>;
export const GetAllRangeLevelsDocument = gql`
    mutation GetAllRangeLevels {
  getAllRangeLevels
}
    `;
export type GetAllRangeLevelsMutationFn = Apollo.MutationFunction<GetAllRangeLevelsMutation, GetAllRangeLevelsMutationVariables>;

/**
 * __useGetAllRangeLevelsMutation__
 *
 * To run a mutation, you first call `useGetAllRangeLevelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAllRangeLevelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAllRangeLevelsMutation, { data, loading, error }] = useGetAllRangeLevelsMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRangeLevelsMutation(baseOptions?: Apollo.MutationHookOptions<GetAllRangeLevelsMutation, GetAllRangeLevelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAllRangeLevelsMutation, GetAllRangeLevelsMutationVariables>(GetAllRangeLevelsDocument, options);
      }
export type GetAllRangeLevelsMutationHookResult = ReturnType<typeof useGetAllRangeLevelsMutation>;
export type GetAllRangeLevelsMutationResult = Apollo.MutationResult<GetAllRangeLevelsMutation>;
export type GetAllRangeLevelsMutationOptions = Apollo.BaseMutationOptions<GetAllRangeLevelsMutation, GetAllRangeLevelsMutationVariables>;
export const UpdateFolderDocument = gql`
    mutation updateFolder($id: String!, $updateFolderDto: UpdateFolderDto!) {
  updateFolder(id: $id, updateFolderDto: $updateFolderDto) {
    __typename
    _id
    id
    name
    assignments
  }
}
    `;
export type UpdateFolderMutationFn = Apollo.MutationFunction<UpdateFolderMutation, UpdateFolderMutationVariables>;

/**
 * __useUpdateFolderMutation__
 *
 * To run a mutation, you first call `useUpdateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFolderMutation, { data, loading, error }] = useUpdateFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateFolderDto: // value for 'updateFolderDto'
 *   },
 * });
 */
export function useUpdateFolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFolderMutation, UpdateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFolderMutation, UpdateFolderMutationVariables>(UpdateFolderDocument, options);
      }
export type UpdateFolderMutationHookResult = ReturnType<typeof useUpdateFolderMutation>;
export type UpdateFolderMutationResult = Apollo.MutationResult<UpdateFolderMutation>;
export type UpdateFolderMutationOptions = Apollo.BaseMutationOptions<UpdateFolderMutation, UpdateFolderMutationVariables>;
export const DeleteFolderDocument = gql`
    mutation deleteFolder($id: String!) {
  deleteFolder(id: $id)
}
    `;
export type DeleteFolderMutationFn = Apollo.MutationFunction<DeleteFolderMutation, DeleteFolderMutationVariables>;

/**
 * __useDeleteFolderMutation__
 *
 * To run a mutation, you first call `useDeleteFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderMutation, { data, loading, error }] = useDeleteFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFolderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFolderMutation, DeleteFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFolderMutation, DeleteFolderMutationVariables>(DeleteFolderDocument, options);
      }
export type DeleteFolderMutationHookResult = ReturnType<typeof useDeleteFolderMutation>;
export type DeleteFolderMutationResult = Apollo.MutationResult<DeleteFolderMutation>;
export type DeleteFolderMutationOptions = Apollo.BaseMutationOptions<DeleteFolderMutation, DeleteFolderMutationVariables>;
export const RemoveAssignementDocument = gql`
    mutation removeAssignement($id: String!, $folderId: String!) {
  removeAssignement(id: $id, folderId: $folderId)
}
    `;
export type RemoveAssignementMutationFn = Apollo.MutationFunction<RemoveAssignementMutation, RemoveAssignementMutationVariables>;

/**
 * __useRemoveAssignementMutation__
 *
 * To run a mutation, you first call `useRemoveAssignementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssignementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssignementMutation, { data, loading, error }] = useRemoveAssignementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useRemoveAssignementMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAssignementMutation, RemoveAssignementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAssignementMutation, RemoveAssignementMutationVariables>(RemoveAssignementDocument, options);
      }
export type RemoveAssignementMutationHookResult = ReturnType<typeof useRemoveAssignementMutation>;
export type RemoveAssignementMutationResult = Apollo.MutationResult<RemoveAssignementMutation>;
export type RemoveAssignementMutationOptions = Apollo.BaseMutationOptions<RemoveAssignementMutation, RemoveAssignementMutationVariables>;
export const SaveAutoSaveDocument = gql`
    mutation saveAutoSave($submitInput: SubmitInput!, $code: String!, $language: String!) {
  saveAutoSave(submitInput: $submitInput, code: $code, language: $language)
}
    `;
export type SaveAutoSaveMutationFn = Apollo.MutationFunction<SaveAutoSaveMutation, SaveAutoSaveMutationVariables>;

/**
 * __useSaveAutoSaveMutation__
 *
 * To run a mutation, you first call `useSaveAutoSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAutoSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAutoSaveMutation, { data, loading, error }] = useSaveAutoSaveMutation({
 *   variables: {
 *      submitInput: // value for 'submitInput'
 *      code: // value for 'code'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSaveAutoSaveMutation(baseOptions?: Apollo.MutationHookOptions<SaveAutoSaveMutation, SaveAutoSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAutoSaveMutation, SaveAutoSaveMutationVariables>(SaveAutoSaveDocument, options);
      }
export type SaveAutoSaveMutationHookResult = ReturnType<typeof useSaveAutoSaveMutation>;
export type SaveAutoSaveMutationResult = Apollo.MutationResult<SaveAutoSaveMutation>;
export type SaveAutoSaveMutationOptions = Apollo.BaseMutationOptions<SaveAutoSaveMutation, SaveAutoSaveMutationVariables>;
export const SaveAssignmentCodeDocument = gql`
    mutation saveAssignmentCode($saveCodeInput: AssignmentSubmitInput!, $code: String!, $language: String!) {
  saveAssignmentCode(
    saveCodeInput: $saveCodeInput
    code: $code
    language: $language
  )
}
    `;
export type SaveAssignmentCodeMutationFn = Apollo.MutationFunction<SaveAssignmentCodeMutation, SaveAssignmentCodeMutationVariables>;

/**
 * __useSaveAssignmentCodeMutation__
 *
 * To run a mutation, you first call `useSaveAssignmentCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAssignmentCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAssignmentCodeMutation, { data, loading, error }] = useSaveAssignmentCodeMutation({
 *   variables: {
 *      saveCodeInput: // value for 'saveCodeInput'
 *      code: // value for 'code'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSaveAssignmentCodeMutation(baseOptions?: Apollo.MutationHookOptions<SaveAssignmentCodeMutation, SaveAssignmentCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAssignmentCodeMutation, SaveAssignmentCodeMutationVariables>(SaveAssignmentCodeDocument, options);
      }
export type SaveAssignmentCodeMutationHookResult = ReturnType<typeof useSaveAssignmentCodeMutation>;
export type SaveAssignmentCodeMutationResult = Apollo.MutationResult<SaveAssignmentCodeMutation>;
export type SaveAssignmentCodeMutationOptions = Apollo.BaseMutationOptions<SaveAssignmentCodeMutation, SaveAssignmentCodeMutationVariables>;
export const AddAssignmentToClusterDocument = gql`
    mutation addAssignmentToCluster($campusName: String!, $clusterId: String!, $assignmentId: String!, $isEmail: Boolean!) {
  addAssignmentToCluster(
    campusName: $campusName
    clusterId: $clusterId
    assignmentId: $assignmentId
    isEmail: $isEmail
  ) {
    __typename
    id
    name
    campusName
    courseIds
    assignmentIds
    createdAt
    studentCount
    staffs {
      id
      name
      email
      campusId
      designation
      contactNo
      clusterIds
      isInviteSend
      isAdminStaff
    }
    sendEmail
  }
}
    `;
export type AddAssignmentToClusterMutationFn = Apollo.MutationFunction<AddAssignmentToClusterMutation, AddAssignmentToClusterMutationVariables>;

/**
 * __useAddAssignmentToClusterMutation__
 *
 * To run a mutation, you first call `useAddAssignmentToClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAssignmentToClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAssignmentToClusterMutation, { data, loading, error }] = useAddAssignmentToClusterMutation({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *      assignmentId: // value for 'assignmentId'
 *      isEmail: // value for 'isEmail'
 *   },
 * });
 */
export function useAddAssignmentToClusterMutation(baseOptions?: Apollo.MutationHookOptions<AddAssignmentToClusterMutation, AddAssignmentToClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAssignmentToClusterMutation, AddAssignmentToClusterMutationVariables>(AddAssignmentToClusterDocument, options);
      }
export type AddAssignmentToClusterMutationHookResult = ReturnType<typeof useAddAssignmentToClusterMutation>;
export type AddAssignmentToClusterMutationResult = Apollo.MutationResult<AddAssignmentToClusterMutation>;
export type AddAssignmentToClusterMutationOptions = Apollo.BaseMutationOptions<AddAssignmentToClusterMutation, AddAssignmentToClusterMutationVariables>;
export const CreateRazorpayOrderDocument = gql`
    mutation createRazorpayOrder($orderId: String!, $courseId: String!) {
  createRazorpayOrder(orderId: $orderId, courseId: $courseId)
}
    `;
export type CreateRazorpayOrderMutationFn = Apollo.MutationFunction<CreateRazorpayOrderMutation, CreateRazorpayOrderMutationVariables>;

/**
 * __useCreateRazorpayOrderMutation__
 *
 * To run a mutation, you first call `useCreateRazorpayOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRazorpayOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRazorpayOrderMutation, { data, loading, error }] = useCreateRazorpayOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCreateRazorpayOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateRazorpayOrderMutation, CreateRazorpayOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRazorpayOrderMutation, CreateRazorpayOrderMutationVariables>(CreateRazorpayOrderDocument, options);
      }
export type CreateRazorpayOrderMutationHookResult = ReturnType<typeof useCreateRazorpayOrderMutation>;
export type CreateRazorpayOrderMutationResult = Apollo.MutationResult<CreateRazorpayOrderMutation>;
export type CreateRazorpayOrderMutationOptions = Apollo.BaseMutationOptions<CreateRazorpayOrderMutation, CreateRazorpayOrderMutationVariables>;
export const SavePaymentDetailsDocument = gql`
    mutation savePaymentDetails($createPaymentInput: CreatePaymentInput!) {
  savePaymentDetails(createPaymentInput: $createPaymentInput) {
    __typename
    id
    student_id
    course_id
    order_id
    payment_id
    amount_paid
    date_of_purchase
  }
}
    `;
export type SavePaymentDetailsMutationFn = Apollo.MutationFunction<SavePaymentDetailsMutation, SavePaymentDetailsMutationVariables>;

/**
 * __useSavePaymentDetailsMutation__
 *
 * To run a mutation, you first call `useSavePaymentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePaymentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePaymentDetailsMutation, { data, loading, error }] = useSavePaymentDetailsMutation({
 *   variables: {
 *      createPaymentInput: // value for 'createPaymentInput'
 *   },
 * });
 */
export function useSavePaymentDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SavePaymentDetailsMutation, SavePaymentDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePaymentDetailsMutation, SavePaymentDetailsMutationVariables>(SavePaymentDetailsDocument, options);
      }
export type SavePaymentDetailsMutationHookResult = ReturnType<typeof useSavePaymentDetailsMutation>;
export type SavePaymentDetailsMutationResult = Apollo.MutationResult<SavePaymentDetailsMutation>;
export type SavePaymentDetailsMutationOptions = Apollo.BaseMutationOptions<SavePaymentDetailsMutation, SavePaymentDetailsMutationVariables>;
export const ModuleSubmitCodeDocument = gql`
    mutation ModuleSubmitCode($compilerCodeInput: CompilerInput!, $moduleSubmitInput: ModuleSubmitInput!) {
  modulesubmitCode(
    compilerCodeInput: $compilerCodeInput
    ModuleSubmitInput: $moduleSubmitInput
  ) {
    compilationOutput {
      stdout
      stderr
    }
    submissions {
      code
      score
      submittedAt
      language
    }
    testCasePassed {
      count
      testCaseIds {
        testCaseId
        stdout
      }
    }
    testCaseFailed {
      count
      testCaseIds {
        testCaseId
        stdout
      }
    }
    Results {
      input
      output
      error
    }
  }
}
    `;
export type ModuleSubmitCodeMutationFn = Apollo.MutationFunction<ModuleSubmitCodeMutation, ModuleSubmitCodeMutationVariables>;

/**
 * __useModuleSubmitCodeMutation__
 *
 * To run a mutation, you first call `useModuleSubmitCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModuleSubmitCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moduleSubmitCodeMutation, { data, loading, error }] = useModuleSubmitCodeMutation({
 *   variables: {
 *      compilerCodeInput: // value for 'compilerCodeInput'
 *      moduleSubmitInput: // value for 'moduleSubmitInput'
 *   },
 * });
 */
export function useModuleSubmitCodeMutation(baseOptions?: Apollo.MutationHookOptions<ModuleSubmitCodeMutation, ModuleSubmitCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModuleSubmitCodeMutation, ModuleSubmitCodeMutationVariables>(ModuleSubmitCodeDocument, options);
      }
export type ModuleSubmitCodeMutationHookResult = ReturnType<typeof useModuleSubmitCodeMutation>;
export type ModuleSubmitCodeMutationResult = Apollo.MutationResult<ModuleSubmitCodeMutation>;
export type ModuleSubmitCodeMutationOptions = Apollo.BaseMutationOptions<ModuleSubmitCodeMutation, ModuleSubmitCodeMutationVariables>;
export const ModuleAutoSaveDocument = gql`
    mutation ModuleAutoSave($moduleSubmitInput: ModuleSubmitInput!, $code: String!, $language: String!) {
  ModuleAutoSave(
    moduleSubmitInput: $moduleSubmitInput
    code: $code
    language: $language
  )
}
    `;
export type ModuleAutoSaveMutationFn = Apollo.MutationFunction<ModuleAutoSaveMutation, ModuleAutoSaveMutationVariables>;

/**
 * __useModuleAutoSaveMutation__
 *
 * To run a mutation, you first call `useModuleAutoSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModuleAutoSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moduleAutoSaveMutation, { data, loading, error }] = useModuleAutoSaveMutation({
 *   variables: {
 *      moduleSubmitInput: // value for 'moduleSubmitInput'
 *      code: // value for 'code'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useModuleAutoSaveMutation(baseOptions?: Apollo.MutationHookOptions<ModuleAutoSaveMutation, ModuleAutoSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModuleAutoSaveMutation, ModuleAutoSaveMutationVariables>(ModuleAutoSaveDocument, options);
      }
export type ModuleAutoSaveMutationHookResult = ReturnType<typeof useModuleAutoSaveMutation>;
export type ModuleAutoSaveMutationResult = Apollo.MutationResult<ModuleAutoSaveMutation>;
export type ModuleAutoSaveMutationOptions = Apollo.BaseMutationOptions<ModuleAutoSaveMutation, ModuleAutoSaveMutationVariables>;
export const DeleteCronJobsDocument = gql`
    mutation DeleteCronJobs($jobIds: [String!]!) {
  deleteCronJobs(jobIds: $jobIds)
}
    `;
export type DeleteCronJobsMutationFn = Apollo.MutationFunction<DeleteCronJobsMutation, DeleteCronJobsMutationVariables>;

/**
 * __useDeleteCronJobsMutation__
 *
 * To run a mutation, you first call `useDeleteCronJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCronJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCronJobsMutation, { data, loading, error }] = useDeleteCronJobsMutation({
 *   variables: {
 *      jobIds: // value for 'jobIds'
 *   },
 * });
 */
export function useDeleteCronJobsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCronJobsMutation, DeleteCronJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCronJobsMutation, DeleteCronJobsMutationVariables>(DeleteCronJobsDocument, options);
      }
export type DeleteCronJobsMutationHookResult = ReturnType<typeof useDeleteCronJobsMutation>;
export type DeleteCronJobsMutationResult = Apollo.MutationResult<DeleteCronJobsMutation>;
export type DeleteCronJobsMutationOptions = Apollo.BaseMutationOptions<DeleteCronJobsMutation, DeleteCronJobsMutationVariables>;
export const TriggerCronReportsDocument = gql`
    mutation TriggerCronReports($jobIds: [String!]!) {
  triggerCronReports(jobIds: $jobIds)
}
    `;
export type TriggerCronReportsMutationFn = Apollo.MutationFunction<TriggerCronReportsMutation, TriggerCronReportsMutationVariables>;

/**
 * __useTriggerCronReportsMutation__
 *
 * To run a mutation, you first call `useTriggerCronReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerCronReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerCronReportsMutation, { data, loading, error }] = useTriggerCronReportsMutation({
 *   variables: {
 *      jobIds: // value for 'jobIds'
 *   },
 * });
 */
export function useTriggerCronReportsMutation(baseOptions?: Apollo.MutationHookOptions<TriggerCronReportsMutation, TriggerCronReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerCronReportsMutation, TriggerCronReportsMutationVariables>(TriggerCronReportsDocument, options);
      }
export type TriggerCronReportsMutationHookResult = ReturnType<typeof useTriggerCronReportsMutation>;
export type TriggerCronReportsMutationResult = Apollo.MutationResult<TriggerCronReportsMutation>;
export type TriggerCronReportsMutationOptions = Apollo.BaseMutationOptions<TriggerCronReportsMutation, TriggerCronReportsMutationVariables>;
export const UpdateModuleDocument = gql`
    mutation UpdateModule($id: String!, $data: ModuleInput!) {
  updateModule(id: $id, data: $data) {
    _id
    name
    short_description
    start_date
    end_date
    domain
    daywise_plan {
      day_id
      name
      questions
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateModuleMutationFn = Apollo.MutationFunction<UpdateModuleMutation, UpdateModuleMutationVariables>;

/**
 * __useUpdateModuleMutation__
 *
 * To run a mutation, you first call `useUpdateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModuleMutation, { data, loading, error }] = useUpdateModuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateModuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModuleMutation, UpdateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModuleMutation, UpdateModuleMutationVariables>(UpdateModuleDocument, options);
      }
export type UpdateModuleMutationHookResult = ReturnType<typeof useUpdateModuleMutation>;
export type UpdateModuleMutationResult = Apollo.MutationResult<UpdateModuleMutation>;
export type UpdateModuleMutationOptions = Apollo.BaseMutationOptions<UpdateModuleMutation, UpdateModuleMutationVariables>;
export const RevokeAssignmentDocument = gql`
    mutation RevokeAssignment($assignmentId: String!, $studentIds: [String!]!, $campus_name: String!) {
  revokeAssignment(
    assignmentId: $assignmentId
    studentIds: $studentIds
    campus_name: $campus_name
  ) {
    Status
    revokedCount
  }
}
    `;
export type RevokeAssignmentMutationFn = Apollo.MutationFunction<RevokeAssignmentMutation, RevokeAssignmentMutationVariables>;

/**
 * __useRevokeAssignmentMutation__
 *
 * To run a mutation, you first call `useRevokeAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAssignmentMutation, { data, loading, error }] = useRevokeAssignmentMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      studentIds: // value for 'studentIds'
 *      campus_name: // value for 'campus_name'
 *   },
 * });
 */
export function useRevokeAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<RevokeAssignmentMutation, RevokeAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeAssignmentMutation, RevokeAssignmentMutationVariables>(RevokeAssignmentDocument, options);
      }
export type RevokeAssignmentMutationHookResult = ReturnType<typeof useRevokeAssignmentMutation>;
export type RevokeAssignmentMutationResult = Apollo.MutationResult<RevokeAssignmentMutation>;
export type RevokeAssignmentMutationOptions = Apollo.BaseMutationOptions<RevokeAssignmentMutation, RevokeAssignmentMutationVariables>;
export const RecalculateClusterCountsDocument = gql`
    mutation RecalculateClusterCounts($campusName: String!) {
  recalculateClusterStudentCounts(campusName: $campusName)
}
    `;
export type RecalculateClusterCountsMutationFn = Apollo.MutationFunction<RecalculateClusterCountsMutation, RecalculateClusterCountsMutationVariables>;

/**
 * __useRecalculateClusterCountsMutation__
 *
 * To run a mutation, you first call `useRecalculateClusterCountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalculateClusterCountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalculateClusterCountsMutation, { data, loading, error }] = useRecalculateClusterCountsMutation({
 *   variables: {
 *      campusName: // value for 'campusName'
 *   },
 * });
 */
export function useRecalculateClusterCountsMutation(baseOptions?: Apollo.MutationHookOptions<RecalculateClusterCountsMutation, RecalculateClusterCountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecalculateClusterCountsMutation, RecalculateClusterCountsMutationVariables>(RecalculateClusterCountsDocument, options);
      }
export type RecalculateClusterCountsMutationHookResult = ReturnType<typeof useRecalculateClusterCountsMutation>;
export type RecalculateClusterCountsMutationResult = Apollo.MutationResult<RecalculateClusterCountsMutation>;
export type RecalculateClusterCountsMutationOptions = Apollo.BaseMutationOptions<RecalculateClusterCountsMutation, RecalculateClusterCountsMutationVariables>;
export const GetAllModulesDocument = gql`
    query GetAllModules {
  getAllModules {
    _id
    name
    domain
    short_description
    start_date
    end_date
    daywise_plan {
      name
      questions
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetAllModulesQuery__
 *
 * To run a query within a React component, call `useGetAllModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllModulesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllModulesQuery, GetAllModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllModulesQuery, GetAllModulesQueryVariables>(GetAllModulesDocument, options);
      }
export function useGetAllModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllModulesQuery, GetAllModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllModulesQuery, GetAllModulesQueryVariables>(GetAllModulesDocument, options);
        }
export function useGetAllModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllModulesQuery, GetAllModulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllModulesQuery, GetAllModulesQueryVariables>(GetAllModulesDocument, options);
        }
export type GetAllModulesQueryHookResult = ReturnType<typeof useGetAllModulesQuery>;
export type GetAllModulesLazyQueryHookResult = ReturnType<typeof useGetAllModulesLazyQuery>;
export type GetAllModulesSuspenseQueryHookResult = ReturnType<typeof useGetAllModulesSuspenseQuery>;
export type GetAllModulesQueryResult = Apollo.QueryResult<GetAllModulesQuery, GetAllModulesQueryVariables>;
export const GetClusterDetailsDocument = gql`
    query GetClusterDetails($campusName: String!, $clusterId: String!) {
  getCluster(campusName: $campusName, clusterId: $clusterId) {
    id
    name
    campusName
    moduleIds
  }
}
    `;

/**
 * __useGetClusterDetailsQuery__
 *
 * To run a query within a React component, call `useGetClusterDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClusterDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClusterDetailsQuery({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useGetClusterDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetClusterDetailsQuery, GetClusterDetailsQueryVariables> & ({ variables: GetClusterDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClusterDetailsQuery, GetClusterDetailsQueryVariables>(GetClusterDetailsDocument, options);
      }
export function useGetClusterDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClusterDetailsQuery, GetClusterDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClusterDetailsQuery, GetClusterDetailsQueryVariables>(GetClusterDetailsDocument, options);
        }
export function useGetClusterDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClusterDetailsQuery, GetClusterDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClusterDetailsQuery, GetClusterDetailsQueryVariables>(GetClusterDetailsDocument, options);
        }
export type GetClusterDetailsQueryHookResult = ReturnType<typeof useGetClusterDetailsQuery>;
export type GetClusterDetailsLazyQueryHookResult = ReturnType<typeof useGetClusterDetailsLazyQuery>;
export type GetClusterDetailsSuspenseQueryHookResult = ReturnType<typeof useGetClusterDetailsSuspenseQuery>;
export type GetClusterDetailsQueryResult = Apollo.QueryResult<GetClusterDetailsQuery, GetClusterDetailsQueryVariables>;
export const GetModuleDocument = gql`
    query GetModule($id: String!) {
  getModule(id: $id) {
    _id
    name
    domain
    short_description
  }
}
    `;

/**
 * __useGetModuleQuery__
 *
 * To run a query within a React component, call `useGetModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetModuleQuery(baseOptions: Apollo.QueryHookOptions<GetModuleQuery, GetModuleQueryVariables> & ({ variables: GetModuleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModuleQuery, GetModuleQueryVariables>(GetModuleDocument, options);
      }
export function useGetModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModuleQuery, GetModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModuleQuery, GetModuleQueryVariables>(GetModuleDocument, options);
        }
export function useGetModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModuleQuery, GetModuleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModuleQuery, GetModuleQueryVariables>(GetModuleDocument, options);
        }
export type GetModuleQueryHookResult = ReturnType<typeof useGetModuleQuery>;
export type GetModuleLazyQueryHookResult = ReturnType<typeof useGetModuleLazyQuery>;
export type GetModuleSuspenseQueryHookResult = ReturnType<typeof useGetModuleSuspenseQuery>;
export type GetModuleQueryResult = Apollo.QueryResult<GetModuleQuery, GetModuleQueryVariables>;
export const GetCampusDocument = gql`
    query GetCampus($id: String!) {
  campus(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetCampusQuery__
 *
 * To run a query within a React component, call `useGetCampusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampusQuery(baseOptions: Apollo.QueryHookOptions<GetCampusQuery, GetCampusQueryVariables> & ({ variables: GetCampusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampusQuery, GetCampusQueryVariables>(GetCampusDocument, options);
      }
export function useGetCampusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampusQuery, GetCampusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampusQuery, GetCampusQueryVariables>(GetCampusDocument, options);
        }
export function useGetCampusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampusQuery, GetCampusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampusQuery, GetCampusQueryVariables>(GetCampusDocument, options);
        }
export type GetCampusQueryHookResult = ReturnType<typeof useGetCampusQuery>;
export type GetCampusLazyQueryHookResult = ReturnType<typeof useGetCampusLazyQuery>;
export type GetCampusSuspenseQueryHookResult = ReturnType<typeof useGetCampusSuspenseQuery>;
export type GetCampusQueryResult = Apollo.QueryResult<GetCampusQuery, GetCampusQueryVariables>;
export const GetAllCampusesDocument = gql`
    query GetAllCampuses {
  allCampus {
    id
    name
  }
}
    `;

/**
 * __useGetAllCampusesQuery__
 *
 * To run a query within a React component, call `useGetAllCampusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCampusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCampusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCampusesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCampusesQuery, GetAllCampusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCampusesQuery, GetAllCampusesQueryVariables>(GetAllCampusesDocument, options);
      }
export function useGetAllCampusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCampusesQuery, GetAllCampusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCampusesQuery, GetAllCampusesQueryVariables>(GetAllCampusesDocument, options);
        }
export function useGetAllCampusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCampusesQuery, GetAllCampusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCampusesQuery, GetAllCampusesQueryVariables>(GetAllCampusesDocument, options);
        }
export type GetAllCampusesQueryHookResult = ReturnType<typeof useGetAllCampusesQuery>;
export type GetAllCampusesLazyQueryHookResult = ReturnType<typeof useGetAllCampusesLazyQuery>;
export type GetAllCampusesSuspenseQueryHookResult = ReturnType<typeof useGetAllCampusesSuspenseQuery>;
export type GetAllCampusesQueryResult = Apollo.QueryResult<GetAllCampusesQuery, GetAllCampusesQueryVariables>;
export const GetAllAdminDocument = gql`
    query GetAllAdmin {
  getAllAdmin {
    id
    name
    email
    isSuperAdmin
    permissions {
      courses
      assignments
      reports
      student_creation
    }
  }
}
    `;

/**
 * __useGetAllAdminQuery__
 *
 * To run a query within a React component, call `useGetAllAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAdminQuery, GetAllAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAdminQuery, GetAllAdminQueryVariables>(GetAllAdminDocument, options);
      }
export function useGetAllAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAdminQuery, GetAllAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAdminQuery, GetAllAdminQueryVariables>(GetAllAdminDocument, options);
        }
export function useGetAllAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAdminQuery, GetAllAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAdminQuery, GetAllAdminQueryVariables>(GetAllAdminDocument, options);
        }
export type GetAllAdminQueryHookResult = ReturnType<typeof useGetAllAdminQuery>;
export type GetAllAdminLazyQueryHookResult = ReturnType<typeof useGetAllAdminLazyQuery>;
export type GetAllAdminSuspenseQueryHookResult = ReturnType<typeof useGetAllAdminSuspenseQuery>;
export type GetAllAdminQueryResult = Apollo.QueryResult<GetAllAdminQuery, GetAllAdminQueryVariables>;
export const GetAllStaffsDocument = gql`
    query GetAllStaffs {
  getAllStaffs {
    id
    name
    email
    campusId
  }
}
    `;

/**
 * __useGetAllStaffsQuery__
 *
 * To run a query within a React component, call `useGetAllStaffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStaffsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStaffsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStaffsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStaffsQuery, GetAllStaffsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStaffsQuery, GetAllStaffsQueryVariables>(GetAllStaffsDocument, options);
      }
export function useGetAllStaffsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStaffsQuery, GetAllStaffsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStaffsQuery, GetAllStaffsQueryVariables>(GetAllStaffsDocument, options);
        }
export function useGetAllStaffsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStaffsQuery, GetAllStaffsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStaffsQuery, GetAllStaffsQueryVariables>(GetAllStaffsDocument, options);
        }
export type GetAllStaffsQueryHookResult = ReturnType<typeof useGetAllStaffsQuery>;
export type GetAllStaffsLazyQueryHookResult = ReturnType<typeof useGetAllStaffsLazyQuery>;
export type GetAllStaffsSuspenseQueryHookResult = ReturnType<typeof useGetAllStaffsSuspenseQuery>;
export type GetAllStaffsQueryResult = Apollo.QueryResult<GetAllStaffsQuery, GetAllStaffsQueryVariables>;
export const GetClustersByCampusDocument = gql`
    query GetClustersByCampus($campusName: String!, $searchTerm: String, $page: Int, $limit: Int) {
  getClustersByCampus(
    campusName: $campusName
    searchTerm: $searchTerm
    page: $page
    limit: $limit
  ) {
    id
    name
    studentCount
  }
}
    `;

/**
 * __useGetClustersByCampusQuery__
 *
 * To run a query within a React component, call `useGetClustersByCampusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClustersByCampusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClustersByCampusQuery({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      searchTerm: // value for 'searchTerm'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetClustersByCampusQuery(baseOptions: Apollo.QueryHookOptions<GetClustersByCampusQuery, GetClustersByCampusQueryVariables> & ({ variables: GetClustersByCampusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClustersByCampusQuery, GetClustersByCampusQueryVariables>(GetClustersByCampusDocument, options);
      }
export function useGetClustersByCampusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClustersByCampusQuery, GetClustersByCampusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClustersByCampusQuery, GetClustersByCampusQueryVariables>(GetClustersByCampusDocument, options);
        }
export function useGetClustersByCampusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClustersByCampusQuery, GetClustersByCampusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClustersByCampusQuery, GetClustersByCampusQueryVariables>(GetClustersByCampusDocument, options);
        }
export type GetClustersByCampusQueryHookResult = ReturnType<typeof useGetClustersByCampusQuery>;
export type GetClustersByCampusLazyQueryHookResult = ReturnType<typeof useGetClustersByCampusLazyQuery>;
export type GetClustersByCampusSuspenseQueryHookResult = ReturnType<typeof useGetClustersByCampusSuspenseQuery>;
export type GetClustersByCampusQueryResult = Apollo.QueryResult<GetClustersByCampusQuery, GetClustersByCampusQueryVariables>;
export const GetStudentsByClusterDocument = gql`
    query GetStudentsByCluster($clusterId: String!, $searchTerm: String, $page: Int, $limit: Int) {
  getStudentsByCluster(
    clusterId: $clusterId
    searchTerm: $searchTerm
    page: $page
    limit: $limit
  ) {
    id
    name
    email
    department
    phno
    dob
    rollNo
    placeOfResidence
    leetCodeUname
    hackerRankUname
    campusId
    assignmentIds
    clusterIds
    courseIds
    isInviteSend
  }
}
    `;

/**
 * __useGetStudentsByClusterQuery__
 *
 * To run a query within a React component, call `useGetStudentsByClusterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsByClusterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsByClusterQuery({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *      searchTerm: // value for 'searchTerm'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetStudentsByClusterQuery(baseOptions: Apollo.QueryHookOptions<GetStudentsByClusterQuery, GetStudentsByClusterQueryVariables> & ({ variables: GetStudentsByClusterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentsByClusterQuery, GetStudentsByClusterQueryVariables>(GetStudentsByClusterDocument, options);
      }
export function useGetStudentsByClusterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentsByClusterQuery, GetStudentsByClusterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentsByClusterQuery, GetStudentsByClusterQueryVariables>(GetStudentsByClusterDocument, options);
        }
export function useGetStudentsByClusterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentsByClusterQuery, GetStudentsByClusterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentsByClusterQuery, GetStudentsByClusterQueryVariables>(GetStudentsByClusterDocument, options);
        }
export type GetStudentsByClusterQueryHookResult = ReturnType<typeof useGetStudentsByClusterQuery>;
export type GetStudentsByClusterLazyQueryHookResult = ReturnType<typeof useGetStudentsByClusterLazyQuery>;
export type GetStudentsByClusterSuspenseQueryHookResult = ReturnType<typeof useGetStudentsByClusterSuspenseQuery>;
export type GetStudentsByClusterQueryResult = Apollo.QueryResult<GetStudentsByClusterQuery, GetStudentsByClusterQueryVariables>;
export const GetStaffsByCampusDocument = gql`
    query GetStaffsByCampus($campusId: String!) {
  getStaffsByCampus(campusId: $campusId) {
    id
    name
    email
    campusId
    designation
    contactNo
    isInviteSend
    clusterIds
    isAdminStaff
    mailAutomation
    mailSettings {
      frequency
      studentFilter
    }
  }
}
    `;

/**
 * __useGetStaffsByCampusQuery__
 *
 * To run a query within a React component, call `useGetStaffsByCampusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffsByCampusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffsByCampusQuery({
 *   variables: {
 *      campusId: // value for 'campusId'
 *   },
 * });
 */
export function useGetStaffsByCampusQuery(baseOptions: Apollo.QueryHookOptions<GetStaffsByCampusQuery, GetStaffsByCampusQueryVariables> & ({ variables: GetStaffsByCampusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaffsByCampusQuery, GetStaffsByCampusQueryVariables>(GetStaffsByCampusDocument, options);
      }
export function useGetStaffsByCampusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaffsByCampusQuery, GetStaffsByCampusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaffsByCampusQuery, GetStaffsByCampusQueryVariables>(GetStaffsByCampusDocument, options);
        }
export function useGetStaffsByCampusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStaffsByCampusQuery, GetStaffsByCampusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStaffsByCampusQuery, GetStaffsByCampusQueryVariables>(GetStaffsByCampusDocument, options);
        }
export type GetStaffsByCampusQueryHookResult = ReturnType<typeof useGetStaffsByCampusQuery>;
export type GetStaffsByCampusLazyQueryHookResult = ReturnType<typeof useGetStaffsByCampusLazyQuery>;
export type GetStaffsByCampusSuspenseQueryHookResult = ReturnType<typeof useGetStaffsByCampusSuspenseQuery>;
export type GetStaffsByCampusQueryResult = Apollo.QueryResult<GetStaffsByCampusQuery, GetStaffsByCampusQueryVariables>;
export const GetStaffByEmailIdDocument = gql`
    query GetStaffByEmailId($email: String!) {
  getStaffByEmailId(email: $email) {
    id
    name
    email
    designation
    contactNo
    campusId
    isInviteSend
    isAdminStaff
    clusterIds
    mailAutomation
    mailSettings {
      frequency
      studentFilter
    }
  }
}
    `;

/**
 * __useGetStaffByEmailIdQuery__
 *
 * To run a query within a React component, call `useGetStaffByEmailIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffByEmailIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffByEmailIdQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetStaffByEmailIdQuery(baseOptions: Apollo.QueryHookOptions<GetStaffByEmailIdQuery, GetStaffByEmailIdQueryVariables> & ({ variables: GetStaffByEmailIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaffByEmailIdQuery, GetStaffByEmailIdQueryVariables>(GetStaffByEmailIdDocument, options);
      }
export function useGetStaffByEmailIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaffByEmailIdQuery, GetStaffByEmailIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaffByEmailIdQuery, GetStaffByEmailIdQueryVariables>(GetStaffByEmailIdDocument, options);
        }
export function useGetStaffByEmailIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStaffByEmailIdQuery, GetStaffByEmailIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStaffByEmailIdQuery, GetStaffByEmailIdQueryVariables>(GetStaffByEmailIdDocument, options);
        }
export type GetStaffByEmailIdQueryHookResult = ReturnType<typeof useGetStaffByEmailIdQuery>;
export type GetStaffByEmailIdLazyQueryHookResult = ReturnType<typeof useGetStaffByEmailIdLazyQuery>;
export type GetStaffByEmailIdSuspenseQueryHookResult = ReturnType<typeof useGetStaffByEmailIdSuspenseQuery>;
export type GetStaffByEmailIdQueryResult = Apollo.QueryResult<GetStaffByEmailIdQuery, GetStaffByEmailIdQueryVariables>;
export const GetStudentByEmailIdDocument = gql`
    query GetStudentByEmailId($email: String!) {
  getStudentByEmailId(email: $email) {
    id
    name
    email
    personalEmail
    phno
    dob
    rollNo
    department
    campusId
    leetCodeUname
    hackerRankUname
    placeOfResidence
    assignmentIds
    purchasedCourses {
      course_id
      cluster_id
    }
    courseIds
    clusterIds
    completedQuestions
  }
}
    `;

/**
 * __useGetStudentByEmailIdQuery__
 *
 * To run a query within a React component, call `useGetStudentByEmailIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentByEmailIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentByEmailIdQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetStudentByEmailIdQuery(baseOptions: Apollo.QueryHookOptions<GetStudentByEmailIdQuery, GetStudentByEmailIdQueryVariables> & ({ variables: GetStudentByEmailIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentByEmailIdQuery, GetStudentByEmailIdQueryVariables>(GetStudentByEmailIdDocument, options);
      }
export function useGetStudentByEmailIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentByEmailIdQuery, GetStudentByEmailIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentByEmailIdQuery, GetStudentByEmailIdQueryVariables>(GetStudentByEmailIdDocument, options);
        }
export function useGetStudentByEmailIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentByEmailIdQuery, GetStudentByEmailIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentByEmailIdQuery, GetStudentByEmailIdQueryVariables>(GetStudentByEmailIdDocument, options);
        }
export type GetStudentByEmailIdQueryHookResult = ReturnType<typeof useGetStudentByEmailIdQuery>;
export type GetStudentByEmailIdLazyQueryHookResult = ReturnType<typeof useGetStudentByEmailIdLazyQuery>;
export type GetStudentByEmailIdSuspenseQueryHookResult = ReturnType<typeof useGetStudentByEmailIdSuspenseQuery>;
export type GetStudentByEmailIdQueryResult = Apollo.QueryResult<GetStudentByEmailIdQuery, GetStudentByEmailIdQueryVariables>;
export const GetStaffDocument = gql`
    query GetStaff($id: String!) {
  getStaff(id: $id) {
    id
    name
    email
    campusId
  }
}
    `;

/**
 * __useGetStaffQuery__
 *
 * To run a query within a React component, call `useGetStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStaffQuery(baseOptions: Apollo.QueryHookOptions<GetStaffQuery, GetStaffQueryVariables> & ({ variables: GetStaffQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaffQuery, GetStaffQueryVariables>(GetStaffDocument, options);
      }
export function useGetStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaffQuery, GetStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaffQuery, GetStaffQueryVariables>(GetStaffDocument, options);
        }
export function useGetStaffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStaffQuery, GetStaffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStaffQuery, GetStaffQueryVariables>(GetStaffDocument, options);
        }
export type GetStaffQueryHookResult = ReturnType<typeof useGetStaffQuery>;
export type GetStaffLazyQueryHookResult = ReturnType<typeof useGetStaffLazyQuery>;
export type GetStaffSuspenseQueryHookResult = ReturnType<typeof useGetStaffSuspenseQuery>;
export type GetStaffQueryResult = Apollo.QueryResult<GetStaffQuery, GetStaffQueryVariables>;
export const GetAllStudentsDocument = gql`
    query GetAllStudents {
  getAllStudents {
    id
    name
    email
    phno
    dob
    placeOfResidence
    assignmentIds
    courseIds
  }
}
    `;

/**
 * __useGetAllStudentsQuery__
 *
 * To run a query within a React component, call `useGetAllStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStudentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStudentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStudentsQuery, GetAllStudentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStudentsQuery, GetAllStudentsQueryVariables>(GetAllStudentsDocument, options);
      }
export function useGetAllStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStudentsQuery, GetAllStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStudentsQuery, GetAllStudentsQueryVariables>(GetAllStudentsDocument, options);
        }
export function useGetAllStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStudentsQuery, GetAllStudentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStudentsQuery, GetAllStudentsQueryVariables>(GetAllStudentsDocument, options);
        }
export type GetAllStudentsQueryHookResult = ReturnType<typeof useGetAllStudentsQuery>;
export type GetAllStudentsLazyQueryHookResult = ReturnType<typeof useGetAllStudentsLazyQuery>;
export type GetAllStudentsSuspenseQueryHookResult = ReturnType<typeof useGetAllStudentsSuspenseQuery>;
export type GetAllStudentsQueryResult = Apollo.QueryResult<GetAllStudentsQuery, GetAllStudentsQueryVariables>;
export const GetStudentDocument = gql`
    query GetStudent($id: String!) {
  getStudent(id: $id) {
    id
    name
    email
    phno
    dob
    rollNo
    campusId
    leetCodeUname
    hackerRankUname
    placeOfResidence
    assignmentIds
    courseIds
    clusterIds
    purchasedCourses {
      course_id
      cluster_id
    }
    completedQuestions
  }
}
    `;

/**
 * __useGetStudentQuery__
 *
 * To run a query within a React component, call `useGetStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStudentQuery(baseOptions: Apollo.QueryHookOptions<GetStudentQuery, GetStudentQueryVariables> & ({ variables: GetStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentQuery, GetStudentQueryVariables>(GetStudentDocument, options);
      }
export function useGetStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentQuery, GetStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentQuery, GetStudentQueryVariables>(GetStudentDocument, options);
        }
export function useGetStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentQuery, GetStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentQuery, GetStudentQueryVariables>(GetStudentDocument, options);
        }
export type GetStudentQueryHookResult = ReturnType<typeof useGetStudentQuery>;
export type GetStudentLazyQueryHookResult = ReturnType<typeof useGetStudentLazyQuery>;
export type GetStudentSuspenseQueryHookResult = ReturnType<typeof useGetStudentSuspenseQuery>;
export type GetStudentQueryResult = Apollo.QueryResult<GetStudentQuery, GetStudentQueryVariables>;
export const GetStudentsByCampusDocument = gql`
    query GetStudentsByCampus($campusId: String!, $page: Int, $limit: Int, $searchTerm: String, $clusterid: String) {
  getStudentsByCampus(
    campusId: $campusId
    page: $page
    limit: $limit
    searchTerm: $searchTerm
    clusterid: $clusterid
  ) {
    students {
      id
      name
      email
      rollNo
      department
      phno
      leetCodeUname
      hackerRankUname
      dob
      placeOfResidence
      campusId
      isInviteSend
      assignmentIds
      clusterIds
      purchasedCourses {
        course_id
        cluster_id
      }
    }
    total
  }
}
    `;

/**
 * __useGetStudentsByCampusQuery__
 *
 * To run a query within a React component, call `useGetStudentsByCampusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsByCampusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsByCampusQuery({
 *   variables: {
 *      campusId: // value for 'campusId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      searchTerm: // value for 'searchTerm'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useGetStudentsByCampusQuery(baseOptions: Apollo.QueryHookOptions<GetStudentsByCampusQuery, GetStudentsByCampusQueryVariables> & ({ variables: GetStudentsByCampusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentsByCampusQuery, GetStudentsByCampusQueryVariables>(GetStudentsByCampusDocument, options);
      }
export function useGetStudentsByCampusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentsByCampusQuery, GetStudentsByCampusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentsByCampusQuery, GetStudentsByCampusQueryVariables>(GetStudentsByCampusDocument, options);
        }
export function useGetStudentsByCampusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentsByCampusQuery, GetStudentsByCampusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentsByCampusQuery, GetStudentsByCampusQueryVariables>(GetStudentsByCampusDocument, options);
        }
export type GetStudentsByCampusQueryHookResult = ReturnType<typeof useGetStudentsByCampusQuery>;
export type GetStudentsByCampusLazyQueryHookResult = ReturnType<typeof useGetStudentsByCampusLazyQuery>;
export type GetStudentsByCampusSuspenseQueryHookResult = ReturnType<typeof useGetStudentsByCampusSuspenseQuery>;
export type GetStudentsByCampusQueryResult = Apollo.QueryResult<GetStudentsByCampusQuery, GetStudentsByCampusQueryVariables>;
export const GetLeetcodeDataDocument = gql`
    query GetLeetcodeData($username: String!) {
  leetcodeData(username: $username) {
    allQuestionsCount {
      difficulty
      count
    }
    matchedUser {
      username
      githubUrl
      twitterUrl
      linkedinUrl
      contributions {
        points
        questionCount
        testcaseCount
      }
      profile {
        realName
        userAvatar
        birthday
        ranking
        reputation
        websites
        countryName
        company
        school
        skillTags
        aboutMe
        starRating
      }
      badges {
        id
        displayName
        icon
        creationDate
      }
      upcomingBadges {
        name
        icon
      }
      activeBadge {
        id
        displayName
        icon
        creationDate
      }
      submitStats {
        totalSubmissionNum {
          difficulty
          count
          submissions
        }
        acSubmissionNum {
          difficulty
          count
          submissions
        }
      }
      submissionCalendar
    }
    recentSubmissionList {
      title
      titleSlug
      timestamp
      statusDisplay
      lang
    }
  }
}
    `;

/**
 * __useGetLeetcodeDataQuery__
 *
 * To run a query within a React component, call `useGetLeetcodeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeetcodeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeetcodeDataQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetLeetcodeDataQuery(baseOptions: Apollo.QueryHookOptions<GetLeetcodeDataQuery, GetLeetcodeDataQueryVariables> & ({ variables: GetLeetcodeDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeetcodeDataQuery, GetLeetcodeDataQueryVariables>(GetLeetcodeDataDocument, options);
      }
export function useGetLeetcodeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeetcodeDataQuery, GetLeetcodeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeetcodeDataQuery, GetLeetcodeDataQueryVariables>(GetLeetcodeDataDocument, options);
        }
export function useGetLeetcodeDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeetcodeDataQuery, GetLeetcodeDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeetcodeDataQuery, GetLeetcodeDataQueryVariables>(GetLeetcodeDataDocument, options);
        }
export type GetLeetcodeDataQueryHookResult = ReturnType<typeof useGetLeetcodeDataQuery>;
export type GetLeetcodeDataLazyQueryHookResult = ReturnType<typeof useGetLeetcodeDataLazyQuery>;
export type GetLeetcodeDataSuspenseQueryHookResult = ReturnType<typeof useGetLeetcodeDataSuspenseQuery>;
export type GetLeetcodeDataQueryResult = Apollo.QueryResult<GetLeetcodeDataQuery, GetLeetcodeDataQueryVariables>;
export const GetAllCoursesDocument = gql`
    query GetAllCourses {
  getAllCourses {
    id
    name
    short_description
    description
    categories {
      id
      name
      description
    }
    price
    level
    time_period
    languages
    domain
    benefits
    question_ids
    updatedBy
    updatedAt
    createdBy
    createdAt
  }
}
    `;

/**
 * __useGetAllCoursesQuery__
 *
 * To run a query within a React component, call `useGetAllCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCoursesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCoursesQuery, GetAllCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCoursesQuery, GetAllCoursesQueryVariables>(GetAllCoursesDocument, options);
      }
export function useGetAllCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCoursesQuery, GetAllCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCoursesQuery, GetAllCoursesQueryVariables>(GetAllCoursesDocument, options);
        }
export function useGetAllCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCoursesQuery, GetAllCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCoursesQuery, GetAllCoursesQueryVariables>(GetAllCoursesDocument, options);
        }
export type GetAllCoursesQueryHookResult = ReturnType<typeof useGetAllCoursesQuery>;
export type GetAllCoursesLazyQueryHookResult = ReturnType<typeof useGetAllCoursesLazyQuery>;
export type GetAllCoursesSuspenseQueryHookResult = ReturnType<typeof useGetAllCoursesSuspenseQuery>;
export type GetAllCoursesQueryResult = Apollo.QueryResult<GetAllCoursesQuery, GetAllCoursesQueryVariables>;
export const GetCourseDocument = gql`
    query GetCourse($id: String!) {
  getCourse(id: $id) {
    _id
    id
    name
    question_ids
    short_description
    description
    easy_count
    medium_count
    hard_count
    categories {
      id
      name
      description
    }
    price
    companies
    benefits
    whyChoose
    dis_price
    time_period
    languages
    easy_count
    hard_count
    medium_count
    domain
    level
  }
}
    `;

/**
 * __useGetCourseQuery__
 *
 * To run a query within a React component, call `useGetCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseQuery(baseOptions: Apollo.QueryHookOptions<GetCourseQuery, GetCourseQueryVariables> & ({ variables: GetCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseQuery, GetCourseQueryVariables>(GetCourseDocument, options);
      }
export function useGetCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseQuery, GetCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseQuery, GetCourseQueryVariables>(GetCourseDocument, options);
        }
export function useGetCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseQuery, GetCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseQuery, GetCourseQueryVariables>(GetCourseDocument, options);
        }
export type GetCourseQueryHookResult = ReturnType<typeof useGetCourseQuery>;
export type GetCourseLazyQueryHookResult = ReturnType<typeof useGetCourseLazyQuery>;
export type GetCourseSuspenseQueryHookResult = ReturnType<typeof useGetCourseSuspenseQuery>;
export type GetCourseQueryResult = Apollo.QueryResult<GetCourseQuery, GetCourseQueryVariables>;
export const FindAllQuestionsDocument = gql`
    query findAllQuestions($page: Int, $limit: Int, $difficulties: [String], $searchName: String, $tags: [String]) {
  findAllQuestions(
    page: $page
    limit: $limit
    difficulties: $difficulties
    searchName: $searchName
    tags: $tags
  ) {
    id
    title
    text
    question_sub_text
    test_cases {
      id
      visibility
      input
      output
      weightage
    }
    marks
    difficulty
    hints
    tags
    predefinedCode {
      c
      java
      python
      cpp
    }
    showFunctionOnly
    targetFunctionName
    company_tags
  }
}
    `;

/**
 * __useFindAllQuestionsQuery__
 *
 * To run a query within a React component, call `useFindAllQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllQuestionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      difficulties: // value for 'difficulties'
 *      searchName: // value for 'searchName'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useFindAllQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<FindAllQuestionsQuery, FindAllQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllQuestionsQuery, FindAllQuestionsQueryVariables>(FindAllQuestionsDocument, options);
      }
export function useFindAllQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllQuestionsQuery, FindAllQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllQuestionsQuery, FindAllQuestionsQueryVariables>(FindAllQuestionsDocument, options);
        }
export function useFindAllQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllQuestionsQuery, FindAllQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllQuestionsQuery, FindAllQuestionsQueryVariables>(FindAllQuestionsDocument, options);
        }
export type FindAllQuestionsQueryHookResult = ReturnType<typeof useFindAllQuestionsQuery>;
export type FindAllQuestionsLazyQueryHookResult = ReturnType<typeof useFindAllQuestionsLazyQuery>;
export type FindAllQuestionsSuspenseQueryHookResult = ReturnType<typeof useFindAllQuestionsSuspenseQuery>;
export type FindAllQuestionsQueryResult = Apollo.QueryResult<FindAllQuestionsQuery, FindAllQuestionsQueryVariables>;
export const GetAllQuestionDocument = gql`
    query getAllQuestion($courseId: String!, $page: Int, $limit: Int, $categoryId: String!) {
  getAllQuestion(
    courseId: $courseId
    page: $page
    limit: $limit
    categoryId: $categoryId
  ) {
    questions {
      id
      course_id
      assignment_ids
      title
      text
      question_sub_text
      test_cases {
        id
        visibility
        input
        output
        weightage
      }
      category {
        name
        id
      }
      marks
      difficulty
      hints
      tags
      company_tags
      createdBy
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllQuestionQuery__
 *
 * To run a query within a React component, call `useGetAllQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllQuestionQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetAllQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetAllQuestionQuery, GetAllQuestionQueryVariables> & ({ variables: GetAllQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllQuestionQuery, GetAllQuestionQueryVariables>(GetAllQuestionDocument, options);
      }
export function useGetAllQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllQuestionQuery, GetAllQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllQuestionQuery, GetAllQuestionQueryVariables>(GetAllQuestionDocument, options);
        }
export function useGetAllQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllQuestionQuery, GetAllQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllQuestionQuery, GetAllQuestionQueryVariables>(GetAllQuestionDocument, options);
        }
export type GetAllQuestionQueryHookResult = ReturnType<typeof useGetAllQuestionQuery>;
export type GetAllQuestionLazyQueryHookResult = ReturnType<typeof useGetAllQuestionLazyQuery>;
export type GetAllQuestionSuspenseQueryHookResult = ReturnType<typeof useGetAllQuestionSuspenseQuery>;
export type GetAllQuestionQueryResult = Apollo.QueryResult<GetAllQuestionQuery, GetAllQuestionQueryVariables>;
export const GetQuestionDocument = gql`
    query getQuestion($id: String!) {
  getQuestion(id: $id) {
    id
    course_id
    assignment_ids
    title
    text
    question_sub_text
    test_cases {
      id
      visibility
      input
      output
      weightage
    }
    category {
      name
      id
    }
    marks
    difficulty
    hints
    tags
    predefinedCode {
      c
      java
      python
      cpp
    }
    showFunctionOnly
    targetFunctionName
    company_tags
    updated_by
    updated_at
    created_by
    created_at
  }
}
    `;

/**
 * __useGetQuestionQuery__
 *
 * To run a query within a React component, call `useGetQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionQuery, GetQuestionQueryVariables> & ({ variables: GetQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionQuery, GetQuestionQueryVariables>(GetQuestionDocument, options);
      }
export function useGetQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionQuery, GetQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionQuery, GetQuestionQueryVariables>(GetQuestionDocument, options);
        }
export function useGetQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionQuery, GetQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionQuery, GetQuestionQueryVariables>(GetQuestionDocument, options);
        }
export type GetQuestionQueryHookResult = ReturnType<typeof useGetQuestionQuery>;
export type GetQuestionLazyQueryHookResult = ReturnType<typeof useGetQuestionLazyQuery>;
export type GetQuestionSuspenseQueryHookResult = ReturnType<typeof useGetQuestionSuspenseQuery>;
export type GetQuestionQueryResult = Apollo.QueryResult<GetQuestionQuery, GetQuestionQueryVariables>;
export const GetQuestionsByTagsDocument = gql`
    query getQuestionsByTags($tags: [String!]!, $page: Int!, $limit: Int!) {
  getQuestionsByTags(tags: $tags, page: $page, limit: $limit) {
    id
    course_id
    assignment_ids
    title
    text
    question_sub_text
    test_cases {
      id
      visibility
      input
      output
      weightage
    }
    category {
      name
      id
    }
    marks
    difficulty
    hints
    tags
    company_tags
    updated_by
    updated_at
    created_by
    created_at
  }
}
    `;

/**
 * __useGetQuestionsByTagsQuery__
 *
 * To run a query within a React component, call `useGetQuestionsByTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsByTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsByTagsQuery({
 *   variables: {
 *      tags: // value for 'tags'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetQuestionsByTagsQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionsByTagsQuery, GetQuestionsByTagsQueryVariables> & ({ variables: GetQuestionsByTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionsByTagsQuery, GetQuestionsByTagsQueryVariables>(GetQuestionsByTagsDocument, options);
      }
export function useGetQuestionsByTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionsByTagsQuery, GetQuestionsByTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionsByTagsQuery, GetQuestionsByTagsQueryVariables>(GetQuestionsByTagsDocument, options);
        }
export function useGetQuestionsByTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionsByTagsQuery, GetQuestionsByTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionsByTagsQuery, GetQuestionsByTagsQueryVariables>(GetQuestionsByTagsDocument, options);
        }
export type GetQuestionsByTagsQueryHookResult = ReturnType<typeof useGetQuestionsByTagsQuery>;
export type GetQuestionsByTagsLazyQueryHookResult = ReturnType<typeof useGetQuestionsByTagsLazyQuery>;
export type GetQuestionsByTagsSuspenseQueryHookResult = ReturnType<typeof useGetQuestionsByTagsSuspenseQuery>;
export type GetQuestionsByTagsQueryResult = Apollo.QueryResult<GetQuestionsByTagsQuery, GetQuestionsByTagsQueryVariables>;
export const GetCoursesByStudentEmailDocument = gql`
    query getCoursesByStudentEmail($email: String!) {
  getCoursesByStudentEmail(email: $email) {
    _id
    id
    name
    short_description
    description
    categories {
      id
      name
      description
    }
    price
    time_period
    languages
    domain
  }
}
    `;

/**
 * __useGetCoursesByStudentEmailQuery__
 *
 * To run a query within a React component, call `useGetCoursesByStudentEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesByStudentEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesByStudentEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetCoursesByStudentEmailQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesByStudentEmailQuery, GetCoursesByStudentEmailQueryVariables> & ({ variables: GetCoursesByStudentEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesByStudentEmailQuery, GetCoursesByStudentEmailQueryVariables>(GetCoursesByStudentEmailDocument, options);
      }
export function useGetCoursesByStudentEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesByStudentEmailQuery, GetCoursesByStudentEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesByStudentEmailQuery, GetCoursesByStudentEmailQueryVariables>(GetCoursesByStudentEmailDocument, options);
        }
export function useGetCoursesByStudentEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesByStudentEmailQuery, GetCoursesByStudentEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesByStudentEmailQuery, GetCoursesByStudentEmailQueryVariables>(GetCoursesByStudentEmailDocument, options);
        }
export type GetCoursesByStudentEmailQueryHookResult = ReturnType<typeof useGetCoursesByStudentEmailQuery>;
export type GetCoursesByStudentEmailLazyQueryHookResult = ReturnType<typeof useGetCoursesByStudentEmailLazyQuery>;
export type GetCoursesByStudentEmailSuspenseQueryHookResult = ReturnType<typeof useGetCoursesByStudentEmailSuspenseQuery>;
export type GetCoursesByStudentEmailQueryResult = Apollo.QueryResult<GetCoursesByStudentEmailQuery, GetCoursesByStudentEmailQueryVariables>;
export const GetAllCoursesByClusterDocument = gql`
    query getAllCoursesByCluster($campusName: String!, $clusterId: String!) {
  getAllCoursesByCluster(campusName: $campusName, clusterId: $clusterId) {
    _id
    id
    name
    short_description
    description
    categories {
      id
      name
      description
    }
    price
    companies
    benefits
    whyChoose
    dis_price
    question_ids
    level
    time_period
    languages
    domain
    easy_count
    hard_count
    medium_count
  }
}
    `;

/**
 * __useGetAllCoursesByClusterQuery__
 *
 * To run a query within a React component, call `useGetAllCoursesByClusterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCoursesByClusterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCoursesByClusterQuery({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useGetAllCoursesByClusterQuery(baseOptions: Apollo.QueryHookOptions<GetAllCoursesByClusterQuery, GetAllCoursesByClusterQueryVariables> & ({ variables: GetAllCoursesByClusterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCoursesByClusterQuery, GetAllCoursesByClusterQueryVariables>(GetAllCoursesByClusterDocument, options);
      }
export function useGetAllCoursesByClusterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCoursesByClusterQuery, GetAllCoursesByClusterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCoursesByClusterQuery, GetAllCoursesByClusterQueryVariables>(GetAllCoursesByClusterDocument, options);
        }
export function useGetAllCoursesByClusterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCoursesByClusterQuery, GetAllCoursesByClusterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCoursesByClusterQuery, GetAllCoursesByClusterQueryVariables>(GetAllCoursesByClusterDocument, options);
        }
export type GetAllCoursesByClusterQueryHookResult = ReturnType<typeof useGetAllCoursesByClusterQuery>;
export type GetAllCoursesByClusterLazyQueryHookResult = ReturnType<typeof useGetAllCoursesByClusterLazyQuery>;
export type GetAllCoursesByClusterSuspenseQueryHookResult = ReturnType<typeof useGetAllCoursesByClusterSuspenseQuery>;
export type GetAllCoursesByClusterQueryResult = Apollo.QueryResult<GetAllCoursesByClusterQuery, GetAllCoursesByClusterQueryVariables>;
export const GetClusterDocument = gql`
    query getCluster($campusName: String!, $clusterId: String!) {
  getCluster(campusName: $campusName, clusterId: $clusterId) {
    id
    name
    courseIds
    studentCount
    createdAt
    staffs {
      id
      name
      email
    }
    sendEmail
    isAssessmentMail
  }
}
    `;

/**
 * __useGetClusterQuery__
 *
 * To run a query within a React component, call `useGetClusterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClusterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClusterQuery({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useGetClusterQuery(baseOptions: Apollo.QueryHookOptions<GetClusterQuery, GetClusterQueryVariables> & ({ variables: GetClusterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClusterQuery, GetClusterQueryVariables>(GetClusterDocument, options);
      }
export function useGetClusterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClusterQuery, GetClusterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClusterQuery, GetClusterQueryVariables>(GetClusterDocument, options);
        }
export function useGetClusterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClusterQuery, GetClusterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClusterQuery, GetClusterQueryVariables>(GetClusterDocument, options);
        }
export type GetClusterQueryHookResult = ReturnType<typeof useGetClusterQuery>;
export type GetClusterLazyQueryHookResult = ReturnType<typeof useGetClusterLazyQuery>;
export type GetClusterSuspenseQueryHookResult = ReturnType<typeof useGetClusterSuspenseQuery>;
export type GetClusterQueryResult = Apollo.QueryResult<GetClusterQuery, GetClusterQueryVariables>;
export const CompileCodeDocument = gql`
    query compileCode($compileCodeInput: CompilerInput!) {
  compileCode(compileCodeInput: $compileCodeInput) {
    compilationOutput {
      stdout
      stderr
    }
    testCasePassed {
      count
      testCaseIds {
        testCaseId
        stdout
      }
    }
    testCaseFailed {
      count
      testCaseIds {
        testCaseId
        stdout
      }
    }
    Results {
      input
      output
      expextedOutput
      error
    }
  }
}
    `;

/**
 * __useCompileCodeQuery__
 *
 * To run a query within a React component, call `useCompileCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompileCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompileCodeQuery({
 *   variables: {
 *      compileCodeInput: // value for 'compileCodeInput'
 *   },
 * });
 */
export function useCompileCodeQuery(baseOptions: Apollo.QueryHookOptions<CompileCodeQuery, CompileCodeQueryVariables> & ({ variables: CompileCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompileCodeQuery, CompileCodeQueryVariables>(CompileCodeDocument, options);
      }
export function useCompileCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompileCodeQuery, CompileCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompileCodeQuery, CompileCodeQueryVariables>(CompileCodeDocument, options);
        }
export function useCompileCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompileCodeQuery, CompileCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompileCodeQuery, CompileCodeQueryVariables>(CompileCodeDocument, options);
        }
export type CompileCodeQueryHookResult = ReturnType<typeof useCompileCodeQuery>;
export type CompileCodeLazyQueryHookResult = ReturnType<typeof useCompileCodeLazyQuery>;
export type CompileCodeSuspenseQueryHookResult = ReturnType<typeof useCompileCodeSuspenseQuery>;
export type CompileCodeQueryResult = Apollo.QueryResult<CompileCodeQuery, CompileCodeQueryVariables>;
export const GetCampusByNameDocument = gql`
    query getCampusByName($name: String!) {
  getCampusByName(name: $name) {
    id
    name
  }
}
    `;

/**
 * __useGetCampusByNameQuery__
 *
 * To run a query within a React component, call `useGetCampusByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampusByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampusByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetCampusByNameQuery(baseOptions: Apollo.QueryHookOptions<GetCampusByNameQuery, GetCampusByNameQueryVariables> & ({ variables: GetCampusByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampusByNameQuery, GetCampusByNameQueryVariables>(GetCampusByNameDocument, options);
      }
export function useGetCampusByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampusByNameQuery, GetCampusByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampusByNameQuery, GetCampusByNameQueryVariables>(GetCampusByNameDocument, options);
        }
export function useGetCampusByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampusByNameQuery, GetCampusByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampusByNameQuery, GetCampusByNameQueryVariables>(GetCampusByNameDocument, options);
        }
export type GetCampusByNameQueryHookResult = ReturnType<typeof useGetCampusByNameQuery>;
export type GetCampusByNameLazyQueryHookResult = ReturnType<typeof useGetCampusByNameLazyQuery>;
export type GetCampusByNameSuspenseQueryHookResult = ReturnType<typeof useGetCampusByNameSuspenseQuery>;
export type GetCampusByNameQueryResult = Apollo.QueryResult<GetCampusByNameQuery, GetCampusByNameQueryVariables>;
export const GetClustersByIdsAndCampusDocument = gql`
    query GetClustersByIdsAndCampus($clusterIds: [String!]!, $campusName: String!) {
  getClustersByIdsAndCampus(clusterIds: $clusterIds, campusName: $campusName) {
    id
    name
    courseIds
    createdAt
    studentCount
  }
}
    `;

/**
 * __useGetClustersByIdsAndCampusQuery__
 *
 * To run a query within a React component, call `useGetClustersByIdsAndCampusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClustersByIdsAndCampusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClustersByIdsAndCampusQuery({
 *   variables: {
 *      clusterIds: // value for 'clusterIds'
 *      campusName: // value for 'campusName'
 *   },
 * });
 */
export function useGetClustersByIdsAndCampusQuery(baseOptions: Apollo.QueryHookOptions<GetClustersByIdsAndCampusQuery, GetClustersByIdsAndCampusQueryVariables> & ({ variables: GetClustersByIdsAndCampusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClustersByIdsAndCampusQuery, GetClustersByIdsAndCampusQueryVariables>(GetClustersByIdsAndCampusDocument, options);
      }
export function useGetClustersByIdsAndCampusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClustersByIdsAndCampusQuery, GetClustersByIdsAndCampusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClustersByIdsAndCampusQuery, GetClustersByIdsAndCampusQueryVariables>(GetClustersByIdsAndCampusDocument, options);
        }
export function useGetClustersByIdsAndCampusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClustersByIdsAndCampusQuery, GetClustersByIdsAndCampusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClustersByIdsAndCampusQuery, GetClustersByIdsAndCampusQueryVariables>(GetClustersByIdsAndCampusDocument, options);
        }
export type GetClustersByIdsAndCampusQueryHookResult = ReturnType<typeof useGetClustersByIdsAndCampusQuery>;
export type GetClustersByIdsAndCampusLazyQueryHookResult = ReturnType<typeof useGetClustersByIdsAndCampusLazyQuery>;
export type GetClustersByIdsAndCampusSuspenseQueryHookResult = ReturnType<typeof useGetClustersByIdsAndCampusSuspenseQuery>;
export type GetClustersByIdsAndCampusQueryResult = Apollo.QueryResult<GetClustersByIdsAndCampusQuery, GetClustersByIdsAndCampusQueryVariables>;
export const GetLeaderboardDocument = gql`
    query getLeaderboard($campusName: String!, $clusterId: String, $filter: String, $limit: Int, $page: Int, $startDate: String, $endDate: String) {
  getLeaderboard(
    campusName: $campusName
    clusterId: $clusterId
    filter: $filter
    limit: $limit
    page: $page
    startDate: $startDate
    endDate: $endDate
  ) {
    student_id
    totalScore
    department
    student {
      id
      name
      email
      rollNo
      phno
      dob
      completedQuestions
      leetCodeUname
    }
    completedQuestions
    courseBreakdown {
      courseId
      courseName
      completedQuestions
      totalQuestions
    }
    latestSubmissionDate
    position
    leetcode_data {
      difficulty
      count
      submissions
    }
    easyQuestionsCompleted
    hardQuestionCompleted
    mediumQuestionsCompleted
  }
}
    `;

/**
 * __useGetLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaderboardQuery({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<GetLeaderboardQuery, GetLeaderboardQueryVariables> & ({ variables: GetLeaderboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaderboardQuery, GetLeaderboardQueryVariables>(GetLeaderboardDocument, options);
      }
export function useGetLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaderboardQuery, GetLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaderboardQuery, GetLeaderboardQueryVariables>(GetLeaderboardDocument, options);
        }
export function useGetLeaderboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeaderboardQuery, GetLeaderboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeaderboardQuery, GetLeaderboardQueryVariables>(GetLeaderboardDocument, options);
        }
export type GetLeaderboardQueryHookResult = ReturnType<typeof useGetLeaderboardQuery>;
export type GetLeaderboardLazyQueryHookResult = ReturnType<typeof useGetLeaderboardLazyQuery>;
export type GetLeaderboardSuspenseQueryHookResult = ReturnType<typeof useGetLeaderboardSuspenseQuery>;
export type GetLeaderboardQueryResult = Apollo.QueryResult<GetLeaderboardQuery, GetLeaderboardQueryVariables>;
export const GetQuestionCompletedDocument = gql`
    query GetQuestionCompleted($student_id: String!, $is_paid: Boolean!) {
  getQuestionCompleted(student_id: $student_id, is_paid: $is_paid) {
    easy {
      completed
      total
    }
    medium {
      completed
      total
    }
    hard {
      completed
      total
    }
    overall {
      completed
      total
    }
  }
}
    `;

/**
 * __useGetQuestionCompletedQuery__
 *
 * To run a query within a React component, call `useGetQuestionCompletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionCompletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionCompletedQuery({
 *   variables: {
 *      student_id: // value for 'student_id'
 *      is_paid: // value for 'is_paid'
 *   },
 * });
 */
export function useGetQuestionCompletedQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionCompletedQuery, GetQuestionCompletedQueryVariables> & ({ variables: GetQuestionCompletedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionCompletedQuery, GetQuestionCompletedQueryVariables>(GetQuestionCompletedDocument, options);
      }
export function useGetQuestionCompletedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionCompletedQuery, GetQuestionCompletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionCompletedQuery, GetQuestionCompletedQueryVariables>(GetQuestionCompletedDocument, options);
        }
export function useGetQuestionCompletedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionCompletedQuery, GetQuestionCompletedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionCompletedQuery, GetQuestionCompletedQueryVariables>(GetQuestionCompletedDocument, options);
        }
export type GetQuestionCompletedQueryHookResult = ReturnType<typeof useGetQuestionCompletedQuery>;
export type GetQuestionCompletedLazyQueryHookResult = ReturnType<typeof useGetQuestionCompletedLazyQuery>;
export type GetQuestionCompletedSuspenseQueryHookResult = ReturnType<typeof useGetQuestionCompletedSuspenseQuery>;
export type GetQuestionCompletedQueryResult = Apollo.QueryResult<GetQuestionCompletedQuery, GetQuestionCompletedQueryVariables>;
export const GetDashboardCourseDetailsDocument = gql`
    query GetDashboardCourseDetails($student_id: String!, $is_paid: Boolean!) {
  getDashboardCourseDetails(student_id: $student_id, is_paid: $is_paid) {
    __typename
    courseDetails {
      courseId
      courseName
      level
      completedQuestion
      totalQuestion
      percentageCompleted
    }
  }
}
    `;

/**
 * __useGetDashboardCourseDetailsQuery__
 *
 * To run a query within a React component, call `useGetDashboardCourseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardCourseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardCourseDetailsQuery({
 *   variables: {
 *      student_id: // value for 'student_id'
 *      is_paid: // value for 'is_paid'
 *   },
 * });
 */
export function useGetDashboardCourseDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardCourseDetailsQuery, GetDashboardCourseDetailsQueryVariables> & ({ variables: GetDashboardCourseDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardCourseDetailsQuery, GetDashboardCourseDetailsQueryVariables>(GetDashboardCourseDetailsDocument, options);
      }
export function useGetDashboardCourseDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardCourseDetailsQuery, GetDashboardCourseDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardCourseDetailsQuery, GetDashboardCourseDetailsQueryVariables>(GetDashboardCourseDetailsDocument, options);
        }
export function useGetDashboardCourseDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardCourseDetailsQuery, GetDashboardCourseDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardCourseDetailsQuery, GetDashboardCourseDetailsQueryVariables>(GetDashboardCourseDetailsDocument, options);
        }
export type GetDashboardCourseDetailsQueryHookResult = ReturnType<typeof useGetDashboardCourseDetailsQuery>;
export type GetDashboardCourseDetailsLazyQueryHookResult = ReturnType<typeof useGetDashboardCourseDetailsLazyQuery>;
export type GetDashboardCourseDetailsSuspenseQueryHookResult = ReturnType<typeof useGetDashboardCourseDetailsSuspenseQuery>;
export type GetDashboardCourseDetailsQueryResult = Apollo.QueryResult<GetDashboardCourseDetailsQuery, GetDashboardCourseDetailsQueryVariables>;
export const GetLastFiveSubmissionsDocument = gql`
    query GetLastFiveSubmissions($submitInput: SubmitInput!) {
  getLastFiveSubmissions(submitInput: $submitInput) {
    id
    student_id
    course_id
    cluster_id
    question_id
    max_score
    is_completed
    autosave {
      id
      code
      score
      submittedAt
      language
    }
    submissions {
      id
      code
      score
      submittedAt
      language
    }
  }
}
    `;

/**
 * __useGetLastFiveSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetLastFiveSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastFiveSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastFiveSubmissionsQuery({
 *   variables: {
 *      submitInput: // value for 'submitInput'
 *   },
 * });
 */
export function useGetLastFiveSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<GetLastFiveSubmissionsQuery, GetLastFiveSubmissionsQueryVariables> & ({ variables: GetLastFiveSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastFiveSubmissionsQuery, GetLastFiveSubmissionsQueryVariables>(GetLastFiveSubmissionsDocument, options);
      }
export function useGetLastFiveSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastFiveSubmissionsQuery, GetLastFiveSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastFiveSubmissionsQuery, GetLastFiveSubmissionsQueryVariables>(GetLastFiveSubmissionsDocument, options);
        }
export function useGetLastFiveSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLastFiveSubmissionsQuery, GetLastFiveSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLastFiveSubmissionsQuery, GetLastFiveSubmissionsQueryVariables>(GetLastFiveSubmissionsDocument, options);
        }
export type GetLastFiveSubmissionsQueryHookResult = ReturnType<typeof useGetLastFiveSubmissionsQuery>;
export type GetLastFiveSubmissionsLazyQueryHookResult = ReturnType<typeof useGetLastFiveSubmissionsLazyQuery>;
export type GetLastFiveSubmissionsSuspenseQueryHookResult = ReturnType<typeof useGetLastFiveSubmissionsSuspenseQuery>;
export type GetLastFiveSubmissionsQueryResult = Apollo.QueryResult<GetLastFiveSubmissionsQuery, GetLastFiveSubmissionsQueryVariables>;
export const GetAllAssignmentsDocument = gql`
    query GetAllAssignments {
  getAllAssignments {
    _id
    id
    name
    short_description
    description
    start_time
    due_date
    duration
    languages
    domain
    updatedBy
    updatedAt
    createdBy
    createdAt
  }
}
    `;

/**
 * __useGetAllAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetAllAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAssignmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAssignmentsQuery, GetAllAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAssignmentsQuery, GetAllAssignmentsQueryVariables>(GetAllAssignmentsDocument, options);
      }
export function useGetAllAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAssignmentsQuery, GetAllAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAssignmentsQuery, GetAllAssignmentsQueryVariables>(GetAllAssignmentsDocument, options);
        }
export function useGetAllAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAssignmentsQuery, GetAllAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAssignmentsQuery, GetAllAssignmentsQueryVariables>(GetAllAssignmentsDocument, options);
        }
export type GetAllAssignmentsQueryHookResult = ReturnType<typeof useGetAllAssignmentsQuery>;
export type GetAllAssignmentsLazyQueryHookResult = ReturnType<typeof useGetAllAssignmentsLazyQuery>;
export type GetAllAssignmentsSuspenseQueryHookResult = ReturnType<typeof useGetAllAssignmentsSuspenseQuery>;
export type GetAllAssignmentsQueryResult = Apollo.QueryResult<GetAllAssignmentsQuery, GetAllAssignmentsQueryVariables>;
export const GetAssignmentDocument = gql`
    query GetAssignment($id: String!) {
  getAssignment(id: $id) {
    _id
    id
    name
    short_description
    description
    start_time
    due_date
    duration
    languages
    max_cheat_count
    max_tabSwitches
    enable_proctoring
    domain
    updatedBy
    updatedAt
    createdBy
    createdAt
  }
}
    `;

/**
 * __useGetAssignmentQuery__
 *
 * To run a query within a React component, call `useGetAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssignmentQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentQuery, GetAssignmentQueryVariables> & ({ variables: GetAssignmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentQuery, GetAssignmentQueryVariables>(GetAssignmentDocument, options);
      }
export function useGetAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentQuery, GetAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentQuery, GetAssignmentQueryVariables>(GetAssignmentDocument, options);
        }
export function useGetAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentQuery, GetAssignmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentQuery, GetAssignmentQueryVariables>(GetAssignmentDocument, options);
        }
export type GetAssignmentQueryHookResult = ReturnType<typeof useGetAssignmentQuery>;
export type GetAssignmentLazyQueryHookResult = ReturnType<typeof useGetAssignmentLazyQuery>;
export type GetAssignmentSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentSuspenseQuery>;
export type GetAssignmentQueryResult = Apollo.QueryResult<GetAssignmentQuery, GetAssignmentQueryVariables>;
export const GetAllAssignmentQuestionDocument = gql`
    query getAllAssignmentQuestion($assignmentId: String!, $page: Int = 1, $limit: Int = 10) {
  getAllAssignmentQuestion(
    assignmentId: $assignmentId
    page: $page
    limit: $limit
  ) {
    id
    assignment_id
    title
    text
    question_sub_text
    test_cases {
      id
      visibility
      input
      output
      weightage
    }
    marks
    predefinedCode {
      c
      java
      python
      cpp
    }
    showFunctionOnly
    targetFunctionName
    difficulty
    hints
    tags
    company_tags
    updated_by
    updated_at
    created_by
    created_at
  }
}
    `;

/**
 * __useGetAllAssignmentQuestionQuery__
 *
 * To run a query within a React component, call `useGetAllAssignmentQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAssignmentQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAssignmentQuestionQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllAssignmentQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetAllAssignmentQuestionQuery, GetAllAssignmentQuestionQueryVariables> & ({ variables: GetAllAssignmentQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAssignmentQuestionQuery, GetAllAssignmentQuestionQueryVariables>(GetAllAssignmentQuestionDocument, options);
      }
export function useGetAllAssignmentQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAssignmentQuestionQuery, GetAllAssignmentQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAssignmentQuestionQuery, GetAllAssignmentQuestionQueryVariables>(GetAllAssignmentQuestionDocument, options);
        }
export function useGetAllAssignmentQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAssignmentQuestionQuery, GetAllAssignmentQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAssignmentQuestionQuery, GetAllAssignmentQuestionQueryVariables>(GetAllAssignmentQuestionDocument, options);
        }
export type GetAllAssignmentQuestionQueryHookResult = ReturnType<typeof useGetAllAssignmentQuestionQuery>;
export type GetAllAssignmentQuestionLazyQueryHookResult = ReturnType<typeof useGetAllAssignmentQuestionLazyQuery>;
export type GetAllAssignmentQuestionSuspenseQueryHookResult = ReturnType<typeof useGetAllAssignmentQuestionSuspenseQuery>;
export type GetAllAssignmentQuestionQueryResult = Apollo.QueryResult<GetAllAssignmentQuestionQuery, GetAllAssignmentQuestionQueryVariables>;
export const GetAssignmentQuestionDocument = gql`
    query getAssignmentQuestion($id: String!) {
  getAssignmentQuestion(id: $id) {
    id
    assignment_id
    title
    text
    question_sub_text
    test_cases {
      id
      visibility
      input
      output
      weightage
    }
    marks
    predefinedCode {
      c
      java
      python
      cpp
    }
    showFunctionOnly
    targetFunctionName
    difficulty
    hints
    tags
    company_tags
    updated_by
    updated_at
    created_by
    created_at
  }
}
    `;

/**
 * __useGetAssignmentQuestionQuery__
 *
 * To run a query within a React component, call `useGetAssignmentQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssignmentQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentQuestionQuery, GetAssignmentQuestionQueryVariables> & ({ variables: GetAssignmentQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentQuestionQuery, GetAssignmentQuestionQueryVariables>(GetAssignmentQuestionDocument, options);
      }
export function useGetAssignmentQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentQuestionQuery, GetAssignmentQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentQuestionQuery, GetAssignmentQuestionQueryVariables>(GetAssignmentQuestionDocument, options);
        }
export function useGetAssignmentQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentQuestionQuery, GetAssignmentQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentQuestionQuery, GetAssignmentQuestionQueryVariables>(GetAssignmentQuestionDocument, options);
        }
export type GetAssignmentQuestionQueryHookResult = ReturnType<typeof useGetAssignmentQuestionQuery>;
export type GetAssignmentQuestionLazyQueryHookResult = ReturnType<typeof useGetAssignmentQuestionLazyQuery>;
export type GetAssignmentQuestionSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentQuestionSuspenseQuery>;
export type GetAssignmentQuestionQueryResult = Apollo.QueryResult<GetAssignmentQuestionQuery, GetAssignmentQuestionQueryVariables>;
export const GetAssignmentQuestionsByTagsDocument = gql`
    query getAssignmentQuestionsByTags($tags: [String!]!, $page: Int!, $limit: Int!) {
  getAssignmentQuestionsByTags(tags: $tags, page: $page, limit: $limit) {
    id
    assignment_id
    title
    text
    question_sub_text
    test_cases {
      id
      visibility
      input
      output
      weightage
    }
    marks
    predefinedCode {
      c
      java
      python
      cpp
    }
    showFunctionOnly
    targetFunctionName
    difficulty
    hints
    tags
    company_tags
    updated_by
    updated_at
    created_by
    created_at
  }
}
    `;

/**
 * __useGetAssignmentQuestionsByTagsQuery__
 *
 * To run a query within a React component, call `useGetAssignmentQuestionsByTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentQuestionsByTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentQuestionsByTagsQuery({
 *   variables: {
 *      tags: // value for 'tags'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAssignmentQuestionsByTagsQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentQuestionsByTagsQuery, GetAssignmentQuestionsByTagsQueryVariables> & ({ variables: GetAssignmentQuestionsByTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentQuestionsByTagsQuery, GetAssignmentQuestionsByTagsQueryVariables>(GetAssignmentQuestionsByTagsDocument, options);
      }
export function useGetAssignmentQuestionsByTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentQuestionsByTagsQuery, GetAssignmentQuestionsByTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentQuestionsByTagsQuery, GetAssignmentQuestionsByTagsQueryVariables>(GetAssignmentQuestionsByTagsDocument, options);
        }
export function useGetAssignmentQuestionsByTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentQuestionsByTagsQuery, GetAssignmentQuestionsByTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentQuestionsByTagsQuery, GetAssignmentQuestionsByTagsQueryVariables>(GetAssignmentQuestionsByTagsDocument, options);
        }
export type GetAssignmentQuestionsByTagsQueryHookResult = ReturnType<typeof useGetAssignmentQuestionsByTagsQuery>;
export type GetAssignmentQuestionsByTagsLazyQueryHookResult = ReturnType<typeof useGetAssignmentQuestionsByTagsLazyQuery>;
export type GetAssignmentQuestionsByTagsSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentQuestionsByTagsSuspenseQuery>;
export type GetAssignmentQuestionsByTagsQueryResult = Apollo.QueryResult<GetAssignmentQuestionsByTagsQuery, GetAssignmentQuestionsByTagsQueryVariables>;
export const GetStudentAndCampusDetailsByAssignmentIdDocument = gql`
    query GetStudentAndCampusDetailsByAssignmentId($assignmentId: String!) {
  getStudentAndCampusDetailsByAssignmentId(assignmentId: $assignmentId) {
    student {
      id
      name
      email
      campusId
      rollNo
      assignmentIds
    }
    campus {
      id
      name
    }
  }
}
    `;

/**
 * __useGetStudentAndCampusDetailsByAssignmentIdQuery__
 *
 * To run a query within a React component, call `useGetStudentAndCampusDetailsByAssignmentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentAndCampusDetailsByAssignmentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentAndCampusDetailsByAssignmentIdQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useGetStudentAndCampusDetailsByAssignmentIdQuery(baseOptions: Apollo.QueryHookOptions<GetStudentAndCampusDetailsByAssignmentIdQuery, GetStudentAndCampusDetailsByAssignmentIdQueryVariables> & ({ variables: GetStudentAndCampusDetailsByAssignmentIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentAndCampusDetailsByAssignmentIdQuery, GetStudentAndCampusDetailsByAssignmentIdQueryVariables>(GetStudentAndCampusDetailsByAssignmentIdDocument, options);
      }
export function useGetStudentAndCampusDetailsByAssignmentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentAndCampusDetailsByAssignmentIdQuery, GetStudentAndCampusDetailsByAssignmentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentAndCampusDetailsByAssignmentIdQuery, GetStudentAndCampusDetailsByAssignmentIdQueryVariables>(GetStudentAndCampusDetailsByAssignmentIdDocument, options);
        }
export function useGetStudentAndCampusDetailsByAssignmentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentAndCampusDetailsByAssignmentIdQuery, GetStudentAndCampusDetailsByAssignmentIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentAndCampusDetailsByAssignmentIdQuery, GetStudentAndCampusDetailsByAssignmentIdQueryVariables>(GetStudentAndCampusDetailsByAssignmentIdDocument, options);
        }
export type GetStudentAndCampusDetailsByAssignmentIdQueryHookResult = ReturnType<typeof useGetStudentAndCampusDetailsByAssignmentIdQuery>;
export type GetStudentAndCampusDetailsByAssignmentIdLazyQueryHookResult = ReturnType<typeof useGetStudentAndCampusDetailsByAssignmentIdLazyQuery>;
export type GetStudentAndCampusDetailsByAssignmentIdSuspenseQueryHookResult = ReturnType<typeof useGetStudentAndCampusDetailsByAssignmentIdSuspenseQuery>;
export type GetStudentAndCampusDetailsByAssignmentIdQueryResult = Apollo.QueryResult<GetStudentAndCampusDetailsByAssignmentIdQuery, GetStudentAndCampusDetailsByAssignmentIdQueryVariables>;
export const GetAssignmentsForStudentDocument = gql`
    query GetAssignmentsForStudent($email: String!) {
  getAssignmentsForStudent(email: $email) {
    completedAssignments {
      assignment {
        id
        name
        short_description
        start_time
        due_date
        duration
        createdAt
      }
      endTime
    }
    pendingAssignments {
      assignment {
        id
        name
        short_description
        start_time
        due_date
        duration
        createdAt
      }
      endTime
    }
  }
}
    `;

/**
 * __useGetAssignmentsForStudentQuery__
 *
 * To run a query within a React component, call `useGetAssignmentsForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentsForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentsForStudentQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetAssignmentsForStudentQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentsForStudentQuery, GetAssignmentsForStudentQueryVariables> & ({ variables: GetAssignmentsForStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentsForStudentQuery, GetAssignmentsForStudentQueryVariables>(GetAssignmentsForStudentDocument, options);
      }
export function useGetAssignmentsForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentsForStudentQuery, GetAssignmentsForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentsForStudentQuery, GetAssignmentsForStudentQueryVariables>(GetAssignmentsForStudentDocument, options);
        }
export function useGetAssignmentsForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentsForStudentQuery, GetAssignmentsForStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentsForStudentQuery, GetAssignmentsForStudentQueryVariables>(GetAssignmentsForStudentDocument, options);
        }
export type GetAssignmentsForStudentQueryHookResult = ReturnType<typeof useGetAssignmentsForStudentQuery>;
export type GetAssignmentsForStudentLazyQueryHookResult = ReturnType<typeof useGetAssignmentsForStudentLazyQuery>;
export type GetAssignmentsForStudentSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentsForStudentSuspenseQuery>;
export type GetAssignmentsForStudentQueryResult = Apollo.QueryResult<GetAssignmentsForStudentQuery, GetAssignmentsForStudentQueryVariables>;
export const GetAssignmentSubmitDocument = gql`
    query GetAssignmentSubmit($assignmentId: String!, $studentId: String!, $campus_name: String!) {
  getAssignmentSubmit(
    assignmentId: $assignmentId
    studentId: $studentId
    campus_name: $campus_name
  ) {
    id
    assignment_id
    cluster_id
    student_id
    questions {
      question_id
      answer
      score
      language
    }
    autosave {
      question_id
      answer
      score
      language
    }
    totalScore
    tabSwitches
    cheat_count
    cheat_reasons
    endTime
    completed
    timeRemaining
  }
}
    `;

/**
 * __useGetAssignmentSubmitQuery__
 *
 * To run a query within a React component, call `useGetAssignmentSubmitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentSubmitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentSubmitQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      studentId: // value for 'studentId'
 *      campus_name: // value for 'campus_name'
 *   },
 * });
 */
export function useGetAssignmentSubmitQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentSubmitQuery, GetAssignmentSubmitQueryVariables> & ({ variables: GetAssignmentSubmitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentSubmitQuery, GetAssignmentSubmitQueryVariables>(GetAssignmentSubmitDocument, options);
      }
export function useGetAssignmentSubmitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentSubmitQuery, GetAssignmentSubmitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentSubmitQuery, GetAssignmentSubmitQueryVariables>(GetAssignmentSubmitDocument, options);
        }
export function useGetAssignmentSubmitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentSubmitQuery, GetAssignmentSubmitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentSubmitQuery, GetAssignmentSubmitQueryVariables>(GetAssignmentSubmitDocument, options);
        }
export type GetAssignmentSubmitQueryHookResult = ReturnType<typeof useGetAssignmentSubmitQuery>;
export type GetAssignmentSubmitLazyQueryHookResult = ReturnType<typeof useGetAssignmentSubmitLazyQuery>;
export type GetAssignmentSubmitSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentSubmitSuspenseQuery>;
export type GetAssignmentSubmitQueryResult = Apollo.QueryResult<GetAssignmentSubmitQuery, GetAssignmentSubmitQueryVariables>;
export const GetModulesByClusterDocument = gql`
    query GetModulesByCluster($clusterId: String!, $campusName: String!) {
  getModulesByCluster(clusterId: $clusterId, campusName: $campusName) {
    moduleID
    enabled_dates
  }
}
    `;

/**
 * __useGetModulesByClusterQuery__
 *
 * To run a query within a React component, call `useGetModulesByClusterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModulesByClusterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModulesByClusterQuery({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *      campusName: // value for 'campusName'
 *   },
 * });
 */
export function useGetModulesByClusterQuery(baseOptions: Apollo.QueryHookOptions<GetModulesByClusterQuery, GetModulesByClusterQueryVariables> & ({ variables: GetModulesByClusterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModulesByClusterQuery, GetModulesByClusterQueryVariables>(GetModulesByClusterDocument, options);
      }
export function useGetModulesByClusterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModulesByClusterQuery, GetModulesByClusterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModulesByClusterQuery, GetModulesByClusterQueryVariables>(GetModulesByClusterDocument, options);
        }
export function useGetModulesByClusterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModulesByClusterQuery, GetModulesByClusterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModulesByClusterQuery, GetModulesByClusterQueryVariables>(GetModulesByClusterDocument, options);
        }
export type GetModulesByClusterQueryHookResult = ReturnType<typeof useGetModulesByClusterQuery>;
export type GetModulesByClusterLazyQueryHookResult = ReturnType<typeof useGetModulesByClusterLazyQuery>;
export type GetModulesByClusterSuspenseQueryHookResult = ReturnType<typeof useGetModulesByClusterSuspenseQuery>;
export type GetModulesByClusterQueryResult = Apollo.QueryResult<GetModulesByClusterQuery, GetModulesByClusterQueryVariables>;
export const GetStudentSubmissionsForMonthDocument = gql`
    query GetStudentSubmissionsForMonth($studentId: String!, $campusName: String!, $month: Int!, $year: Int!) {
  getStudentSubmissionsForMonth(
    studentId: $studentId
    campusName: $campusName
    month: $month
    year: $year
  ) {
    date
    courseName
    submissions {
      submittedAt
    }
  }
}
    `;

/**
 * __useGetStudentSubmissionsForMonthQuery__
 *
 * To run a query within a React component, call `useGetStudentSubmissionsForMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentSubmissionsForMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentSubmissionsForMonthQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      campusName: // value for 'campusName'
 *      month: // value for 'month'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetStudentSubmissionsForMonthQuery(baseOptions: Apollo.QueryHookOptions<GetStudentSubmissionsForMonthQuery, GetStudentSubmissionsForMonthQueryVariables> & ({ variables: GetStudentSubmissionsForMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentSubmissionsForMonthQuery, GetStudentSubmissionsForMonthQueryVariables>(GetStudentSubmissionsForMonthDocument, options);
      }
export function useGetStudentSubmissionsForMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentSubmissionsForMonthQuery, GetStudentSubmissionsForMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentSubmissionsForMonthQuery, GetStudentSubmissionsForMonthQueryVariables>(GetStudentSubmissionsForMonthDocument, options);
        }
export function useGetStudentSubmissionsForMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentSubmissionsForMonthQuery, GetStudentSubmissionsForMonthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentSubmissionsForMonthQuery, GetStudentSubmissionsForMonthQueryVariables>(GetStudentSubmissionsForMonthDocument, options);
        }
export type GetStudentSubmissionsForMonthQueryHookResult = ReturnType<typeof useGetStudentSubmissionsForMonthQuery>;
export type GetStudentSubmissionsForMonthLazyQueryHookResult = ReturnType<typeof useGetStudentSubmissionsForMonthLazyQuery>;
export type GetStudentSubmissionsForMonthSuspenseQueryHookResult = ReturnType<typeof useGetStudentSubmissionsForMonthSuspenseQuery>;
export type GetStudentSubmissionsForMonthQueryResult = Apollo.QueryResult<GetStudentSubmissionsForMonthQuery, GetStudentSubmissionsForMonthQueryVariables>;
export const GetStudentSubmissionsForTimeRangeDocument = gql`
    query GetStudentSubmissionsForTimeRange($studentId: String!, $campusName: String!, $timeRangeInMonths: Int!) {
  getStudentSubmissionsForTimeRange(
    studentId: $studentId
    campusName: $campusName
    timeRangeInMonths: $timeRangeInMonths
  ) {
    courseName
    date
    submissions {
      submittedAt
    }
  }
}
    `;

/**
 * __useGetStudentSubmissionsForTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetStudentSubmissionsForTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentSubmissionsForTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentSubmissionsForTimeRangeQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      campusName: // value for 'campusName'
 *      timeRangeInMonths: // value for 'timeRangeInMonths'
 *   },
 * });
 */
export function useGetStudentSubmissionsForTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetStudentSubmissionsForTimeRangeQuery, GetStudentSubmissionsForTimeRangeQueryVariables> & ({ variables: GetStudentSubmissionsForTimeRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentSubmissionsForTimeRangeQuery, GetStudentSubmissionsForTimeRangeQueryVariables>(GetStudentSubmissionsForTimeRangeDocument, options);
      }
export function useGetStudentSubmissionsForTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentSubmissionsForTimeRangeQuery, GetStudentSubmissionsForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentSubmissionsForTimeRangeQuery, GetStudentSubmissionsForTimeRangeQueryVariables>(GetStudentSubmissionsForTimeRangeDocument, options);
        }
export function useGetStudentSubmissionsForTimeRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentSubmissionsForTimeRangeQuery, GetStudentSubmissionsForTimeRangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentSubmissionsForTimeRangeQuery, GetStudentSubmissionsForTimeRangeQueryVariables>(GetStudentSubmissionsForTimeRangeDocument, options);
        }
export type GetStudentSubmissionsForTimeRangeQueryHookResult = ReturnType<typeof useGetStudentSubmissionsForTimeRangeQuery>;
export type GetStudentSubmissionsForTimeRangeLazyQueryHookResult = ReturnType<typeof useGetStudentSubmissionsForTimeRangeLazyQuery>;
export type GetStudentSubmissionsForTimeRangeSuspenseQueryHookResult = ReturnType<typeof useGetStudentSubmissionsForTimeRangeSuspenseQuery>;
export type GetStudentSubmissionsForTimeRangeQueryResult = Apollo.QueryResult<GetStudentSubmissionsForTimeRangeQuery, GetStudentSubmissionsForTimeRangeQueryVariables>;
export const GetAssignmentLeaderBoardDocument = gql`
    query GetAssignmentLeaderBoard($assignmentId: String!, $campus_name: String!) {
  getAssignmentLeaderBoard(assignmentId: $assignmentId, campus_name: $campus_name) {
    __typename
    assignment_id
    student {
      id
      name
      email
      campusId
      rollNo
      department
    }
    totalScore
    clusterNames
    totalNumberOfQuestion
    cheat_reasons
    position
    questions {
      questionId
      score
      AllotedTotalMarks
    }
  }
}
    `;

/**
 * __useGetAssignmentLeaderBoardQuery__
 *
 * To run a query within a React component, call `useGetAssignmentLeaderBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentLeaderBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentLeaderBoardQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      campus_name: // value for 'campus_name'
 *   },
 * });
 */
export function useGetAssignmentLeaderBoardQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentLeaderBoardQuery, GetAssignmentLeaderBoardQueryVariables> & ({ variables: GetAssignmentLeaderBoardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentLeaderBoardQuery, GetAssignmentLeaderBoardQueryVariables>(GetAssignmentLeaderBoardDocument, options);
      }
export function useGetAssignmentLeaderBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentLeaderBoardQuery, GetAssignmentLeaderBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentLeaderBoardQuery, GetAssignmentLeaderBoardQueryVariables>(GetAssignmentLeaderBoardDocument, options);
        }
export function useGetAssignmentLeaderBoardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentLeaderBoardQuery, GetAssignmentLeaderBoardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentLeaderBoardQuery, GetAssignmentLeaderBoardQueryVariables>(GetAssignmentLeaderBoardDocument, options);
        }
export type GetAssignmentLeaderBoardQueryHookResult = ReturnType<typeof useGetAssignmentLeaderBoardQuery>;
export type GetAssignmentLeaderBoardLazyQueryHookResult = ReturnType<typeof useGetAssignmentLeaderBoardLazyQuery>;
export type GetAssignmentLeaderBoardSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentLeaderBoardSuspenseQuery>;
export type GetAssignmentLeaderBoardQueryResult = Apollo.QueryResult<GetAssignmentLeaderBoardQuery, GetAssignmentLeaderBoardQueryVariables>;
export const FindAssignmentsForStudentWithFilterDocument = gql`
    query findAssignmentsForStudentWithFilter($email: String!, $filterType: String!, $customDateRange: AssignmentFilterInput) {
  findAssignmentsForStudentWithFilter(
    email: $email
    filterType: $filterType
    customDateRange: $customDateRange
  ) {
    __typename
    _id
    id
    name
    short_description
    description
    start_time
    due_date
    languages
    domain
    duration
    max_cheat_count
    max_tabSwitches
    enable_proctoring
    updatedBy
    updatedAt
    createdBy
    createdAt
  }
}
    `;

/**
 * __useFindAssignmentsForStudentWithFilterQuery__
 *
 * To run a query within a React component, call `useFindAssignmentsForStudentWithFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAssignmentsForStudentWithFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAssignmentsForStudentWithFilterQuery({
 *   variables: {
 *      email: // value for 'email'
 *      filterType: // value for 'filterType'
 *      customDateRange: // value for 'customDateRange'
 *   },
 * });
 */
export function useFindAssignmentsForStudentWithFilterQuery(baseOptions: Apollo.QueryHookOptions<FindAssignmentsForStudentWithFilterQuery, FindAssignmentsForStudentWithFilterQueryVariables> & ({ variables: FindAssignmentsForStudentWithFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAssignmentsForStudentWithFilterQuery, FindAssignmentsForStudentWithFilterQueryVariables>(FindAssignmentsForStudentWithFilterDocument, options);
      }
export function useFindAssignmentsForStudentWithFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAssignmentsForStudentWithFilterQuery, FindAssignmentsForStudentWithFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAssignmentsForStudentWithFilterQuery, FindAssignmentsForStudentWithFilterQueryVariables>(FindAssignmentsForStudentWithFilterDocument, options);
        }
export function useFindAssignmentsForStudentWithFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAssignmentsForStudentWithFilterQuery, FindAssignmentsForStudentWithFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAssignmentsForStudentWithFilterQuery, FindAssignmentsForStudentWithFilterQueryVariables>(FindAssignmentsForStudentWithFilterDocument, options);
        }
export type FindAssignmentsForStudentWithFilterQueryHookResult = ReturnType<typeof useFindAssignmentsForStudentWithFilterQuery>;
export type FindAssignmentsForStudentWithFilterLazyQueryHookResult = ReturnType<typeof useFindAssignmentsForStudentWithFilterLazyQuery>;
export type FindAssignmentsForStudentWithFilterSuspenseQueryHookResult = ReturnType<typeof useFindAssignmentsForStudentWithFilterSuspenseQuery>;
export type FindAssignmentsForStudentWithFilterQueryResult = Apollo.QueryResult<FindAssignmentsForStudentWithFilterQuery, FindAssignmentsForStudentWithFilterQueryVariables>;
export const AllCategoriesDocument = gql`
    query allCategories {
  allCategories {
    id
    name
    description
  }
}
    `;

/**
 * __useAllCategoriesQuery__
 *
 * To run a query within a React component, call `useAllCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AllCategoriesQuery, AllCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCategoriesQuery, AllCategoriesQueryVariables>(AllCategoriesDocument, options);
      }
export function useAllCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCategoriesQuery, AllCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCategoriesQuery, AllCategoriesQueryVariables>(AllCategoriesDocument, options);
        }
export function useAllCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCategoriesQuery, AllCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCategoriesQuery, AllCategoriesQueryVariables>(AllCategoriesDocument, options);
        }
export type AllCategoriesQueryHookResult = ReturnType<typeof useAllCategoriesQuery>;
export type AllCategoriesLazyQueryHookResult = ReturnType<typeof useAllCategoriesLazyQuery>;
export type AllCategoriesSuspenseQueryHookResult = ReturnType<typeof useAllCategoriesSuspenseQuery>;
export type AllCategoriesQueryResult = Apollo.QueryResult<AllCategoriesQuery, AllCategoriesQueryVariables>;
export const GetSubmissionDocument = gql`
    query GetSubmission($campus_name: String!, $assignment_id: String!, $student_id: String!) {
  getSubmission(
    campus_name: $campus_name
    assignment_id: $assignment_id
    student_id: $student_id
  ) {
    id
    assignment_id
    student_id
    completed
    cheat_reasons
    tabSwitches
    cheat_count
    totalScore
    endTime
    autosave {
      question_id
      answer
      score
      language
    }
    questions {
      question_id
      answer
      score
      language
    }
  }
}
    `;

/**
 * __useGetSubmissionQuery__
 *
 * To run a query within a React component, call `useGetSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionQuery({
 *   variables: {
 *      campus_name: // value for 'campus_name'
 *      assignment_id: // value for 'assignment_id'
 *      student_id: // value for 'student_id'
 *   },
 * });
 */
export function useGetSubmissionQuery(baseOptions: Apollo.QueryHookOptions<GetSubmissionQuery, GetSubmissionQueryVariables> & ({ variables: GetSubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubmissionQuery, GetSubmissionQueryVariables>(GetSubmissionDocument, options);
      }
export function useGetSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubmissionQuery, GetSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubmissionQuery, GetSubmissionQueryVariables>(GetSubmissionDocument, options);
        }
export function useGetSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubmissionQuery, GetSubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubmissionQuery, GetSubmissionQueryVariables>(GetSubmissionDocument, options);
        }
export type GetSubmissionQueryHookResult = ReturnType<typeof useGetSubmissionQuery>;
export type GetSubmissionLazyQueryHookResult = ReturnType<typeof useGetSubmissionLazyQuery>;
export type GetSubmissionSuspenseQueryHookResult = ReturnType<typeof useGetSubmissionSuspenseQuery>;
export type GetSubmissionQueryResult = Apollo.QueryResult<GetSubmissionQuery, GetSubmissionQueryVariables>;
export const GetQuestionsByCategoryDocument = gql`
    query getQuestionsByCategory($categoryId: String!, $courseId: String!, $page: Int, $limit: Int, $searchName: String) {
  getQuestionsByCategory(
    categoryId: $categoryId
    courseId: $courseId
    page: $page
    limit: $limit
    searchName: $searchName
  ) {
    questions {
      id
      course_id
      assignment_ids
      title
      text
      question_sub_text
      test_cases {
        id
        visibility
        input
        output
        weightage
      }
      category {
        id
        name
      }
      marks
      predefinedCode {
        c
        java
        python
        cpp
      }
      showFunctionOnly
      targetFunctionName
      difficulty
      hints
      tags
      company_tags
    }
    totalCount
  }
}
    `;

/**
 * __useGetQuestionsByCategoryQuery__
 *
 * To run a query within a React component, call `useGetQuestionsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsByCategoryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      courseId: // value for 'courseId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      searchName: // value for 'searchName'
 *   },
 * });
 */
export function useGetQuestionsByCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionsByCategoryQuery, GetQuestionsByCategoryQueryVariables> & ({ variables: GetQuestionsByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionsByCategoryQuery, GetQuestionsByCategoryQueryVariables>(GetQuestionsByCategoryDocument, options);
      }
export function useGetQuestionsByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionsByCategoryQuery, GetQuestionsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionsByCategoryQuery, GetQuestionsByCategoryQueryVariables>(GetQuestionsByCategoryDocument, options);
        }
export function useGetQuestionsByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionsByCategoryQuery, GetQuestionsByCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionsByCategoryQuery, GetQuestionsByCategoryQueryVariables>(GetQuestionsByCategoryDocument, options);
        }
export type GetQuestionsByCategoryQueryHookResult = ReturnType<typeof useGetQuestionsByCategoryQuery>;
export type GetQuestionsByCategoryLazyQueryHookResult = ReturnType<typeof useGetQuestionsByCategoryLazyQuery>;
export type GetQuestionsByCategorySuspenseQueryHookResult = ReturnType<typeof useGetQuestionsByCategorySuspenseQuery>;
export type GetQuestionsByCategoryQueryResult = Apollo.QueryResult<GetQuestionsByCategoryQuery, GetQuestionsByCategoryQueryVariables>;
export const GetAssignmentByClusterDocument = gql`
    query getAssignmentByCluster($campusName: String!, $clusterId: String!) {
  getAssignmentByCluster(campusName: $campusName, clusterId: $clusterId) {
    id
    name
    short_description
    description
    due_date
    languages
    domain
    duration
  }
}
    `;

/**
 * __useGetAssignmentByClusterQuery__
 *
 * To run a query within a React component, call `useGetAssignmentByClusterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentByClusterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentByClusterQuery({
 *   variables: {
 *      campusName: // value for 'campusName'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useGetAssignmentByClusterQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentByClusterQuery, GetAssignmentByClusterQueryVariables> & ({ variables: GetAssignmentByClusterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentByClusterQuery, GetAssignmentByClusterQueryVariables>(GetAssignmentByClusterDocument, options);
      }
export function useGetAssignmentByClusterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentByClusterQuery, GetAssignmentByClusterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentByClusterQuery, GetAssignmentByClusterQueryVariables>(GetAssignmentByClusterDocument, options);
        }
export function useGetAssignmentByClusterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentByClusterQuery, GetAssignmentByClusterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentByClusterQuery, GetAssignmentByClusterQueryVariables>(GetAssignmentByClusterDocument, options);
        }
export type GetAssignmentByClusterQueryHookResult = ReturnType<typeof useGetAssignmentByClusterQuery>;
export type GetAssignmentByClusterLazyQueryHookResult = ReturnType<typeof useGetAssignmentByClusterLazyQuery>;
export type GetAssignmentByClusterSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentByClusterSuspenseQuery>;
export type GetAssignmentByClusterQueryResult = Apollo.QueryResult<GetAssignmentByClusterQuery, GetAssignmentByClusterQueryVariables>;
export const GetAdminUsingEmailDocument = gql`
    query getAdminUsingEmail($email: String!) {
  getAdminUsingEmail(email: $email) {
    id
    name
    email
    isSuperAdmin
    permissions {
      courses
      assignments
      reports
      student_creation
    }
  }
}
    `;

/**
 * __useGetAdminUsingEmailQuery__
 *
 * To run a query within a React component, call `useGetAdminUsingEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUsingEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUsingEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetAdminUsingEmailQuery(baseOptions: Apollo.QueryHookOptions<GetAdminUsingEmailQuery, GetAdminUsingEmailQueryVariables> & ({ variables: GetAdminUsingEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUsingEmailQuery, GetAdminUsingEmailQueryVariables>(GetAdminUsingEmailDocument, options);
      }
export function useGetAdminUsingEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUsingEmailQuery, GetAdminUsingEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUsingEmailQuery, GetAdminUsingEmailQueryVariables>(GetAdminUsingEmailDocument, options);
        }
export function useGetAdminUsingEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminUsingEmailQuery, GetAdminUsingEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminUsingEmailQuery, GetAdminUsingEmailQueryVariables>(GetAdminUsingEmailDocument, options);
        }
export type GetAdminUsingEmailQueryHookResult = ReturnType<typeof useGetAdminUsingEmailQuery>;
export type GetAdminUsingEmailLazyQueryHookResult = ReturnType<typeof useGetAdminUsingEmailLazyQuery>;
export type GetAdminUsingEmailSuspenseQueryHookResult = ReturnType<typeof useGetAdminUsingEmailSuspenseQuery>;
export type GetAdminUsingEmailQueryResult = Apollo.QueryResult<GetAdminUsingEmailQuery, GetAdminUsingEmailQueryVariables>;
export const GetStudentsResultsDocument = gql`
    query getStudentsResults($campusId: String!, $searchTerm: String, $page: Int, $limit: Int, $clusterid: String) {
  getStudentsResults(
    campusId: $campusId
    searchTerm: $searchTerm
    page: $page
    limit: $limit
    clusterid: $clusterid
  ) {
    __typename
    students {
      id
      name
      email
      rollNo
      department
      courseDetails {
        courseDetails {
          courseId
          percentageCompleted
          completedQuestion
          totalQuestion
        }
        rewardPoints
      }
      assignmentDetails {
        assignment_id
        student_id
        totalScore
      }
    }
    total
  }
}
    `;

/**
 * __useGetStudentsResultsQuery__
 *
 * To run a query within a React component, call `useGetStudentsResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsResultsQuery({
 *   variables: {
 *      campusId: // value for 'campusId'
 *      searchTerm: // value for 'searchTerm'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useGetStudentsResultsQuery(baseOptions: Apollo.QueryHookOptions<GetStudentsResultsQuery, GetStudentsResultsQueryVariables> & ({ variables: GetStudentsResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentsResultsQuery, GetStudentsResultsQueryVariables>(GetStudentsResultsDocument, options);
      }
export function useGetStudentsResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentsResultsQuery, GetStudentsResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentsResultsQuery, GetStudentsResultsQueryVariables>(GetStudentsResultsDocument, options);
        }
export function useGetStudentsResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentsResultsQuery, GetStudentsResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentsResultsQuery, GetStudentsResultsQueryVariables>(GetStudentsResultsDocument, options);
        }
export type GetStudentsResultsQueryHookResult = ReturnType<typeof useGetStudentsResultsQuery>;
export type GetStudentsResultsLazyQueryHookResult = ReturnType<typeof useGetStudentsResultsLazyQuery>;
export type GetStudentsResultsSuspenseQueryHookResult = ReturnType<typeof useGetStudentsResultsSuspenseQuery>;
export type GetStudentsResultsQueryResult = Apollo.QueryResult<GetStudentsResultsQuery, GetStudentsResultsQueryVariables>;
export const GetAssignmentByCampusDocument = gql`
    query getAssignmentByCampus($campusName: String!) {
  getAssignmentByCampus(campusName: $campusName) {
    __typename
    _id
    id
    name
    short_description
    description
    due_date
    languages
    domain
    duration
    max_cheat_count
    max_tabSwitches
    enable_proctoring
    updatedBy
    updatedAt
    createdBy
    createdAt
  }
}
    `;

/**
 * __useGetAssignmentByCampusQuery__
 *
 * To run a query within a React component, call `useGetAssignmentByCampusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentByCampusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentByCampusQuery({
 *   variables: {
 *      campusName: // value for 'campusName'
 *   },
 * });
 */
export function useGetAssignmentByCampusQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentByCampusQuery, GetAssignmentByCampusQueryVariables> & ({ variables: GetAssignmentByCampusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentByCampusQuery, GetAssignmentByCampusQueryVariables>(GetAssignmentByCampusDocument, options);
      }
export function useGetAssignmentByCampusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentByCampusQuery, GetAssignmentByCampusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentByCampusQuery, GetAssignmentByCampusQueryVariables>(GetAssignmentByCampusDocument, options);
        }
export function useGetAssignmentByCampusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentByCampusQuery, GetAssignmentByCampusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentByCampusQuery, GetAssignmentByCampusQueryVariables>(GetAssignmentByCampusDocument, options);
        }
export type GetAssignmentByCampusQueryHookResult = ReturnType<typeof useGetAssignmentByCampusQuery>;
export type GetAssignmentByCampusLazyQueryHookResult = ReturnType<typeof useGetAssignmentByCampusLazyQuery>;
export type GetAssignmentByCampusSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentByCampusSuspenseQuery>;
export type GetAssignmentByCampusQueryResult = Apollo.QueryResult<GetAssignmentByCampusQuery, GetAssignmentByCampusQueryVariables>;
export const StudentsNotAttendedAssignmentDocument = gql`
    query studentsNotAttendedAssignment($campus_id: String!, $assignmentId: String!, $cluster_id: String) {
  studentsNotAttendedAssignment(
    campus_id: $campus_id
    assignmentId: $assignmentId
    cluster_id: $cluster_id
  ) {
    __typename
    student_name
    student_id
    cluster_names
    student_rollno
    student_email
  }
}
    `;

/**
 * __useStudentsNotAttendedAssignmentQuery__
 *
 * To run a query within a React component, call `useStudentsNotAttendedAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsNotAttendedAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsNotAttendedAssignmentQuery({
 *   variables: {
 *      campus_id: // value for 'campus_id'
 *      assignmentId: // value for 'assignmentId'
 *      cluster_id: // value for 'cluster_id'
 *   },
 * });
 */
export function useStudentsNotAttendedAssignmentQuery(baseOptions: Apollo.QueryHookOptions<StudentsNotAttendedAssignmentQuery, StudentsNotAttendedAssignmentQueryVariables> & ({ variables: StudentsNotAttendedAssignmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentsNotAttendedAssignmentQuery, StudentsNotAttendedAssignmentQueryVariables>(StudentsNotAttendedAssignmentDocument, options);
      }
export function useStudentsNotAttendedAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentsNotAttendedAssignmentQuery, StudentsNotAttendedAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentsNotAttendedAssignmentQuery, StudentsNotAttendedAssignmentQueryVariables>(StudentsNotAttendedAssignmentDocument, options);
        }
export function useStudentsNotAttendedAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentsNotAttendedAssignmentQuery, StudentsNotAttendedAssignmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudentsNotAttendedAssignmentQuery, StudentsNotAttendedAssignmentQueryVariables>(StudentsNotAttendedAssignmentDocument, options);
        }
export type StudentsNotAttendedAssignmentQueryHookResult = ReturnType<typeof useStudentsNotAttendedAssignmentQuery>;
export type StudentsNotAttendedAssignmentLazyQueryHookResult = ReturnType<typeof useStudentsNotAttendedAssignmentLazyQuery>;
export type StudentsNotAttendedAssignmentSuspenseQueryHookResult = ReturnType<typeof useStudentsNotAttendedAssignmentSuspenseQuery>;
export type StudentsNotAttendedAssignmentQueryResult = Apollo.QueryResult<StudentsNotAttendedAssignmentQuery, StudentsNotAttendedAssignmentQueryVariables>;
export const GetOrdersByStudentIdDocument = gql`
    query getOrdersByStudentId($student_id: String!) {
  getOrdersByStudentId(student_id: $student_id) {
    __typename
    order_id
    course_name
    amount
    payment_date
  }
}
    `;

/**
 * __useGetOrdersByStudentIdQuery__
 *
 * To run a query within a React component, call `useGetOrdersByStudentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersByStudentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersByStudentIdQuery({
 *   variables: {
 *      student_id: // value for 'student_id'
 *   },
 * });
 */
export function useGetOrdersByStudentIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersByStudentIdQuery, GetOrdersByStudentIdQueryVariables> & ({ variables: GetOrdersByStudentIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersByStudentIdQuery, GetOrdersByStudentIdQueryVariables>(GetOrdersByStudentIdDocument, options);
      }
export function useGetOrdersByStudentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersByStudentIdQuery, GetOrdersByStudentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersByStudentIdQuery, GetOrdersByStudentIdQueryVariables>(GetOrdersByStudentIdDocument, options);
        }
export function useGetOrdersByStudentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersByStudentIdQuery, GetOrdersByStudentIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersByStudentIdQuery, GetOrdersByStudentIdQueryVariables>(GetOrdersByStudentIdDocument, options);
        }
export type GetOrdersByStudentIdQueryHookResult = ReturnType<typeof useGetOrdersByStudentIdQuery>;
export type GetOrdersByStudentIdLazyQueryHookResult = ReturnType<typeof useGetOrdersByStudentIdLazyQuery>;
export type GetOrdersByStudentIdSuspenseQueryHookResult = ReturnType<typeof useGetOrdersByStudentIdSuspenseQuery>;
export type GetOrdersByStudentIdQueryResult = Apollo.QueryResult<GetOrdersByStudentIdQuery, GetOrdersByStudentIdQueryVariables>;
export const GetCourseProgressDocument = gql`
    query getCourseProgress($studentId: String!, $courseId: String!, $isPaid: Boolean!) {
  getCourseProgress(studentId: $studentId, courseId: $courseId, isPaid: $isPaid) {
    __typename
    courseId
    courseName
    level
    completedQuestions
    totalQuestions
    percentageCompleted
  }
}
    `;

/**
 * __useGetCourseProgressQuery__
 *
 * To run a query within a React component, call `useGetCourseProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseProgressQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      courseId: // value for 'courseId'
 *      isPaid: // value for 'isPaid'
 *   },
 * });
 */
export function useGetCourseProgressQuery(baseOptions: Apollo.QueryHookOptions<GetCourseProgressQuery, GetCourseProgressQueryVariables> & ({ variables: GetCourseProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseProgressQuery, GetCourseProgressQueryVariables>(GetCourseProgressDocument, options);
      }
export function useGetCourseProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseProgressQuery, GetCourseProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseProgressQuery, GetCourseProgressQueryVariables>(GetCourseProgressDocument, options);
        }
export function useGetCourseProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseProgressQuery, GetCourseProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseProgressQuery, GetCourseProgressQueryVariables>(GetCourseProgressDocument, options);
        }
export type GetCourseProgressQueryHookResult = ReturnType<typeof useGetCourseProgressQuery>;
export type GetCourseProgressLazyQueryHookResult = ReturnType<typeof useGetCourseProgressLazyQuery>;
export type GetCourseProgressSuspenseQueryHookResult = ReturnType<typeof useGetCourseProgressSuspenseQuery>;
export type GetCourseProgressQueryResult = Apollo.QueryResult<GetCourseProgressQuery, GetCourseProgressQueryVariables>;
export const GetCourseForStudentsDocument = gql`
    query getCourseForStudents($id: String!) {
  getCourseForStudents(id: $id) {
    easy_count
    medium_count
    hard_count
    name
    short_description
    categories {
      id
      name
      description
      questions {
        id
        title
        difficulty
      }
    }
    price
    companies
    benefits
    whyChoose
    dis_price
    time_period
    languages
    easy_count
    hard_count
    medium_count
    domain
    level
  }
}
    `;

/**
 * __useGetCourseForStudentsQuery__
 *
 * To run a query within a React component, call `useGetCourseForStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseForStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseForStudentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseForStudentsQuery(baseOptions: Apollo.QueryHookOptions<GetCourseForStudentsQuery, GetCourseForStudentsQueryVariables> & ({ variables: GetCourseForStudentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseForStudentsQuery, GetCourseForStudentsQueryVariables>(GetCourseForStudentsDocument, options);
      }
export function useGetCourseForStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseForStudentsQuery, GetCourseForStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseForStudentsQuery, GetCourseForStudentsQueryVariables>(GetCourseForStudentsDocument, options);
        }
export function useGetCourseForStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseForStudentsQuery, GetCourseForStudentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseForStudentsQuery, GetCourseForStudentsQueryVariables>(GetCourseForStudentsDocument, options);
        }
export type GetCourseForStudentsQueryHookResult = ReturnType<typeof useGetCourseForStudentsQuery>;
export type GetCourseForStudentsLazyQueryHookResult = ReturnType<typeof useGetCourseForStudentsLazyQuery>;
export type GetCourseForStudentsSuspenseQueryHookResult = ReturnType<typeof useGetCourseForStudentsSuspenseQuery>;
export type GetCourseForStudentsQueryResult = Apollo.QueryResult<GetCourseForStudentsQuery, GetCourseForStudentsQueryVariables>;
export const GetCourseDashboardDetailsDocument = gql`
    query getCourseDashboardDetails($course_id: String!, $student_id: String!, $campus_name: String!) {
  getCourseDashboardDetails(
    course_id: $course_id
    student_id: $student_id
    campus_name: $campus_name
  ) {
    totalScore
    inProgressCount
    awaitingCount
    completedCount
  }
}
    `;

/**
 * __useGetCourseDashboardDetailsQuery__
 *
 * To run a query within a React component, call `useGetCourseDashboardDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseDashboardDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseDashboardDetailsQuery({
 *   variables: {
 *      course_id: // value for 'course_id'
 *      student_id: // value for 'student_id'
 *      campus_name: // value for 'campus_name'
 *   },
 * });
 */
export function useGetCourseDashboardDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCourseDashboardDetailsQuery, GetCourseDashboardDetailsQueryVariables> & ({ variables: GetCourseDashboardDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseDashboardDetailsQuery, GetCourseDashboardDetailsQueryVariables>(GetCourseDashboardDetailsDocument, options);
      }
export function useGetCourseDashboardDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseDashboardDetailsQuery, GetCourseDashboardDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseDashboardDetailsQuery, GetCourseDashboardDetailsQueryVariables>(GetCourseDashboardDetailsDocument, options);
        }
export function useGetCourseDashboardDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseDashboardDetailsQuery, GetCourseDashboardDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseDashboardDetailsQuery, GetCourseDashboardDetailsQueryVariables>(GetCourseDashboardDetailsDocument, options);
        }
export type GetCourseDashboardDetailsQueryHookResult = ReturnType<typeof useGetCourseDashboardDetailsQuery>;
export type GetCourseDashboardDetailsLazyQueryHookResult = ReturnType<typeof useGetCourseDashboardDetailsLazyQuery>;
export type GetCourseDashboardDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCourseDashboardDetailsSuspenseQuery>;
export type GetCourseDashboardDetailsQueryResult = Apollo.QueryResult<GetCourseDashboardDetailsQuery, GetCourseDashboardDetailsQueryVariables>;
export const GetCategoryDashboardDetailsDocument = gql`
    query getCategoryDashboardDetails($course_id: String!, $student_id: String!, $campus_name: String!, $category_id: String!) {
  getCategoryDashboardDetails(
    course_id: $course_id
    student_id: $student_id
    campus_name: $campus_name
    category_id: $category_id
  ) {
    totalScore
    inProgressCount
    awaitingCount
    completedCount
    categoryName
    maxScore
  }
}
    `;

/**
 * __useGetCategoryDashboardDetailsQuery__
 *
 * To run a query within a React component, call `useGetCategoryDashboardDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryDashboardDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryDashboardDetailsQuery({
 *   variables: {
 *      course_id: // value for 'course_id'
 *      student_id: // value for 'student_id'
 *      campus_name: // value for 'campus_name'
 *      category_id: // value for 'category_id'
 *   },
 * });
 */
export function useGetCategoryDashboardDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryDashboardDetailsQuery, GetCategoryDashboardDetailsQueryVariables> & ({ variables: GetCategoryDashboardDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryDashboardDetailsQuery, GetCategoryDashboardDetailsQueryVariables>(GetCategoryDashboardDetailsDocument, options);
      }
export function useGetCategoryDashboardDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryDashboardDetailsQuery, GetCategoryDashboardDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryDashboardDetailsQuery, GetCategoryDashboardDetailsQueryVariables>(GetCategoryDashboardDetailsDocument, options);
        }
export function useGetCategoryDashboardDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryDashboardDetailsQuery, GetCategoryDashboardDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoryDashboardDetailsQuery, GetCategoryDashboardDetailsQueryVariables>(GetCategoryDashboardDetailsDocument, options);
        }
export type GetCategoryDashboardDetailsQueryHookResult = ReturnType<typeof useGetCategoryDashboardDetailsQuery>;
export type GetCategoryDashboardDetailsLazyQueryHookResult = ReturnType<typeof useGetCategoryDashboardDetailsLazyQuery>;
export type GetCategoryDashboardDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCategoryDashboardDetailsSuspenseQuery>;
export type GetCategoryDashboardDetailsQueryResult = Apollo.QueryResult<GetCategoryDashboardDetailsQuery, GetCategoryDashboardDetailsQueryVariables>;
export const GetQuestionForStudentsDocument = gql`
    query getQuestionForStudents($course_id: String!, $student_id: String!, $campus_name: String!, $category_id: String!, $page: Int, $limit: Int, $difficulty: String, $text: String, $status: Int) {
  getQuestionForStudents(
    course_id: $course_id
    student_id: $student_id
    category_id: $category_id
    campus_name: $campus_name
    page: $page
    limit: $limit
    difficulty: $difficulty
    text: $text
    status: $status
  ) {
    questions {
      mark
      status
      question_id
      title
      difficulty
    }
    totalCount
  }
}
    `;

/**
 * __useGetQuestionForStudentsQuery__
 *
 * To run a query within a React component, call `useGetQuestionForStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionForStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionForStudentsQuery({
 *   variables: {
 *      course_id: // value for 'course_id'
 *      student_id: // value for 'student_id'
 *      campus_name: // value for 'campus_name'
 *      category_id: // value for 'category_id'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      difficulty: // value for 'difficulty'
 *      text: // value for 'text'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetQuestionForStudentsQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionForStudentsQuery, GetQuestionForStudentsQueryVariables> & ({ variables: GetQuestionForStudentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionForStudentsQuery, GetQuestionForStudentsQueryVariables>(GetQuestionForStudentsDocument, options);
      }
export function useGetQuestionForStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionForStudentsQuery, GetQuestionForStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionForStudentsQuery, GetQuestionForStudentsQueryVariables>(GetQuestionForStudentsDocument, options);
        }
export function useGetQuestionForStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionForStudentsQuery, GetQuestionForStudentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionForStudentsQuery, GetQuestionForStudentsQueryVariables>(GetQuestionForStudentsDocument, options);
        }
export type GetQuestionForStudentsQueryHookResult = ReturnType<typeof useGetQuestionForStudentsQuery>;
export type GetQuestionForStudentsLazyQueryHookResult = ReturnType<typeof useGetQuestionForStudentsLazyQuery>;
export type GetQuestionForStudentsSuspenseQueryHookResult = ReturnType<typeof useGetQuestionForStudentsSuspenseQuery>;
export type GetQuestionForStudentsQueryResult = Apollo.QueryResult<GetQuestionForStudentsQuery, GetQuestionForStudentsQueryVariables>;
export const GetAssignmentQuestionForStudentsDocument = gql`
    query getAssignmentQuestionForStudents($id: String!) {
  getAssignmentQuestionForStudents(id: $id) {
    id
    assignment_id
    title
    text
    question_sub_text
    test_cases {
      id
      visibility
      input
      output
      weightage
    }
    marks
    predefinedCode {
      c
      java
      python
      cpp
    }
    showFunctionOnly
    targetFunctionName
    difficulty
    hints
    tags
    company_tags
    updated_by
    updated_at
    created_by
    created_at
  }
}
    `;

/**
 * __useGetAssignmentQuestionForStudentsQuery__
 *
 * To run a query within a React component, call `useGetAssignmentQuestionForStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentQuestionForStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentQuestionForStudentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssignmentQuestionForStudentsQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentQuestionForStudentsQuery, GetAssignmentQuestionForStudentsQueryVariables> & ({ variables: GetAssignmentQuestionForStudentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentQuestionForStudentsQuery, GetAssignmentQuestionForStudentsQueryVariables>(GetAssignmentQuestionForStudentsDocument, options);
      }
export function useGetAssignmentQuestionForStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentQuestionForStudentsQuery, GetAssignmentQuestionForStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentQuestionForStudentsQuery, GetAssignmentQuestionForStudentsQueryVariables>(GetAssignmentQuestionForStudentsDocument, options);
        }
export function useGetAssignmentQuestionForStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentQuestionForStudentsQuery, GetAssignmentQuestionForStudentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentQuestionForStudentsQuery, GetAssignmentQuestionForStudentsQueryVariables>(GetAssignmentQuestionForStudentsDocument, options);
        }
export type GetAssignmentQuestionForStudentsQueryHookResult = ReturnType<typeof useGetAssignmentQuestionForStudentsQuery>;
export type GetAssignmentQuestionForStudentsLazyQueryHookResult = ReturnType<typeof useGetAssignmentQuestionForStudentsLazyQuery>;
export type GetAssignmentQuestionForStudentsSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentQuestionForStudentsSuspenseQuery>;
export type GetAssignmentQuestionForStudentsQueryResult = Apollo.QueryResult<GetAssignmentQuestionForStudentsQuery, GetAssignmentQuestionForStudentsQueryVariables>;
export const GetAllFoldersDocument = gql`
    query getAllFolders {
  getAllFolders {
    __typename
    _id
    id
    name
    assignments
  }
}
    `;

/**
 * __useGetAllFoldersQuery__
 *
 * To run a query within a React component, call `useGetAllFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFoldersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllFoldersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllFoldersQuery, GetAllFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFoldersQuery, GetAllFoldersQueryVariables>(GetAllFoldersDocument, options);
      }
export function useGetAllFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFoldersQuery, GetAllFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFoldersQuery, GetAllFoldersQueryVariables>(GetAllFoldersDocument, options);
        }
export function useGetAllFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllFoldersQuery, GetAllFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFoldersQuery, GetAllFoldersQueryVariables>(GetAllFoldersDocument, options);
        }
export type GetAllFoldersQueryHookResult = ReturnType<typeof useGetAllFoldersQuery>;
export type GetAllFoldersLazyQueryHookResult = ReturnType<typeof useGetAllFoldersLazyQuery>;
export type GetAllFoldersSuspenseQueryHookResult = ReturnType<typeof useGetAllFoldersSuspenseQuery>;
export type GetAllFoldersQueryResult = Apollo.QueryResult<GetAllFoldersQuery, GetAllFoldersQueryVariables>;
export const AssignmentsInFolderDocument = gql`
    query assignmentsInFolder($folderId: String!) {
  assignmentsInFolder(folderId: $folderId) {
    __typename
    _id
    id
    name
    short_description
    description
    due_date
    languages
    domain
    duration
    max_cheat_count
    max_tabSwitches
    enable_proctoring
    updatedBy
    updatedAt
    createdBy
    createdAt
  }
}
    `;

/**
 * __useAssignmentsInFolderQuery__
 *
 * To run a query within a React component, call `useAssignmentsInFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentsInFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentsInFolderQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useAssignmentsInFolderQuery(baseOptions: Apollo.QueryHookOptions<AssignmentsInFolderQuery, AssignmentsInFolderQueryVariables> & ({ variables: AssignmentsInFolderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignmentsInFolderQuery, AssignmentsInFolderQueryVariables>(AssignmentsInFolderDocument, options);
      }
export function useAssignmentsInFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignmentsInFolderQuery, AssignmentsInFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignmentsInFolderQuery, AssignmentsInFolderQueryVariables>(AssignmentsInFolderDocument, options);
        }
export function useAssignmentsInFolderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssignmentsInFolderQuery, AssignmentsInFolderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssignmentsInFolderQuery, AssignmentsInFolderQueryVariables>(AssignmentsInFolderDocument, options);
        }
export type AssignmentsInFolderQueryHookResult = ReturnType<typeof useAssignmentsInFolderQuery>;
export type AssignmentsInFolderLazyQueryHookResult = ReturnType<typeof useAssignmentsInFolderLazyQuery>;
export type AssignmentsInFolderSuspenseQueryHookResult = ReturnType<typeof useAssignmentsInFolderSuspenseQuery>;
export type AssignmentsInFolderQueryResult = Apollo.QueryResult<AssignmentsInFolderQuery, AssignmentsInFolderQueryVariables>;
export const StartTestDocument = gql`
    mutation startTest($campus_name: String!, $assignment_id: String!, $student_id: String!, $testDurationInMinutes: Float!) {
  startTest(
    campus_name: $campus_name
    assignment_id: $assignment_id
    student_id: $student_id
    testDurationInMinutes: $testDurationInMinutes
  ) {
    id
    assignment_id
    cluster_id
    student_id
    questions {
      question_id
      answer
      score
      language
    }
    totalScore
    tabSwitches
    cheat_count
    completed
    autosave {
      question_id
      answer
      score
      language
    }
    endTime
  }
}
    `;
export type StartTestMutationFn = Apollo.MutationFunction<StartTestMutation, StartTestMutationVariables>;

/**
 * __useStartTestMutation__
 *
 * To run a mutation, you first call `useStartTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTestMutation, { data, loading, error }] = useStartTestMutation({
 *   variables: {
 *      campus_name: // value for 'campus_name'
 *      assignment_id: // value for 'assignment_id'
 *      student_id: // value for 'student_id'
 *      testDurationInMinutes: // value for 'testDurationInMinutes'
 *   },
 * });
 */
export function useStartTestMutation(baseOptions?: Apollo.MutationHookOptions<StartTestMutation, StartTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTestMutation, StartTestMutationVariables>(StartTestDocument, options);
      }
export type StartTestMutationHookResult = ReturnType<typeof useStartTestMutation>;
export type StartTestMutationResult = Apollo.MutationResult<StartTestMutation>;
export type StartTestMutationOptions = Apollo.BaseMutationOptions<StartTestMutation, StartTestMutationVariables>;
export const GetAutoSubmitDocument = gql`
    query GetAutoSubmit($getModuleSubmit: GetAutoSubmitInput!) {
  getAutoSubmit(GetAutoSubmitInput: $getModuleSubmit) {
    id
    student_id
    module_id
    day_id
    question_id
    cluster_id
    campus_name
    autosave {
      id
      code
      language
      submittedAt
    }
  }
}
    `;

/**
 * __useGetAutoSubmitQuery__
 *
 * To run a query within a React component, call `useGetAutoSubmitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoSubmitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoSubmitQuery({
 *   variables: {
 *      getModuleSubmit: // value for 'getModuleSubmit'
 *   },
 * });
 */
export function useGetAutoSubmitQuery(baseOptions: Apollo.QueryHookOptions<GetAutoSubmitQuery, GetAutoSubmitQueryVariables> & ({ variables: GetAutoSubmitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutoSubmitQuery, GetAutoSubmitQueryVariables>(GetAutoSubmitDocument, options);
      }
export function useGetAutoSubmitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutoSubmitQuery, GetAutoSubmitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutoSubmitQuery, GetAutoSubmitQueryVariables>(GetAutoSubmitDocument, options);
        }
export function useGetAutoSubmitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAutoSubmitQuery, GetAutoSubmitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAutoSubmitQuery, GetAutoSubmitQueryVariables>(GetAutoSubmitDocument, options);
        }
export type GetAutoSubmitQueryHookResult = ReturnType<typeof useGetAutoSubmitQuery>;
export type GetAutoSubmitLazyQueryHookResult = ReturnType<typeof useGetAutoSubmitLazyQuery>;
export type GetAutoSubmitSuspenseQueryHookResult = ReturnType<typeof useGetAutoSubmitSuspenseQuery>;
export type GetAutoSubmitQueryResult = Apollo.QueryResult<GetAutoSubmitQuery, GetAutoSubmitQueryVariables>;
export const GetModuleSubmissionsDocument = gql`
    query GetModuleSubmissions($studentId: String!, $moduleId: String!, $campusName: String!) {
  getModuleSubmissions(
    studentId: $studentId
    moduleId: $moduleId
    campusName: $campusName
  ) {
    id
    student_id
    score
    is_completed
    question_id
    submissions {
      id
      code
      score
      submittedAt
    }
  }
}
    `;

/**
 * __useGetModuleSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetModuleSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleSubmissionsQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      moduleId: // value for 'moduleId'
 *      campusName: // value for 'campusName'
 *   },
 * });
 */
export function useGetModuleSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<GetModuleSubmissionsQuery, GetModuleSubmissionsQueryVariables> & ({ variables: GetModuleSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModuleSubmissionsQuery, GetModuleSubmissionsQueryVariables>(GetModuleSubmissionsDocument, options);
      }
export function useGetModuleSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModuleSubmissionsQuery, GetModuleSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModuleSubmissionsQuery, GetModuleSubmissionsQueryVariables>(GetModuleSubmissionsDocument, options);
        }
export function useGetModuleSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModuleSubmissionsQuery, GetModuleSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModuleSubmissionsQuery, GetModuleSubmissionsQueryVariables>(GetModuleSubmissionsDocument, options);
        }
export type GetModuleSubmissionsQueryHookResult = ReturnType<typeof useGetModuleSubmissionsQuery>;
export type GetModuleSubmissionsLazyQueryHookResult = ReturnType<typeof useGetModuleSubmissionsLazyQuery>;
export type GetModuleSubmissionsSuspenseQueryHookResult = ReturnType<typeof useGetModuleSubmissionsSuspenseQuery>;
export type GetModuleSubmissionsQueryResult = Apollo.QueryResult<GetModuleSubmissionsQuery, GetModuleSubmissionsQueryVariables>;
export const GetModulesByCampusDocument = gql`
    query GetModulesByCampus($campusName: String!) {
  getModulesByCampus(campusName: $campusName) {
    moduleID
    name
    description
    enabled_dates
  }
}
    `;

/**
 * __useGetModulesByCampusQuery__
 *
 * To run a query within a React component, call `useGetModulesByCampusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModulesByCampusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModulesByCampusQuery({
 *   variables: {
 *      campusName: // value for 'campusName'
 *   },
 * });
 */
export function useGetModulesByCampusQuery(baseOptions: Apollo.QueryHookOptions<GetModulesByCampusQuery, GetModulesByCampusQueryVariables> & ({ variables: GetModulesByCampusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModulesByCampusQuery, GetModulesByCampusQueryVariables>(GetModulesByCampusDocument, options);
      }
export function useGetModulesByCampusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModulesByCampusQuery, GetModulesByCampusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModulesByCampusQuery, GetModulesByCampusQueryVariables>(GetModulesByCampusDocument, options);
        }
export function useGetModulesByCampusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModulesByCampusQuery, GetModulesByCampusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModulesByCampusQuery, GetModulesByCampusQueryVariables>(GetModulesByCampusDocument, options);
        }
export type GetModulesByCampusQueryHookResult = ReturnType<typeof useGetModulesByCampusQuery>;
export type GetModulesByCampusLazyQueryHookResult = ReturnType<typeof useGetModulesByCampusLazyQuery>;
export type GetModulesByCampusSuspenseQueryHookResult = ReturnType<typeof useGetModulesByCampusSuspenseQuery>;
export type GetModulesByCampusQueryResult = Apollo.QueryResult<GetModulesByCampusQuery, GetModulesByCampusQueryVariables>;
export const GetModuleByIdDocument = gql`
    query GetModuleById($id: String!) {
  getModuleById(id: $id) {
    _id
    name
    short_description
    domain
    start_date
    end_date
    daywise_plan {
      day_id
      name
      day_description
      questions
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetModuleByIdQuery__
 *
 * To run a query within a React component, call `useGetModuleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetModuleByIdQuery(baseOptions: Apollo.QueryHookOptions<GetModuleByIdQuery, GetModuleByIdQueryVariables> & ({ variables: GetModuleByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModuleByIdQuery, GetModuleByIdQueryVariables>(GetModuleByIdDocument, options);
      }
export function useGetModuleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModuleByIdQuery, GetModuleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModuleByIdQuery, GetModuleByIdQueryVariables>(GetModuleByIdDocument, options);
        }
export function useGetModuleByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModuleByIdQuery, GetModuleByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModuleByIdQuery, GetModuleByIdQueryVariables>(GetModuleByIdDocument, options);
        }
export type GetModuleByIdQueryHookResult = ReturnType<typeof useGetModuleByIdQuery>;
export type GetModuleByIdLazyQueryHookResult = ReturnType<typeof useGetModuleByIdLazyQuery>;
export type GetModuleByIdSuspenseQueryHookResult = ReturnType<typeof useGetModuleByIdSuspenseQuery>;
export type GetModuleByIdQueryResult = Apollo.QueryResult<GetModuleByIdQuery, GetModuleByIdQueryVariables>;
export const GetAllCronJobsDocument = gql`
    query GetAllCronJobs($input: GetAllJobsInput!) {
  getAllCronJobs(input: $input) {
    data {
      id
      job_id
      emailId
      campusName
      status
      createdAt
    }
    total
  }
}
    `;

/**
 * __useGetAllCronJobsQuery__
 *
 * To run a query within a React component, call `useGetAllCronJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCronJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCronJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllCronJobsQuery(baseOptions: Apollo.QueryHookOptions<GetAllCronJobsQuery, GetAllCronJobsQueryVariables> & ({ variables: GetAllCronJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCronJobsQuery, GetAllCronJobsQueryVariables>(GetAllCronJobsDocument, options);
      }
export function useGetAllCronJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCronJobsQuery, GetAllCronJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCronJobsQuery, GetAllCronJobsQueryVariables>(GetAllCronJobsDocument, options);
        }
export function useGetAllCronJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCronJobsQuery, GetAllCronJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCronJobsQuery, GetAllCronJobsQueryVariables>(GetAllCronJobsDocument, options);
        }
export type GetAllCronJobsQueryHookResult = ReturnType<typeof useGetAllCronJobsQuery>;
export type GetAllCronJobsLazyQueryHookResult = ReturnType<typeof useGetAllCronJobsLazyQuery>;
export type GetAllCronJobsSuspenseQueryHookResult = ReturnType<typeof useGetAllCronJobsSuspenseQuery>;
export type GetAllCronJobsQueryResult = Apollo.QueryResult<GetAllCronJobsQuery, GetAllCronJobsQueryVariables>;
export const GetAllReportMessagesDocument = gql`
    query GetAllReportMessages($campusName: String) {
  getReportMessages(campusName: $campusName) {
    id
    ranges {
      rangeLabel
      entries {
        campusName
        message
        greeting
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAllReportMessagesQuery__
 *
 * To run a query within a React component, call `useGetAllReportMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllReportMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllReportMessagesQuery({
 *   variables: {
 *      campusName: // value for 'campusName'
 *   },
 * });
 */
export function useGetAllReportMessagesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllReportMessagesQuery, GetAllReportMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllReportMessagesQuery, GetAllReportMessagesQueryVariables>(GetAllReportMessagesDocument, options);
      }
export function useGetAllReportMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllReportMessagesQuery, GetAllReportMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllReportMessagesQuery, GetAllReportMessagesQueryVariables>(GetAllReportMessagesDocument, options);
        }
export function useGetAllReportMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllReportMessagesQuery, GetAllReportMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllReportMessagesQuery, GetAllReportMessagesQueryVariables>(GetAllReportMessagesDocument, options);
        }
export type GetAllReportMessagesQueryHookResult = ReturnType<typeof useGetAllReportMessagesQuery>;
export type GetAllReportMessagesLazyQueryHookResult = ReturnType<typeof useGetAllReportMessagesLazyQuery>;
export type GetAllReportMessagesSuspenseQueryHookResult = ReturnType<typeof useGetAllReportMessagesSuspenseQuery>;
export type GetAllReportMessagesQueryResult = Apollo.QueryResult<GetAllReportMessagesQuery, GetAllReportMessagesQueryVariables>;
export const GetMessageByScoreDocument = gql`
    query GetMessageByScore($scorePercent: Int!, $campusName: String) {
  getReportMessageByScore(scorePercent: $scorePercent, campusName: $campusName) {
    campusName
    message
    greeting
  }
}
    `;

/**
 * __useGetMessageByScoreQuery__
 *
 * To run a query within a React component, call `useGetMessageByScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageByScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageByScoreQuery({
 *   variables: {
 *      scorePercent: // value for 'scorePercent'
 *      campusName: // value for 'campusName'
 *   },
 * });
 */
export function useGetMessageByScoreQuery(baseOptions: Apollo.QueryHookOptions<GetMessageByScoreQuery, GetMessageByScoreQueryVariables> & ({ variables: GetMessageByScoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageByScoreQuery, GetMessageByScoreQueryVariables>(GetMessageByScoreDocument, options);
      }
export function useGetMessageByScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageByScoreQuery, GetMessageByScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageByScoreQuery, GetMessageByScoreQueryVariables>(GetMessageByScoreDocument, options);
        }
export function useGetMessageByScoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessageByScoreQuery, GetMessageByScoreQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessageByScoreQuery, GetMessageByScoreQueryVariables>(GetMessageByScoreDocument, options);
        }
export type GetMessageByScoreQueryHookResult = ReturnType<typeof useGetMessageByScoreQuery>;
export type GetMessageByScoreLazyQueryHookResult = ReturnType<typeof useGetMessageByScoreLazyQuery>;
export type GetMessageByScoreSuspenseQueryHookResult = ReturnType<typeof useGetMessageByScoreSuspenseQuery>;
export type GetMessageByScoreQueryResult = Apollo.QueryResult<GetMessageByScoreQuery, GetMessageByScoreQueryVariables>;
export const GetMessagesByRangeDocument = gql`
    query GetMessagesByRange($rangeLabel: String!, $campusName: String) {
  getMessagesByRangeLevel(rangeLabel: $rangeLabel, campusName: $campusName) {
    campusName
    message
    greeting
  }
}
    `;

/**
 * __useGetMessagesByRangeQuery__
 *
 * To run a query within a React component, call `useGetMessagesByRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesByRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesByRangeQuery({
 *   variables: {
 *      rangeLabel: // value for 'rangeLabel'
 *      campusName: // value for 'campusName'
 *   },
 * });
 */
export function useGetMessagesByRangeQuery(baseOptions: Apollo.QueryHookOptions<GetMessagesByRangeQuery, GetMessagesByRangeQueryVariables> & ({ variables: GetMessagesByRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessagesByRangeQuery, GetMessagesByRangeQueryVariables>(GetMessagesByRangeDocument, options);
      }
export function useGetMessagesByRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagesByRangeQuery, GetMessagesByRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessagesByRangeQuery, GetMessagesByRangeQueryVariables>(GetMessagesByRangeDocument, options);
        }
export function useGetMessagesByRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessagesByRangeQuery, GetMessagesByRangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessagesByRangeQuery, GetMessagesByRangeQueryVariables>(GetMessagesByRangeDocument, options);
        }
export type GetMessagesByRangeQueryHookResult = ReturnType<typeof useGetMessagesByRangeQuery>;
export type GetMessagesByRangeLazyQueryHookResult = ReturnType<typeof useGetMessagesByRangeLazyQuery>;
export type GetMessagesByRangeSuspenseQueryHookResult = ReturnType<typeof useGetMessagesByRangeSuspenseQuery>;
export type GetMessagesByRangeQueryResult = Apollo.QueryResult<GetMessagesByRangeQuery, GetMessagesByRangeQueryVariables>;
export const GetClusterStudentsDocument = gql`
    query GetClusterStudents($clusterId: String!) {
  getClusterStudents(clusterId: $clusterId) {
    id
    name
    email
    rollNo
    leetCodeUname
  }
}
    `;

/**
 * __useGetClusterStudentsQuery__
 *
 * To run a query within a React component, call `useGetClusterStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClusterStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClusterStudentsQuery({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useGetClusterStudentsQuery(baseOptions: Apollo.QueryHookOptions<GetClusterStudentsQuery, GetClusterStudentsQueryVariables> & ({ variables: GetClusterStudentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClusterStudentsQuery, GetClusterStudentsQueryVariables>(GetClusterStudentsDocument, options);
      }
export function useGetClusterStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClusterStudentsQuery, GetClusterStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClusterStudentsQuery, GetClusterStudentsQueryVariables>(GetClusterStudentsDocument, options);
        }
export function useGetClusterStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClusterStudentsQuery, GetClusterStudentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClusterStudentsQuery, GetClusterStudentsQueryVariables>(GetClusterStudentsDocument, options);
        }
export type GetClusterStudentsQueryHookResult = ReturnType<typeof useGetClusterStudentsQuery>;
export type GetClusterStudentsLazyQueryHookResult = ReturnType<typeof useGetClusterStudentsLazyQuery>;
export type GetClusterStudentsSuspenseQueryHookResult = ReturnType<typeof useGetClusterStudentsSuspenseQuery>;
export type GetClusterStudentsQueryResult = Apollo.QueryResult<GetClusterStudentsQuery, GetClusterStudentsQueryVariables>;
export const GetLeetcodeBulkDocument = gql`
    query GetLeetcodeBulk($usernames: [String!]!) {
  leetcodeBulk(usernames: $usernames) {
    username
    name
    ranking
    totalSolved
    easySolved
    mediumSolved
    hardSolved
    profileUrl
  }
}
    `;

/**
 * __useGetLeetcodeBulkQuery__
 *
 * To run a query within a React component, call `useGetLeetcodeBulkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeetcodeBulkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeetcodeBulkQuery({
 *   variables: {
 *      usernames: // value for 'usernames'
 *   },
 * });
 */
export function useGetLeetcodeBulkQuery(baseOptions: Apollo.QueryHookOptions<GetLeetcodeBulkQuery, GetLeetcodeBulkQueryVariables> & ({ variables: GetLeetcodeBulkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeetcodeBulkQuery, GetLeetcodeBulkQueryVariables>(GetLeetcodeBulkDocument, options);
      }
export function useGetLeetcodeBulkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeetcodeBulkQuery, GetLeetcodeBulkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeetcodeBulkQuery, GetLeetcodeBulkQueryVariables>(GetLeetcodeBulkDocument, options);
        }
export function useGetLeetcodeBulkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeetcodeBulkQuery, GetLeetcodeBulkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeetcodeBulkQuery, GetLeetcodeBulkQueryVariables>(GetLeetcodeBulkDocument, options);
        }
export type GetLeetcodeBulkQueryHookResult = ReturnType<typeof useGetLeetcodeBulkQuery>;
export type GetLeetcodeBulkLazyQueryHookResult = ReturnType<typeof useGetLeetcodeBulkLazyQuery>;
export type GetLeetcodeBulkSuspenseQueryHookResult = ReturnType<typeof useGetLeetcodeBulkSuspenseQuery>;
export type GetLeetcodeBulkQueryResult = Apollo.QueryResult<GetLeetcodeBulkQuery, GetLeetcodeBulkQueryVariables>;
export const GetOtherAssignmentDocument = gql`
    query getOtherAssignment {
  getOtherAssignment {
    id
    name
  }
}
    `;

/**
 * __useGetOtherAssignmentQuery__
 *
 * To run a query within a React component, call `useGetOtherAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtherAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtherAssignmentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOtherAssignmentQuery(baseOptions?: Apollo.QueryHookOptions<GetOtherAssignmentQuery, GetOtherAssignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOtherAssignmentQuery, GetOtherAssignmentQueryVariables>(GetOtherAssignmentDocument, options);
      }
export function useGetOtherAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOtherAssignmentQuery, GetOtherAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOtherAssignmentQuery, GetOtherAssignmentQueryVariables>(GetOtherAssignmentDocument, options);
        }
export function useGetOtherAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOtherAssignmentQuery, GetOtherAssignmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOtherAssignmentQuery, GetOtherAssignmentQueryVariables>(GetOtherAssignmentDocument, options);
        }
export type GetOtherAssignmentQueryHookResult = ReturnType<typeof useGetOtherAssignmentQuery>;
export type GetOtherAssignmentLazyQueryHookResult = ReturnType<typeof useGetOtherAssignmentLazyQuery>;
export type GetOtherAssignmentSuspenseQueryHookResult = ReturnType<typeof useGetOtherAssignmentSuspenseQuery>;
export type GetOtherAssignmentQueryResult = Apollo.QueryResult<GetOtherAssignmentQuery, GetOtherAssignmentQueryVariables>;